// 2026-01-22 10:09:15 +0700

export default {
  banner: {
    header1: 'ទទួលបានសម្រង់, ប្រៀបធៀប, ទិញ\nងាយស្រួល & ឆាប់រហ័សជាមួយ MGA Cover',
    header2: 'ទទួលបានសម្រង់តម្លៃធានារ៉ាប់រងរថយន្តដោយឥតគិតថ្លៃ',
    subHeader: 'ទទួលបានសម្រង់តម្លៃភ្លាមៗពីក្រុមហ៊ុនធានារ៉ាប់រងរថយន្តដៃគូកំពូលរបស់យើង ហើយប្រៀបធៀបឥឡូវនេះ។',
    cta: 'ទទួលសម្រង់តម្លៃ',
  },
  mga: {
    address: 'អគារលេខ ៤៦៦ វិថីម៉ៅសេទុង (២៤៥) កាច់ជ្រុង ផ្លូវ ១៥០ ភ្នំពេញ កម្ពុជា',
  },
  supportCard: {
    header: 'ត្រូវការជំនួយ? ទាក់ទងយើងខ្ញុំឥឡូវនេះ',
    subHeader: 'អ្នកជំនាញរបស់យើងចាំជួយលោកអ្នកជានិច្ច!',
  },
  faq: {
    header: 'សំណួរដែលគេសួរញឹកញាប់',
    q1: 'តើ MGA Cover ធ្វើការងារអ្វី?',
    a1: 'MGA Cover គឺជាក្រុមហ៊ុន Insurtech ដែលធ្វើទំនើបកម្មដំណើរប្រពន្ធ័ឌីជីថល ផលិតផលធានារ៉ាប់រងពីក្រុមហ៊ុនធានារ៉ាប់រងដែលគួរឱ្យទុកចិត្តបំផុតនៅក្នុងព្រះរាជាណាចក្រកម្ពុជា។\n\nអ្នកប្រើប្រាស់អាចមើលតម្លៃ ប្រៀបធៀបតម្លៃ ពត័មានលម្អិត និងគោលការណ៍លក្ខ័ណ្ឌសំខាន់ៗ នៃប័ណ្ណសន្យារ៉ាប់រងរបស់ក្រុមហ៊ុនធានារ៉ាប់រងនិមួយៗ ដោយរហ័សទាន់ចិត្ត ត្រឹមតែ១នាទីប៉ុណ្ណោះ។ អ្នកប្រើប្រាស់អាចទិញប័ណ្ណសន្យារ៉ាប់រង និងបង់ប្រាក់តាមប្រពន្ធ័អនឡាញដោយសុវត្ថិភាព ហើយទទួលការការពារភ្លាមៗ។ លើសពីនេះទៅទៀត អ្នកប្រើប្រាស់ក៏អាចស្នើរសុំសំណង និងបន្តប័ណ្ណសន្យាបរ៉ាប់រង បានយ៉ាងងាយស្រួលនៅលើថ្នាលបច្ចេកវិទ្យាផងដែរ។',
    q2: 'តើអ្វីទៅជាធានារ៉ាប់រងរថយន្ត?',
    a2: 'ការធានារ៉ាប់រងរថយន្តគឺត្រូវបានគេស្គាល់ថាជាការធានារ៉ាប់រងយានយន្ត។ ការធានារ៉ាប់រងលើរថយន្តផ្តល់ការការពារផ្នែកហិរញ្ញវត្ថុ ដល់រថយន្តរបស់អ្នក ពីហានិភ័យដែលមិននឹកស្មានដល់ ឬដោយចៃដន្យ។ ជាថ្នូរនឹងការបង់បុព្វលាភរ៉ាប់រងរបស់អ្នក ក្រុមហ៊ុនធានារ៉ាប់រងយល់ព្រមបង់ការខាតបង់របស់អ្នក ដូចដែលបានរៀបរាប់នៅក្នុងគោលការណ៍របស់អ្នក។',
    q3: 'តើអ្វីទៅជាបណ្ណសន្យាធានារ៉ាប់រងរថយន្ត?',
    a3: 'បណ្ណសន្យាធានារ៉ាប់រងរថយន្ត គឺជាកិច្ចសន្យារវាងអ្នក នឹងក្រុមហ៊ុនធានារ៉ាប់រង ដែលអ្នកយល់ព្រមបង់បុព្វលាភរ៉ាប់រងជាថ្នូរនឹងការការពារចំពោះការខាតបង់ហិរញ្ញវត្ថុ ដែលកើតឡើងពីគ្រោះថ្នាក់ ឬការខូចខាតផ្សេងៗចំពោះរថយន្ត។ បណ្ណសន្យាធានារ៉ាបរងនីមួយៗ គឺផ្អែកលើដែនកំណត់ ឬចំនួនអតិបរមា ដែលក្រុមហ៊ុនធានារ៉ាប់រងនិងបង់លើការទាមទារសំណង។',
    q4: 'តើធានារ៉ាប់រងរថយន្តមានប្រភេទអ្វីខ្លះ?',
    a4: 'ធានារ៉ាប់រងរថយន្តមាន២ប្រភេទ៖\n\n1) ទំនួលខុសត្រូវលើតតិយជន\nធានារ៉ាប់រងរថយន្តទំនួលខុសត្រូវលើតតិយជន ត្រូវបានគេស្គាល់ផងដែរថាជា ការធានារ៉ាប់រងការទទួលខុសត្រូវ ធានាលើការខូចខាតដែលកើតឡើងចំពោះបុគ្គលតតិយជន ឬទ្រព្យសម្បត្តិ។ វាមិនផ្តល់ការធានាររ៉ាប់រងសំរាប់អ្នក នឹងរថយន្តរបស់អ្នកទេ។\n\n2) ធានារ៉ាប់រងទូលំទូលាយ ឬស្តង់ដា\nការធានារ៉ាប់រងរថយន្តទូលំទូលាយ ឬស្តង់ដា ធានារ៉ាប់រងលើការបាត់បង់ ឬការខូចខាតរថយន្តផ្ទាល់ខ្លួនរបស់អ្នក ឬការខូចខាតដល់យានយន្ត ឬទ្រព្យសម្បត្តិរបស់អ្នកដទៃ ឬការរងរបួសដល់តតិយជន (ភាគីទីបី)។',
    q5: 'តើបណ្ណសន្យាធានារ៉ាប់រងរថយន្តធានាលើអ្វីខ្លះ?',
    a5: 'ទំនួលខុសត្រូវលើតតិយជន ធានារ៉ាប់រងលើ៖\n- មរណភាព ឬរបួសរាងកាយចំពោះបុគ្គលណាមួយ\n- ការខូចខាតចំពោះទ្រព្យសម្បត្តិរបស់តតិយជន (ភាគីទីបី)\n- សេវាផ្នែកច្បាប់\n\nធានារ៉ាប់រងទូលំទូលាយ ឬស្តង់ដា ធានារ៉ាប់រងលើ៖\n- ទំនួលខុសត្រូវលើតតិយជន\n- ការខូចខាតផ្ទាល់ខ្លួន - ការធ្វើសំណងសម្រាប់ការខូចខាតរថយន្តផ្ទាល់ខ្លួនរបស់អ្នក ដោយសារគ្រោះថ្នាក់\n- ចោរកម្ម - ការធ្វើសំណងសម្រាប់ការបាត់បង់រថយន្តផ្ទាល់ខ្លួនរបស់អ្នក ដោយសារចោរកម្ម\n',
    q6: 'តើអ្វីជាធានារ៉ាប់រងរថយន្តបន្ថែម?',
    a6: 'គឺជាការធានាពង្រីកបន្ថែម ឬអត្ថប្រយោជន៍បន្ថែម លើការធានារ៉ាបរងមូលដ្ឋាន។\n\n- គ្រោះថ្នាក់ដល់អ្នកមានសិទ្ធិបើកបរ\nការធានារ៉ាប់រងបន្ថែមនេះផ្តល់ការធ្វើសំណងសំរាប់ មរណៈភាព ឬពិការភាពជាអចិន្ត្រៃយ៍ ឬការរងរបួស ដល់បុគ្គលដែលបើកបរយានយន្តក្នុងអំឡុងពេលកើតហេតុ ចំពោះការទាមទារសំណងណាមួយកើតឡើងពីហេតុការណ៍។ អ្នកមានសិទ្ធិបើកបរ សំដៅលើបុគ្គលណាដែលបើករថយន្តរបស់អ្នកតាមការបញ្ជារ ឬការអនុញ្ញាតរបស់អ្នក ប៉ុន្តែលុះត្រាតែបុគ្គលនោះមានប័ណ្ណបើកបរដែលមានសុពលភាពនៅក្នុងប្រទេសកម្ពុជា ហើយនិងមិនស្ថិតក្រោមការត្រួតពិនិត្យ ឬការដកសិទ្ធិក្នុងការបើកបរ។\n\n- ទំនួលខុសត្រូវចំពោះអ្នកដំណើរ\nការធានារ៉ាប់រងបន្ថែមនេះផ្តល់ការធ្វើសំណងសម្រាប់មរណៈភាព ឬការរងរបួស ដល់បុគ្គលណា ដែលត្រូវបានដឹកចូល ឬចូល ឬឡើងជិះ ឬចុះពីយានយន្តនៅក្នុងអំឡុងពេលកើតហេតុ ចំពោះការទាមទារសំណងណាមួយកើតឡើងពីហេតុការណ៍។\n',
    q7: 'ហេតុអ្វីខ្ញុំគួរតែទិញធានារ៉ាប់រងរថយន្ត?',
    a7: 'ទោះបីជាវាមិនមែនជាកាតព្វកិច្ចនៅក្នុងព្រះរាជាណាចក្រកម្ពុជានៅឡើយក៏ដោយ យ៉ាងហោចណាស់អ្នកគួរតែមានការធានារ៉ាប់រងលើរថយន្ត ទំនួលខុសត្រូវលើតតិយជន នៅពេលដែលអ្នកមានរថយន្តផ្ទាល់ខ្លួន។\n\nបណ្ណសន្យានារ៉ាប់រងរថយន្តផ្តល់អោយអ្នកនូវទំនួលខុសត្រូវហិរញ្ញវត្ថុ ដែលអាចកើតឡើងចំពោះតតិយជន ឬការបាត់បង់ ឬការខូចខាតផ្ទាល់ខ្លួនចំពោះរថយន្តរបស់អ្នក ដោយសារគ្រោះថ្នាក់ចរាចរណ៍ ឬព្រឹត្តិការណ៍អកុសលផ្សេងទៀត។',
    q8: 'តើហេតុអ្វីខ្ញុំគួរតែទិញធានារ៉ាប់រងរថយន្តលើប្រពន្ធ័អុីនធឺណិត?',
    a8: 'ដូចជាការទិញតាមអុីនធឺណិតទូទៅដែរ  ការទិញបណ្ណសន្យាធានារ៉ាប់រងរថយន្តតាមអ៊ីនធឺណិត ក៏បានក្លាយជាការអនុវត្តធម្មតានាពេលបច្ចុប្បន្ននេះ។ អ្នកអាចទទួលបានធានារ៉ាប់រងរថយន្តរបស់អ្នក ចំពោះការខូចខាត និងការបាត់បង់ផ្នែកហិរញ្ញវត្ថុ ដែលបង្កឡើងដោយគ្រោះថ្នាក់ អគ្គីភ័យ ចោរកម្ម ជាដើម ក្នុងរយៈពេលតិចជាង 5 នាទី។ សូមពិនិត្យមើលអត្ថប្រយោជន៍ខាងក្រោមដែលមកជាមួយការទិញធានារ៉ាប់រងតាមអុីនធឺណិត។\n\n- ងាយស្រួល និងពេលវេលាមានប្រសិទ្ធភាព\n- មានតម្លាភាព \n- ចំណាយមានប្រសិទ្ធភាព\n- បង់បុព្វលាភតាមអុីនធឺណិត',
    q9: 'តើខ្ញុំទិញបណ្ណសន្យាធានារ៉ាប់រងរថយន្តដោយរបៀបណា?',
    a9: 'យើងធ្វើឱ្យការធានារ៉ាប់រងរថយន្តមានលក្ខណៈសាមញ្ញ និងងាយស្រួលសម្រាប់អ្នក។ អ្នកអាចទិញបណ្ណសន្យាធានារ៉ាប់រងរថយន្តរបស់អ្នក ដោយចុចពីរបីដង លើគេហទំព័ររបស់យើង mgacover.com ហើយធ្វើតាមជំហានដែលបានរៀបរាប់ខាងក្រោម៖\n\n1. ឆ្លើយសំណួរសាមញ្ញមួយចំនួនអំពីរថយន្តរបស់អ្នក ដូចជាម៉ាករថយន្ត ម៉ូដែល លេខម៉ាស៊ីន និងឆ្នាំ បន្ទាប់មក អ្នកទទួលបានសម្រង់ការធានារ៉ាប់រងរថយន្ត។\n\n2. មើលសម្រង់តម្លៃ នឹងប្រៀបធៀបសម្រង់តម្លៃ ដោយមានពត័មានលម្អិត\n\n3.  ជ្រើសរើសគំរោងអ្នកពេញចិត្ត\n\n4. បង្កើតគណនីជាមួយយើង ហើយបន្ទាប់មក បង់បុព្វលាភតាមអុីនធឺណិតដោយសុវត្ថិភាព\n\nនៅពេលដែលការទូទាត់ត្រូវបានធ្វើឡើង អ្នកនឹងទទួលបានការជូនដំណឹងតាមអ៊ីមែល និងគណនីដើម្បីចូលទៅកាន់ផ្ទាំងគ្រប់គ្រងអតិថិជន។ អ្នកអាចមើលប្រតិបត្តិការទូទាត់ប្រាក់ និងព័ត៌មានលម្អិតអំពីបណ្ណសន្យាធានារ៉ាប់រងរថយន្តរបស់អ្នក និងទាញយកឯកសារជា PDF ។',
    q10: 'តើវាចំណាយពេលប៉ុន្មានដើម្បីទិញធានារ៉ាប់រងជាមួយ MGA Cover?',
    a10: 'វាគឺរហ័សក្នុងរយៈពេលតិចជាង 5 នាទីដើម្បីទិញណ្ណសន្យាធានារ៉ាប់រងរថយន្តរបស់អ្នកនៅលើ MGA Cover ។ ក្នុង​ករណី​ដែល​អ្នក​ត្រូវ​ការ​ជំនួយ ក្រុម​ជំនួយ​របស់​យើង​តែង​តែ​អាច​រក​បាន​នៅ​ពេល​ហៅ​ទូរសព្ទ ឬ​ជជែក​ដើម្បី​ជួយ​អ្នក។',
    q11: 'តើខ្ញុំត្រូវបានការការពារភ្លាមៗក្រោយពីទិញបណ្ណសន្យាធានារ៉ាប់រងរថយន្តដោយជោគជ័យ?',
    a11: 'ពិតណាស់! អ្នកត្រូវបានការពារភ្លាមៗក្រោយពីទិញបានជោគជ័យ។',
    q12: 'តើលក្ខណៈវិនិច្ឆ័យអ្វីខ្លះដែលក្រុមហ៊ុនធានារ៉ាប់រងពិចារណាទទួល ឬបដិសេធ ពាក្យស្នើរសុំធានារ៉ាប់រងរថយន្ត?',
    a12: 'ក្រុមហ៊ុនធានារ៉ាប់រងភាគច្រើនស្នើរឱ្យអ្នកផ្តល់ព័ត៌មានពាក់ព័ន្ធផ្សេងៗអំពីរថយន្តឯកជនរបស់អ្នកដូចជា ម៉ាក ម៉ូដែល ម៉ូដែលរង IDV (ដែលគេស្គាល់ថាជាតម្លៃទីផ្សារប្រហាក់ប្រហែល) កំលាំងម៉ាស៊ីន ជាដើម ព័ត៌មានលម្អិតផ្ទាល់ខ្លួនរបស់អ្នក និងពត័មានផ្សេងទៀត ដើម្បីឱ្យពួកគេអាចពិចារណាទទួលយក ឬបដិសេធពាក្យសុំរបស់អ្នក។',
    q13: 'តើត្រូវធ្វើដូចម្តេចដើម្បីទាមទារសំណងតាមអុីនធឺណិត?',
    a13: 'អ្នកអាចដាក់ពាក្យទាមទារសំណងតាមអ៊ីនធឺណិតនៅក្នុងផ្ទាំងគ្រប់គ្រងអ្នកប្រើប្រាស់ របស់ MGA Cover ដោយជំហានងាយៗខាងក្រោម៖\n\n1. ចូលគណនីរបស់អ្នកនៅលើគេហទំព័រ MGA Cover\n2. នៅក្នុងផ្ទាំងគ្រប់គ្រងអ្នកប្រើប្រាស់របស់អ្នក មើលគោលការណ៍របស់អ្នកទាំងអស់។\n3. ចុចលើប៊ូតុង ទាមទារលើគោលការណ៍ដែលអ្នកចង់ដាក់ពាក្យទាមទារសំណង\n4. បំពេញព័ត៌មានលម្អិតដែលត្រូវការ ហើយបន្ទាប់មកបញ្ជូនការទាមទាររបស់អ្នក។\n5. អ្នកអាចតាមដានស្ថានភាពការទាមទាររបស់អ្នកដែលអ្នកបានដាក់ស្នើដោយមើលព័ត៌មានលម្អិតនៅក្នុងម៉ឺនុយទាមទារសំណង។\n',
    q14: 'តើខ្ញុំអាចប្រៀបធៀបសម្រង់តម្លៃក្នុងចំណោមក្រុមហ៊ុនធានារ៉ាប់រងផ្សេងៗបានដែរឬទេ?',
    a14: 'ពិតប្រាកដណាស់។ ថ្នាលបច្ចេកវិទ្យា MGA Cover អនុញ្ញាតឱ្យអ្នកប្រៀបធៀប បុព្វលាភធានារ៉ាប់រង ការធានារ៉ាប់រង និងព័ត៌មានលម្អិតផ្សេងទៀតនៃសម្រង់តំលៃច្រើនបំផុត ចំនួន៣ ពីក្រុមហ៊ុនធានារ៉ាប់រងទាំងឡាយ ក្នុងមួយការប្រៀបធៀប។ ដូច្នេះហើយ វាគឺងាយស្រួលសម្រាប់អ្នកសំរេចចិត្តលើ ផែនការ និងថវិកាត្រឹមត្រូវ។',
  },
  testimonial: {
    header: 'សម្តីរបស់អតិថិជនយើង',
  },
  partner: {
    header: 'ក្រុមហ៊ុនធានារ៉ាប់រងដៃគូពេញនិយមរបស់យើង',
  },
  howItWorks: {
    header: 'តើ MGA Cover ដំណើរការយ៉ាងដូចម្តេច?',
    title1: 'បំពេញព័ត៌មានលម្អិតរបស់អ្នក',
    desc1: 'បំពេញព័ត៌មានលម្អិតរបស់អ្នក នឹងទទួលបានសម្រង់បុព្វលាភធានារ៉ាប់រង ពីក្រុមហ៊ុនធានារ៉ាប់រងដៃគូដែលគួរឱ្យទុកចិត្តរបស់យើងភ្លាមៗ។',
    title2: 'ប្រៀបធៀបសម្រង់តម្លៃ នឹងជ្រើសរើសគំរោងដែលអ្នកពេញចិត្ត',
    desc2: 'សូមជ្រើសរើសសម្រង់តម្លៃមួយណាដែលសាកសមបំផុតនិងតម្រូវការ និងថវិការបស់អ្នក។',
    title3: 'បង់ប្រាក់ នឹងទទួលបានការការពារ',
    desc3: 'បង់ប្រាក់តាមអ៊ុីនធឺណិតតាមរយៈវិធីបង់ប្រាក់ដែលមានសុវត្ថិភាពរបស់យើង ហើយទទួលបានការការពារភ្លាមៗ។',
  },
  benefit: {
    header: 'ហេតុអ្វីជ្រើសរើស MGA Cover?',
    title1: 'សម្រង់តម្លៃ និងការការពារភ្លាមៗ',
    desc1: 'រហ័ស ងាយស្រួល និង 100% លើប្រពន្ធ័ឌីជីថល។ មើលសម្រង់តម្លៃភ្លាមៗ របស់ក្រុមហ៊ុនធានារ៉ាប់រងទាំងឡាយ ក្នុងរយៈពេលតិចជាង 2 នាទីប៉ុណ្ណោះ។ ទទួលការការពារភ្លាមៗក្នុងរយៈពេលតិចជាង 5 នាទីប៉ុណ្ណោះ។',
    title2: 'បុព្វលាភសមរម្យ',
    desc2: 'ការទិញធានារ៉ាប់រងមិនគួរជាបន្ទុកហិរញ្ញវត្ថុសំរាប់អ្នកទេ។ យើងផ្តល់ជូននូវគំរោង ធានារ៉ាប់រងដែលសមស្រប និងថវិការរបស់អ្នក។',
    title3: 'ដំណើរការទាមទារសំណងដោយរលូន',
    desc3: 'គោលបំណងបស់យើង គឺធ្វើឱ្យការទាមទារសំណងធានារ៉ាប់រងកាន់តែងាយស្រួល។ អ្វីដែលអ្នកត្រូវធ្វើ គឺដាក់ការទាមទារសំណងរបស់អ្នកតាមអ៊ុីនធឺណិត និងទទួលបទពិសោធន៍ទូទាត់សំណង ដោយមិនប្រើសាច់ប្រាក់ រហ័ស និងងាយស្រួល។ យើងនឹងនៅជាមួយអ្នកគ្រប់ជំហាននៃដំណើរការទាមទារសំណង។',
  },
  registration: {
    title: 'ចូលទៅគណនី MGA Cover របស់អ្នក។',
    desc: 'ដើម្បីចូល សូមបញ្ចូលលេខទូរស័ព្ទរបស់អ្នក។',
    mobileNumberLabel: 'បញ្ចូលលេខទូរស័ព្ទ',
    ctaOtp: 'ចូលដោយប្រើលេខកូដ OTP',
    ctaPassword: 'ចូលដោយប្រើពាក្យសម្ងាត់',
    ctaMemberId: 'ចូលប្រើដោយប្រើលេខសម្គាល់សមាជិក',
    ctaCamDx: 'ចូលដោយប្រើ Camdigikey',
    otpCode: {
      title: 'ចូលទៅគណនី MGA Cover របស់អ្នក។',
      desc: 'បញ្ចូលលេខកូដដែលយើងផ្ញើទៅលេខទូរស័ព្ទ',
    },
    password: {
      title: 'ចូលទៅគណនី MGA Cover របស់អ្នក។',
      desc: 'បញ្ចូលពាក្យសម្ងាត់សម្រាប់លេខទូរស័ព្ទ',
    },
    continueWith: 'ឬក៏បន្តជាមួយ',
  },
  paymentMethod: {
    paywayTitle: 'ABA Payway',
    paywayShortDesc: 'បង់ប្រាក់តាមរយៈការស្កេន QR Code ឬកាតឥណទាន/ឥណពន្ធ',
    acledaTitle: 'ធនាគារអេស៊ីលីដា ភីអិលស៊ី',
    acledaShortDesc: 'ទូទាត់ដោយសុវត្ថិភាពជាមួយធនាគារអេស៊ីលីដា ភីអិលស៊ី',
  },
  carInsuranceQuote: {
    carBrand: {
      title: 'តើរថយន្តរបស់អ្នកម៉ាកអ្វី?',
    },
    carModel: {
      title: 'តើឡាន {{carBrandName}} មួយណា?',
    },
    carSubModel: {
      title: 'តើ {{carModelName}} ប្រភេទណាដែលអ្នកបើក?',
    },
    carManufacturedYear: {
      title: 'តើឆ្នាំផលិតឆ្នាំណា?',
    },
    thirdPartyPlanDeductible: {
      desc: 'រៀងរាល់ការទាមទារសំណងដែលត្រូវអនុវត្តចំពោះការខូចខាតទ្រព្យសម្បត្តិរបស់តតិយជន',
    },
    ownDamageDeductibleDesc: 'រៀងរាល់ការទាមទារសំណងដែលត្រូវអនុវត្តចំពោះការខូចខាតផ្ទាល់ខ្លួន',
    theftDeductible: {
      desc: '5% នៃចំនួនទឹកប្រាក់ដែលបាត់បង់ គិតជាតម្លៃអប្បបរមាមានចំនួនទឹកប្រាក់',
    },
    deathBodilyInjury: 'មរណភាព / ការរងរបួស',
    propertyDamage: 'ការខូចខាត​ទ្រព្យសម្បត្តិ',
    costOfDefense: 'ការចំណាយលើការការពារក្តី',
    ownDamageTheft: 'ការខូចខាតផ្ទាល់ខ្លួន (OD) / ចោរកម្ម',
    annualAggregateLimit: 'ដែនកំណត់សរុបប្រចាំឆ្នាំ',
    learnMore: 'ស្វែងយល់បន្ថែម CLAUSES/WARRANTIES/ENDORSEMENTS',
    readDetailAttachment: 'សូមអានលម្អិតនៅក្នុងឯកសារភ្ជាប់ខាងក្រោម',
    disabledTitle: 'Quote មិនអាចប្រើបាន',
    disabledDesc: 'Quote នេះមិនមានទៀតទេ។ មាន Quote ផ្សេងទៀតជាច្រើនដែលអ្នកអាចចាប់អារម្មណ៍។',
    basicCovers: 'ធានារ៉ាប់រងមូលដ្ឋាន',
    addons: 'ការធានារ៉ាប់រងបន្ថែម',
    accidentToDriver: {
      name: 'គ្រោះថ្នាក់ដល់អ្នកមានសិទ្ធិបើកបរ',
      description: 'ការធានារ៉ាប់រងបន្ថែមនេះផ្តល់ការធ្វើសំណងសំរាប់ មរណៈភាព ឬពិការភាពជាអចិន្ត្រៃយ៍ ឬការរងរបួស ដល់បុគ្គលដែលបើកបរយានយន្តក្នុងអំឡុងពេលកើតហេតុ ចំពោះការទាមទារសំណងណាមួយកើតឡើងពីហេតុការណ៍។ អ្នកមានសិទ្ធិបើកបរ សំដៅលើបុគ្គលណាដែលបើករថយន្តរបស់អ្នកតាមការបញ្ជារ ឬការអនុញ្ញាតរបស់អ្នក ប៉ុន្តែលុះត្រាតែបុគ្គលនោះមានប័ណ្ណបើកបរដែលមានសុពលភាពនៅក្នុងប្រទេសកម្ពុជា ហើយនិងមិនស្ថិតក្រោមការត្រួតពិនិត្យ ឬការដកសិទ្ធិក្នុងការបើកបរ។',
    },
    passengerLiability: {
      name: 'ទំនួលខុសត្រូវចំពោះអ្នកដំណើរ',
      description: 'ការធានារ៉ាប់រងបន្ថែមនេះផ្តល់ការធ្វើសំណងសម្រាប់មរណៈភាព ឬការរងរបួស ដល់បុគ្គលណា ដែលត្រូវបានដឹកចូល ឬចូល ឬឡើងជិះ ឬចុះពីយានយន្តនៅក្នុងអំឡុងពេលកើតហេតុ ចំពោះការទាមទារសំណងណាមួយកើតឡើងពីហេតុការណ៍។',
    },
    flood: {
      name: 'ទឹកជំនន់',
      description: 'ការធានារ៉ាប់រងបន្ថែមនេះផ្តល់ការធ្វើសំណងសំរាប់ការខូចខាត ឬការបាត់បង់យានយន្តរបស់លោកអ្នក ដែលបង្ករឡើងដោយសារ គ្រោះធម្មជាតិទឹកជំនន់។',
    },
    srcc: {
      name: 'កូដកម្ម កុប្បកម្ម ឬការបះបោរ',
      description: 'ការធានារ៉ាប់រងបន្ថែមនេះផ្តល់ការធ្វើសំណងសំរាប់ការខូចខាត ឬការបាត់បង់យានយន្តរបស់លោកអ្នក ដែលបង្ករឡើងដោយសារ កូដកម្ម កុប្បកម្ម ឬការបះបោរ។',
    },
    discounts: {
      title: 'បញ្ចុះតម្លៃផ្សេងៗ',
      basicDiscount: 'បញ្ចុះតម្លៃជាមូលដ្ឋាន',
    },
    totalPremium: 'បុព្វលាភសរុបចុងក្រោយ',
    endorsement: 'ការកែប្រែធានារ៉ាប់រង (Endorsement)',
    endorsementDescription: 'ការកែប្រែធានារ៉ាប់រង គឺជាការធ្វើអនុប្រយោគកែប្រែ ឬបន្ថែម លើកិច្ចសន្យាធានារ៉ាប់រងបច្ចុប្បន្ន ដែលផ្លាស់ប្តូរលក្ខ័ណ្ឌ ឬដែនកំណត់ការធានារ៉ាប់រង នៃប័ណ្ណសន្យារ៉ាប់រងច្បាប់ដើម។ ការកែប្រែធានារ៉ាប់រង ដែលអនុវត្តចំពោះប័ណ្ណធានារ៉ាប់រងរបស់យោកអ្នក គឺបានដាក់បញ្ចូលក្នុង តារាងសង្ខេប ឬវិញ្ញាបនប័ត្រធានារ៉ាប់រង។',
    deductibleTitle: 'កំរិតមិនធ្វើសំណង',
    deductibleDescription: 'កំរិតមិនធ្វើសំណង សំដៅដល់ទឹកប្រាក់ដែលលោកអ្នកត្រូវតែចូលបដិភាគចំពោះរាល់បណ្តឹងទាមទារសំណងនីមួយ។',
    thirdPartyDeductible: 'ខូចខាតទ្រព្យសម្បត្តិអ្នកដទៃ: {{amount}}',
    ownDamageDeductible: 'ការខូចខាតផ្ទាល់ខ្លួន (ក៏អាចអនុវត្តបានចំពោះការបាត់បង់សរុប): {{amount}}',
    thiefDeductible: 'ការលួច៖ {{amount}} នៃការបាត់បង់',
    planDetails: 'គំរោងលម្អិត',
    coversOn: 'ការធានារ៉ាប់រងចំពោះ {{planTypeName}}',
    policyWording: 'សេចក្តីលំអិតនៃប័ណ្ណសន្យារ៉ាប់រង',
    repairAnywhere: 'សេវាជួសជុលគ្រប់ទីកន្លែងទូទាំងប្រទេសកម្ពុជា',
    freeService: 'ទទួលសេវាដោយមិនគិតថ្លៃ នៅពេលធ្វើការទាមទារជួសជុលនៅគ្រប់យានដ្ឋានជា\nដៃគូសហការរបស់ក្រុមហ៊ុនធានារ៉ាប់រង',
    cashlessGarages: 'យានដ្ឋានដៃគូរ',
    garageNearYou: 'យានដ្ឋានដែលនៅក្បែរអ្នក',
    compareTitle: 'ប្រៀបធៀបសម្រាង់តម្លៃ',
    compareDescription: 'ប្រៀបធៀបបុព្វលាភ ដែនកំណត់នៃការធានារ៉ាប់រង ករណីមិនធានារ៉ាប់រង កំរិតមិនធ្វើសំណង និងព័ត៌មានដទៃជាច្រើនទៀត',
    garagesCount: 'យានដ្ឋានចំនួន {{garagesCount}}',
    policyDetail: 'តម្លៃលំអិតគម្រោង',
    premium: 'តម្លៃ',
    plansTitle: 'មាន {{quotesCount}} ក្នុង {{planTypeName}}',
    insuredDeclaredValue: {
      modalTitle: 'កំណត់តម្លៃរថយន្តរបស់អ្នក (IDV)',
      lowestAmount: 'តម្លៃ IDV ទាបបំផុត ({{amount}})',
      recommendedAmount: 'តម្លៃ IDV សម្រាប់ការណែនាំ ({{amount}})',
      customAmount: 'កំណត់ IDV ផ្ទាល់ខ្លួនរបស់អ្នក',
      insurerCarPrice: 'តម្លៃកំណត់ដោយក្រុមហ៊ុន',
      noteWithoutRecommendedAmount: 'សូមបញ្ចូល តម្លៃ IDV ត្រឹមត្រូវ នៃរថយន្តរបស់អ្នក។ តំលៃរថយន្តត្រូវសមស្របតាមតំលៃទីផ្សារ។ ក្រុមហ៊ុនធានារ៉ាប់រងមានសិទ្ធិលុបចោលកិច្ចសន្យាធានារ៉ាប់រងក្នុងករណីតំលៃរថយន្តដែលវាយបញ្ចូលទាបជាងតំលៃទីផ្សារ។',
      emptyIdvWarningHeader: 'តម្លៃរថយន្តរបស់អ្នក (IDV) គឺទទេ!',
      whatIdv: 'តើ IDV គឺជាអ្វី?',
      description: 'Insured Declared Value (IDV) គឺជាចំនួនអតិបរិមា ឬខ្ពស់បំផុត ដែលអ្នកនឹងទទួលពីក្រុមហ៊ុនធានារ៉ាប់រងចំពោះការខូចខាតទាំងស្រុង ឬចោរលួច នៃរថយន្តរបស់អ្នក។ ជាទូទៅ វាគឺជាតម្លៃទីផ្សារប្រហាក់ប្រហែលនៃរថយន្តរបស់អ្នក។',
      title: 'តម្លៃធានារ៉ាប់រង (IDV)',
      selectIdv: 'ជ្រើសរើស IDV របស់អ្នក',
      selectIdvNotApplicable: 'មិនអាចអនុវត្តបាន',
    },
    planType: {
      comprehensive: {
        name: 'ធានារ៉ាប់រងទូលំទូលាយ ឬស្តង់ដា (Comprehensive/Standard)',
        description: 'គំរោងធានារ៉ាប់រងនេះ ធានាលើការបាត់បង់ ឬការខូចខាតយានយន្តរបស់លោកអ្នក ឬការខូចខាតដល់យានយន្ត ឬទ្រព្យសម្បត្តិរបស់អ្នកដ៏ទៃ ឬការបង្កររបួសដល់តតិយជន (Third-Party)។ គំរោងនេះរាប់បញ្ចូលដូចជា៖',
        coverage1: 'ទំនួលខុសត្រូវលើតតិយជន',
        coverage2: 'ការខូចខាតយានយន្តរបស់លោកអ្នក - ការធ្វើសំណងសំរាប់ការខូចខាតយានយន្តរបស់លោកអ្នកដោយសារគ្រោះថ្នាក់',
        coverage3: 'ចោរកម្ម - ការធ្វើសំណងសំរាប់ការបាត់បង់យានយន្តទាំងស្រុងរបស់លោកអ្នកដោយសារចោរម្ម',
      },
      thirdParty: {
        name: 'ធានារ៉ាប់រងលើតតិយជន (Third-Party)',
        description: 'គំរោងធានារ៉ាប់រងនេះធានាលើចំនួនទឹកប្រាក់សរុបទាំងអស់ដែលរួមបញ្ចូលថ្លៃសំណងរបស់អ្នកទាមទារសំណង និងការចំណាយផ្សេងៗ ដែលលោកអ្នកនឹងត្រូវទទួលខុសត្រូវចំណាយតាមផ្លូវច្បាប់ក្នុងករណី៖',
        coverage1: 'មរណ:ភាព ឬការរងរបួសដល់បុគ្គលណាមួយ',
        coverage2: 'ការខូចខាតទ្រព្យសម្បត្តិរបស់តតិយជន',
        coverage3: 'សេវាកម្មផ្នែកច្បាប់',
        question: 'តើអ្វីជាតតិយជន (Third-Party)?',
        answer: 'តតិយជន (Third-Party) ជាបុគ្គលដែលមិនមែនជាភាគីនៃកិច្ចសន្យាធានារ៉ាប់រង។',
      },
    },
  },
  confirmModal: {
    title: 'សូម​បញ្ជាក់!',
    desc: 'តើអ្នកប្រាកដថាចង់បន្តសកម្មភាពរបស់អ្នកទេ?',
    confirm: 'បន្ត',
    cancel: 'ច្រានចោល',
  },
  car: {
    brand: 'ម៉ាក',
    model: 'ម៉ូដែល',
    subModel: 'ម៉ូដែលរង',
    yearOfManufacture: 'ឆ្នាំផលិត',
    registrationPlace: 'ទីកន្លែងចុះស្លាកលេខ',
    registrationNumber: 'លេខចុះបញ្ជី',
    chassisNumber: 'លេខតួ',
    engineNumber: 'លេខម៉ាស៊ីន',
    engineCapacity: 'សមត្ថភាពម៉ាស៊ីន',
    fuelType: 'ប្រភេទឥន្ធនៈ',
    identificationCard: 'ប័ណ្ណសម្គាល់រថយន្ត',
  },
  carInsuranceClaimForm: {
    vehicleInsured: {
      title: 'រថយន្តដែលត្រូវបានធានារ៉ាប់រង',
    },
    accidentDetails: {
      title: 'ព័ត៌មានលម្អិតនៃគ្រោះថ្នាក់',
    },
    accidentHappenedAt: {
      label: 'កាលបរិច្ឆេទ និងពេលវេលាគ្រោះថ្នាក់',
    },
    accidentPhotos: {
      label: 'សូមភ្ជាប់រូបភាពនៃគ្រោះថ្នាក់ (ទម្រង់ជា JPEG JPG PNG ឬ PDF)',
    },
    passengersThirdParties: {
      title: 'អ្នករួមដំណើរ និង តតិយជន',
    },
    passengersAndThirdPartiesPoliceReports: {
      label: 'ភ្ជាប់របាយការណ៍ប៉ូលីស (ទម្រង់ជា JPEG JPG PNG ឬ PDF)',
    },
    acceptTermsAndConditions: 'យល់ស្របនឹងលក្ខ័ណ្ឌ។ ខ្ញុំ/យើងសូមប្រកាសថាចំលើយទាំងអស់មានភាពត្រឹមត្រូវ និងពេញលេញ។ ខ្ញុំ/យើងសូមស្នើរអោយក្រុមហ៊ុនធានារ៉ាប់រង ដោះស្រាយលើការទាមទាររសប់តតិយជនក្នុងនាមខ្ញុំ/យើង ដោយគោរពទៅតាម ខនិង លក្ខណ្ឌ នៃប័ណ្ណសន្យារ៉ាប់រងខាងលើ ក៏ដូចជាច្បាប់ជាធរមាននៃព្រះរាជាណាចក្រកម្ពុជា ហើយ ខ្ញុំ/យើងសូមផ្តល់សិទ្ធិដល់ក្រុមហ៊ុន ឬមេធាវីរបស់ក្រុមហ៊ុន ក្នុងការដោះស្រាយ ករណីនេះ តាមគ្រប់រូបភាព ដែលក្រុមហ៊ុនយល់ថាចាំបាច់។',
    completedClaimForm: {
      title: 'ពាក្យស្នើរសុំទាមទារសំណងដែលបានបំពេញរួច',
    },
    completedClaimForms: {
      label: 'សូមភ្ជាប់ពាក្យស្នើរសុំទាមទារសំណងដែលបានបំពេញរួច (ទម្រង់ជា JPEG JPG PNG ឬ PDF)',
    },
    supportingDocuments: {
      title: 'ឯកសារជំនួយផ្សេងៗ',
      label: 'សូមភ្ជាប់ឯកសារជំនួយផ្សេងៗ (ទម្រង់ជា JPEG JPG PNG ឬ PDF)',
    },
  },
  healthInsuranceClaimForm: {
    contactInfoSection: {
      title: 'ទំនាក់ទំនងព័ត៌មាន',
    },
    injuryOrIllnessSection: {
      title: 'របួស ឬ ជំងឺ',
      accidentHappenedAt: {
        label: 'តើពេលណាទៅជួបលោកវេជ្ជបណ្ឌិត ឬកាលបរិច្ឆេទចូលសម្រាកព្យាបាល?',
      },
      symptomsDescription: {
        label: 'សូមពណ៌នាអំពីស្ថានភាព/រោគសញ្ញា',
      },
      diagnosisDescription: {
        label: 'ការធ្វើរោគវិនិច្ឆ័យ/សញ្ញាជំងឺដំបូង',
      },
      coveredByOtherInsurance: {
        label: 'តើអ្នកត្រូវបានធានារ៉ាប់រងដោយការធានារ៉ាប់រងផ្សេងទៀតដែរឬទេ?',
      },
      noteOnOtherinsurance: {
        label: 'កំណត់ចំណាំលើការធានារ៉ាប់រងផ្សេងទៀត',
      },
      medicalDocuments: {
        label: 'សូមភ្ជាប់ឯកសារជំនួយវេជ្ជសាស្ត្រ សូមយោងតាមដំណើរការទាមទារសំណង',
      },
      identityDocuments: {
        label: 'សូមភ្ជាប់អត្តសញ្ញាណប័ណ្ណ ឬលិខិតឆ្លងដែន',
      },
      roomStay: {
        label: 'តើអ្នកជំងឺបានស្នាក់នៅក្នុងបន្ទប់ទេ?',
      },
      dischargeDate: {
        label: 'កាលបរិច្ឆេទចេញពីមន្ទីរពេទ្យ',
      },
      hospitalName: {
        label: 'ឈ្មោះមន្ទីរពេទ្យ',
      },
    },
    accidentHappenedAt: {
      label: 'កាលបរិច្ឆេទ និងពេលវេលាគ្រោះថ្នាក់',
    },
    acceptTermsAndConditions: {
      label: 'ខ្ញុំបាទ/នាងខ្ញុំ សូមធានាអះអាងថាខ្ញុំបាទ/នាងខ្ញុំបានអាន បានយល់ ហើយអះអាងថាគ្រប់ព័ត៌មានទាំងអស់ដែលបានបំពេញនៅក្នុងទម្រង់ទាមទារសំណងនេះគឺពិតជាត្រឹមត្រូវ និងមិនមានការក្លែងបន្លំឡើយ។ ខ្ញុំបាទ/ នាងខ្ញុំទទួលស្គាល់ថាលិខិតធានាអះអាងនេះនឹងផ្តល់សិទ្ធិឱ្យក្រុមហ៊ុន ហូតតេ និងអ្នកតំណាងរបស់ក្រុមហ៊ុនអាចទាក់ទងទៅតតិយជន ដោយរួមមានជាអាទិ៍ វេជ្ជបណ្ឌិតព្យាបាលបច្ចុប្បន្ននិងពីមុន របស់ខ្ញុំបាទ/នាងខ្ញុំ សម្រាប់ទទួលបានព័ត៌មានបន្ថែម ដើម្បីបំពេញការវាយតម្លៃរបស់ក្រុមហ៊ុនលើការទាមទារសំណងនេះ។\n\nខ្ញុំបាទ/នាងខ្ញុំ បានដឹង និងយល់ព្រមថា ព័ត៌មានផ្ទាល់ខ្លួនដែលបានប្រមូល ឬរក្សាទុកដោយក្រុមហ៊ុន ហូតតេ ដែលមាននៅក្នុងបែបបទទាមទារសំណងនេះ ឬដែលទទួលបានតាមរយៈមធ្យោបាយណាក៏ដោយ អាច នឹងត្រូវបានប្រើប្រាស់ដោយក្រុមហ៊ុនហូតតេ ឬបង្ហាញឬផ្ទេរទៅឱ្យស្ថាប័នផ្សេងទៀតក្នុងឬក្រៅប្រទេសកម្ពុជា ក្នុងគោលបំណងដើម្បី (1) វាយតម្លៃការទាមទារសំណង និងផ្តល់សេវាកម្មធានារ៉ាប់រង និងសេវាកម្មជូន អតិថិជន (2) ដំណើរការ និងផ្តល់ប្រសិទ្ធិភាពដល់ការទូទាត់បណ្ណឥណទាន (3) ផ្តល់ព័ត៌មានឱ្យផ្នែកទីផ្សារសម្រាប់សេវាកម្មធានារ៉ាប់រង ដែលពាក់ព័ន្ធជាមួយក្រុមហ៊ុន ហូតតេ ឬ ក្រុមហ៊ុនដែលពាក់ព័ន្ធដទៃទៀត និង (4) ដំណើរការ និងវិភាគការទាមទារសំណងធានារ៉ាប់រង ។',
    },
  },
  cancerInsuranceClaimForm: {
    accidentHappenedAt: {
      label: 'កាលបរិច្ឆេទ និងពេលវេលាគ្រោះថ្នាក់',
    },
  },
  personalAccidentInsuranceClaimForm: {
    accidentHappenedAt: {
      label: 'កាលបរិច្ឆេទ និងពេលវេលាគ្រោះថ្នាក់',
    },
  },
  carInsuranceClaim: {
    accidentPhotos: 'រូបភាពនៃគ្រោះថ្នាក់',
    policeReport: 'របាយការណ៍ប៉ូលីស',
    completedClaimForm: 'ពាក្យស្នើរសុំទាមទារសំណងដែលបានបំពេញរួច',
    supportingDocuments: 'ឯកសារជំនួយផ្សេងៗ',
  },
  carClaimTypes: {
    deathLiability: 'ទំនួលខុសត្រូវលើមរណភាព',
    bodilyInjuryLiability: 'ទំនួលខុសត្រូវលើរបួសរាងកាយ',
    propertyDamageLiability: 'ទំនួលខុសត្រូវលើការខូចខាតទ្រព្យសម្បត្តិ',
    costOfDefense: 'ការចំណាយលើការការពារក្តី',
    ownDamage: 'ការខូចខាតផ្ទាល់ខ្លួន',
    theft: 'ចោរកម្ម',
    accidentToDriver: 'គ្រោះថ្នាក់ដល់អ្នកមានសិទ្ធិបើកបរ',
    passengerLiability: 'ទំនួលខុសត្រូវចំពោះអ្នកដំណើរ',
  },
  dashboard: {
    header: 'កាតធានារ៉ាប់រងរបស់ខ្ញុំ',
  },
  policyDetails: {
    title: 'ព័ត៌មានលម្អិតគោលនយោបាយ',
    coverageSummaryInEn: 'កំណត់សំអាងជាភាសាអង់គ្លេស',
    coverageSummaryInKm: 'កំណត់សំអាងជាភាសាខ្មែរ',
    policyWordingInEn: 'ប័ណ្ណសន្យារ៉ាប់រងលម្អិតជាភាសាអង់គ្លេស',
    policyWordingInKm: 'ប័ណ្ណសន្យារ៉ាប់រងលម្អិតជាភាសាខ្មែរ',
    policyScheduleInEn: 'តារាងគោលនយោបាយជាភាសាអង់គ្លេស',
    policyScheduleInKm: 'តារាងគោលនយោបាយជាភាសាខ្មែរ',
    certificateInsuranceInEn: 'វិញ្ញាបនបត្រធានារ៉ាប់រងជាភាសាអង់គ្លេស',
    certificateInsuranceInKm: 'វិញ្ញាបនបត្រធានារ៉ាប់រងជាភាសាខ្មែរ',
    claimProcedureInEn: 'ដំណើរការនៃការស្នើសុំទាមទារសំណងជាភាសាអង់គ្លេស',
    claimProcedureInKm: 'ដំណើរការនៃការស្នើសុំទាមទារសំណងជាភាសាខ្មែរ',
    certificateOfInsuranceInEn: 'វិញ្ញាបនបត្រនៃការធានារ៉ាប់រងជាភាសាអង់គ្លេស',
    certificateOfInsuranceInKm: 'វិញ្ញាបនបត្រនៃការធានារ៉ាប់រងជាភាសាខ្មែរ',
    invoiceInEn: 'វិក្កយបត្រជាភាសាអង់គ្លេស',
    invoiceInKm: 'វិក្កយបត្រជាភាសាខ្មែរ',
    printDigitalCard: 'បោះពុម្ពកាតធានារ៉ាប់រងឌីជីថល',
    memberName: 'ឈ្មោះសមាជិក',
  },
  policy: {
    actions: {
      reviewAndPay: 'ពិនិត្យឡើងវិញ និងបង់ប្រាក់',
    },
  },
  billing: {
    receiptTitle: 'បង្កាន់ដៃបង់ប្រាក់',
  },
  insuranceTypes: {
    car: 'រថយន្ត',
    health: 'សុខភាព',
    cancer: 'ជំងឺមហារីក',
    personalAccident: 'គ្រោះថ្នាក់ផ្ទាល់ខ្លួន',
    fire: 'អគ្គីភ័យ',
    life: 'ជីវិត',
  },
  insuranceTypesEnum: {
    hlth: 'សុខភាព',
    pa: 'គ្រោះថ្នាក់ផ្ទាល់ខ្លួន',
    auto: 'យានជំនិះ',
    life: 'ជីវិត',
    trav: 'ការធ្វើដំណើរ',
    prop: 'ទ្រព្យសម្បត្តិ',
    fire: 'អគ្គីភ័យ',
    engi: 'វិស្វកម្ម',
    mar: 'សមុទ្រ',
    crit: 'ជំងឺធ្ងន់ធ្ងរ',
    liab: 'ការទទួលខុសត្រូវ',
    micro: 'រ៉ាប់រងអត្រាតិច',
    agri: 'កសិកម្ម',
  },
  policyTypes: {
    personal: 'គោលនយោបាយបុគ្គល និងក្រុម',
    commercial: 'គោលនយោបាយអាជីវកម្ម',
  },
  insuranceTypeNames: {
    car: 'ធានារ៉ាប់រងយានយន្តឯកជន',
    health: 'ធានារ៉ាប់រងសុខភាព',
    cancer: 'ធានារ៉ាប់រងជំងឺមហារីក',
    life: 'ធានារ៉ាប់រងអាយុជីវិត',
    fire: 'ធានារ៉ាប់រងអគ្គីភ័យ',
    personalAccident: 'ធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល',
  },
  carQuoteBuyPage: {
    carQuoteReview: {
      ownerTitle: 'ព័ត៌មានលម្អិតរបស់ម្ចាស់',
      vehicleTitle: 'ព័ត៌មានលម្អិតរបស់យានយន្ត',
      requiredVerify: 'តម្លៃរថយន្តរបស់លោកអ្នក តម្រូវឲ្យធ្វើការផ្ទៀតផ្ទាត់ជាមួយក្រុមហ៊ុនធានារ៉ាប់រងជាមុន មុនពេលលោកអ្នកអាចធ្វើការបង់ប្រាក់បាន។ ក្រុមការងារនឹងធ្វើការជូនដំណឹងលោកអ្នកក្នុងពេលឆាប់ៗ ក្រោយធ្វើការផ្ទៀតផ្ទាត់រួចរាល់។',
    },
    carQuoteBuyForm: {
      vehicleTitle: 'បំពេញព័ត៌មានលម្អិតរបស់យានយន្ត',
    },
  },
  carInsurancePayment: {
    referredVehicleUsageNotSet: 'សូមអភ័យទោស! អ្នកមិនអាចទិញធានារ៉ាប់រងរថយន្តរបស់អ្នកពី {{insurerName}} បានទេឥឡូវនេះ ដោយសារការប្រកាសអំពីការប្រើប្រាស់យានយន្តរបស់វាមិនមាន។\nអ្នកអាចទិញនៅពេលក្រោយ នៅពេលដែលការប្រកាសមាន។',
  },
  thankYou: {
    title: 'សូមអរគុណ!',
    description: 'អបអរសាទរ! ឥឡូវនេះអ្នកត្រូវបានការពារ។ ព័ត៌មានលម្អិតអំពីប័ណ្ណសន្យារបស់អ្នកនឹងត្រូវបានផ្តល់ជូនអ្នកក្នុងពេលឆាប់ៗនេះ។',
    goToDashboard: 'ចូលទៅកាន់ផ្ទាំងគ្រប់គ្រង',
  },
  thankYouBeta: {
    title: 'សូមអរគុណសម្រាប់ការសាកល្បងការធានារ៉ាប់រងបេតារបស់យើង',
    description: 'អបអរសាទរ! ឥឡូវនេះ អ្នកត្រូវបានបញ្ចូលទៅក្នុងបញ្ជីទំនាក់ទំនងជួរមុខរបស់យើង។ យើងនឹងទាក់ទងអ្នកក្នុងពេលឆាប់ៗនេះ។',
  },
  aboutUsPage: {
    heading: 'អំពី អិមជីអេខូវើ',
    subHeading: 'ថ្នាលបច្ចេកវិទ្យាធានារ៉ាប់រងពេញលេញដំបូងគេនៅកម្ពុជា',
    vision: 'ចក្ខុវិស័យ',
    visionStatement: 'យើងខិតខំប្រឹងប្រែងដើម្បីក្លាយជាក្រុមហ៊ុនបច្ចេកវិទ្យាធានារ៉ាប់រងដែលគួរឱ្យទុកចិត្តបំផុតមួយក្នុងពិភពលោក។',
    mission: 'បេសកម្ម',
    missionStatement: 'បេសកកម្មរបស់ MGA Cover គឺសាមញ្ញ៖ ធ្វើឱ្យការធានារ៉ាប់រងមានលក្ខណៈសាមញ្ញ តម្លាភាព និងអាចទុកចិត្តបានសម្រាប់អតិថិជនរបស់យើង ដូច្នេះពួកគេអាចសម្រេចបាននូវសេចក្តីប្រាថ្នារបស់ពួកគេ។',
    whoAreWe: 'តើយើងជានរណា?',
    whoAreWeDescription: 'អិមជីអេខូវើ ត្រូវបានផ្តួចផ្តើមដោយ លោក មាស សុផាត ប្រធានប្រតិបត្តិនៃក្រុមហ៊ុន MGA Asia Insurance Brokers Co., Ltd នៅដើមដំបូងនៃការផ្ទុះឡើងនៃជំងឺកូវីដ-១៩។ ជំរុញដោយការជឿជាក់ និងចំណង់ចំណូលចិត្តរបស់គាត់ចំពោះបច្ចេកវិទ្យា គាត់ជឿជាក់ថា MGA Cover នឹងជំរុញវិស័យធានារ៉ាប់រងនៅក្នុងព្រះរាជាណាចក្រកម្ពុជាឆ្ពោះទៅមុខ និងបង្កើតផលវិជ្ជមានដល់ប្រជាជនកម្ពុជាជាច្រើននាក់។',
  },
  contactUsPage: {
    businessHours: 'ច័ន្ទ - សៅរ៍ ម៉ោង 8:00 ព្រឹក - 5:30 ល្ងាច ដោយមិនរាប់បញ្ចូលថ្ងៃឈប់សំរាក',
    callUs: 'ទូរសព្ទមកកាន់យើង',
    emailUs: 'ផ្ញើរអ៊ុីម៉េលមកកាន់យើង',
    headOffice: 'ការិយាល័យកណ្តាលរបស់យើង',
    generalInquiry: 'សាកសួរទូទៅ',
  },
  paymentOption: {
    title: 'មធ្យោបាយបង់ប្រាក់',
  },
  paymentMethods: {
    abapayKhqr: 'ABA KHQR',
    abapayKhqrDescription: 'ស្កេនដើម្បីទូទាត់ជាមួយកម្មវិធីធនាគារណាមួយ',
    bakong: 'KHQR',
    bakongDescription: 'ស្កេនដើម្បីបង់ប្រាក់តាមរយៈធនាគាជាសមាជិក',
  },
  fuelTypes: {
    unknown: 'មិនស្គាល់',
    petrol: 'ប្រេងសាំង',
    diesel: 'ម៉ាស៊ូត',
    hybrid: 'កូនកាត់',
  },
  personalInfo: {
    changeabilityWarningMessage: 'វាជារឿងសំខាន់ដែលអ្នកត្រូវតែបញ្ចូលព័ត៌មានផ្ទាល់ខ្លួនរបស់អ្នកឱ្យបានត្រឹមត្រូវដូចនៅក្នុងអត្តសញ្ញាណប័ណ្ណ ឬលិខិតឆ្លងដែនរបស់អ្នក ព្រោះនៅពេលដែលវាត្រូវបានរក្សាទុក អ្នកមិនអាចផ្លាស់ប្តូរបានទេ។ សូមបំពេញដោយប្រុងប្រយ័ត្នមុនពេលផ្លាស់ទីទៅជំហានបន្ទាប់។ សូមបំពេញដោយប្រុងប្រយ័ត្នមុនពេលផ្លាស់ទីទៅជំហានបន្ទាប់។',
    supportContact: 'សម្រាប់ព័ត៌មានបន្ថែមសូមទាក់ទង',
  },
  genders: {
    male: 'ប្រុស',
    female: 'ស្រី',
  },
  toast: {
    signedIn: 'អ្នកបានចូលដោយជោគជ័យ',
    signedOut: 'អ្នកបានចេញដោយជោគជ័យ',
    personalInfo: {
      updateSuccess: 'ព័ត៌មានផ្ទាល់ខ្លួនត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ',
    },
    insuranceClaimUpdate: {
      success: 'ការទាមទារសំណងត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ',
      error: 'ការធ្វើបច្ចុប្បន្នភាពការទាមទារសំណងបរាជ័យ',
    },
    requestDocuments: {
      success: 'អ៊ីមែលស្នើសុំឯកសារត្រូវបានផ្ញើដោយជោគជ័យ',
      error: 'បរាជ័យក្នុងការផ្ញើអ៊ីមែលស្នើសុំឯកសារ',
    },
  },
  orderStatuses: {
    pending: 'កំពុងរង់ចាំ',
    expired: 'ផុតកំណត់',
    active: 'សកម្ម',
    ended: 'បានបញ្ចប់',
    locked: 'ចាក់សោ',
  },
  orderCustomTypes: {
    noCustom: 'គ្មានការកំណត់ផ្ទាល់ខ្លួ',
    custom: 'ការកំណត់ផ្ទាល់ខ្លួន',
    lumpSum: 'ទឹកប្រាក់សរុប',
  },
  superSeo: {
    home: {
      title: 'MGA Cover: ទិញបណ្ណសន្យាធានារ៉ាប់រងតាមអ៊ីនធឺណិត និងទទួលការការពារភ្លាមៗ',
      description: 'ធានារ៉ាប់រងរថយន្តត្រូវបានធ្វើឱ្យមានភាពសាមញ្ញ តម្លាភាព និងអាចទុកចិត្តបាន។ ស្វែងរកបណ្ណសន្យាធានារ៉ាប់រងរថយន្តល្អបំផុតតាមអ៊ីនធឺណិត។ ទទួលការការពារភ្លាមៗ។',
    },
    aboutUsPage: {
      title: 'អំពី អិមជីអេខូវើ',
      description: 'ថ្នាលបច្ចេកវិទ្យាធានារ៉ាប់រងពេញលេញដំបូងគេនៅកម្ពុជា។ បេសកកម្មរបស់ អិមជីអេខូវើ គឺធ្វើឱ្យការធានារ៉ាប់រងមានលក្ខណៈសាមញ្ញ តម្លាភាព និងអាចទុកចិត្តបានសម្រាប់អតិថិជនរបស់យើង ដូច្នេះពួកគេអាចសម្រេចបាននូវសេចក្តីប្រាថ្នារបស់ពួកគេ។',
    },
    contactUsPage: {
      title: 'ទំនាក់ទំនងពួកយើង - អិមជីអេខូវើ',
      description: 'មិនថាអ្នកមានចម្ងល់អំពីសម្រង់តំលៃធានារ៉ាប់រងរថយន្តភ្លាមៗតាមអ៊ីនធឺណិត ការការពារ ការទាមទារសំណង ឬជំនួយណាមួយទេ អ្នកអាចទាក់ទងមកយើងតាមរយៈព័ត៌មានលម្អិតទំនាក់ទំនង MGA Cover។',
    },
    carInsurancePage: {
      title: 'អិមជីអេខូវើ: ទិញបណ្ណសន្យាធានារ៉ាប់រងរថយន្តតាមអ៊ីនធឺណិតនៅកម្ពុជា និងទទួលការការពារភ្លាមៗ',
      description: 'ទទួលបានសម្រង់តម្លៃធានារ៉ាប់រងរថយន្តភ្លាមៗដោយឥតគិតថ្លៃតាមអ៊ីនធឺណិត។ ប្រៀបធៀប និងទិញ/បន្ត ប័ណ្ណសន្យាធានារ៉ាប់រងរថយន្តតាមអ៊ីនធឺណិតនៅកម្ពុជា។ បុព្វលាភតម្លៃសមរម្យពីក្រុមហ៊ុនធានារ៉ាប់រងរថយន្តកំពូលៗក្នុងប្រទេសកម្ពុជា។',
    },
    healthInsurancePage: {
      title: 'ទិញគម្រោងធានារ៉ាប់រងសុខភាពតាមអ៊ីនធឺណិតនៅកម្ពុជា - អិមជីអេខូវើ',
      description: 'ទទួលបានសម្រង់តម្លៃធានារ៉ាប់រងសុខភាពភ្លាមៗតាមអ៊ីនធឺណិតជាមួយនឹងបុព្វលាភដែលមានតម្លៃសមរម្យ។ ប្រៀបធៀប និង ទិញ ឬបន្ត ប័ណ្ណសន្យាធានារ៉ាប់រងសុខភាពតាមអ៊ីនធឺណិតនៅកម្ពុជា។',
    },
    personalAccidentInsurancePage: {
      title: 'ទិញបណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលតាមអ៊ីនធឺណិតនៅកម្ពុជា -  អិមជីអេខូវើ',
      description: 'ប្រៀបធៀប និង ទិញឬបន្ត ប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលតាមអ៊ីនធឺណិត។ ទទួលការធានារ៉ាបរងលើមរណភាពដោយចៃដន្យ ពិការភាពជាអចិន្ត្រៃយ៍ និងថ្លៃព្យាបាលវេជ្ជសាស្ត្រ។',
    },
    cancerInsurancePage: {
      title: 'ទិញបណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីកតាមអ៊ីនធឺណិតនៅកម្ពុជា - អិមជីអេខូវើ',
      description: 'ប្រៀបធៀប និងទិញ/បន្តបណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីកលើអ៊ីនធឺណិត។ ទទួលបានការការពារប្រឆាំងនឹងជំងឺមហារីក។',
    },
    hospitalNetworkPage: {
      title: 'ស្វែងរកបណ្តាញមន្ទីរពេទ្យទូលំទូលាយរបស់យើង។',
      description: 'ដើម្បីកាត់បន្ថយការលំបាករបស់អ្នក យើងក៏បានបញ្ចូលការស្វែងរកតាមឈ្មោះ និងទីតាំងរបស់មន្ទីរពេទ្យផងដែរ។',
    },
  },
  notFoundPage: {
    title: 'រកមិនឃើញទំព័រ',
    desc: 'ទំព័រដែលអ្នកកំពុងស្វែងរកមិនមានទេ',
  },
  photoManagerDialog: {
    title: 'ប្រអប់កម្មវិធីគ្រប់គ្រងរូបថត',
    tabs: {
      photos: {
        title: 'រូបថត',
      },
      upload: {
        title: 'ផ្ទុកនៅខាងលើ (Upload)',
        usageMsg: 'អូស និងទម្លាក់ឯកសារនៅទីនេះ ឬចុច',
        maxSizeMsg: 'ទំហំឯកសារដែលអាចទទួលយកបានជាអតិបរមាគឺ៖ 5MB',
        maxFilesMsg: 'ចំនួនអតិបរមានៃឯកសារដែលអ្នកអាចផ្ទុកនៅខាងលើ (Upload)គឺ {{maxFiles}}',
        reachLimitMsg: 'អ្នកបានឈានដល់ចំនួនកំណត់រូបថតរបស់អ្នកហើយ!',
      },
    },
  },
  carInsurancePage: {
    headerSection: {
      title: 'ធានារ៉ាប់រង​រថយន្ត',
      item1: 'ទទួលសម្រង់តម្លៃធានារ៉ាប់រងរថយន្តភ្លាមៗដោយឥតគិតថ្លៃ',
      item2: 'បុព្វលាភសមរម្យពីក្រុមហ៊ុនធានារ៉ាប់រងរថយន្តកំពូលៗ',
      item3: 'ស្វែងរកវិធីសន្សំសំចៃប្រាក់លើការធានារ៉ាប់រងរថយន្ត',
      item4: 'ប្រៀបធៀបអត្រាធានារ៉ាប់រងរថយន្តដោយឥតគិតថ្លៃ',
    },
    definitionSection: {
      title: 'តើអ្វីទៅជាធានារ៉ាប់រងរថយន្ត?',
      description: 'ធានារ៉ាប់រងរថយន្តផ្តល់ការការពារផ្នែកហិរញ្ញវត្ថុដល់អ្នក និងរថយន្តរបស់អ្នកចំពោះការបាត់បង់ ឬការខូចខាតដែលមិនបានរំពឹងទុក ដែលបណ្តាលមកពីគ្រោះថ្នាក់ អគ្គីភ័យ ចោរកម្ម ក៏ដូចជាការខូចខាតដល់តតិយជន (ភាគីទីបី)  ឬទ្រព្យសម្បត្តិរបស់តតិយជន (ភាគីទីបី)។ ជំនួសឱ្យការបង់ប្រាក់សម្រាប់ការរងរបួស ឬទ្រព្យសម្បត្តិដែលខូចខាតដ៏ថ្លៃដោយខ្លួនឯង ធានារ៉ាប់រងរថយន្តរបស់អ្នកចូលមកដើម្បីបង់ប្រាក់មួយចំនួន ឬទាំងស្រុង សំរាប់ការបាត់បង់ ឬការខូចខាត។',
    },
    coverSection: {
      title: 'តើធានារ៉ាប់រងរថយន្តធានាលើអ្វីខ្លះ?',
      subTitle: 'ទាំងនេះគឺជាការធានាទូទៅក្នុងបណ្ណសន្យាធានារ៉ាប់រងរថយន្ត។ សូមយោងទៅលើប័ណ្ណសន្យារ៉ាប់រងជាពាក្យពេចសម្រាប់ព័ត៌មានបន្ថែមអំពីការធានារបស់បណ្ណសន្យា។',
      item1: {
        label: 'ការខូចខាតដោយគ្រោះថ្នាក់',
        desc: 'ការបាត់បង់ និងការខូចខាតដោយសារគ្រោះថ្នាក់ និងការប៉ះទង្គិចត្រូវបានធានារ៉ាប់រង។',
      },
      item2: {
        label: 'អគ្គីភ័យ',
        desc: 'ការបាត់បង់ និងការខូចខាតចំពោះរថយន្តរបស់អ្នកដោយសារភ្លើងឆេះដោយគ្រោះថ្នាក់ ការបញ្ឆេះដោយខ្លួនឯង រងការបំផ្លិចបំផ្លាញ។ល។',
      },
      item3: {
        label: 'ចោរកម្ម',
        desc: 'ធានារ៉ាប់រងសំរាប់ការបាត់បង់នៃរថយន្តរបស់អ្នកនៅពេលដែលវាត្រូវបានគេលួចយក។',
      },
      item4: {
        label: 'ទំនួលខុសត្រូវលើតតិយជន',
        desc: 'ប្រសិនបើរថយន្តរបស់អ្នកបង្ករឲមាន មរណភាព ឬរបួសរាងកាយដល់បុគ្គលណាម្នាក់ ឬការខូចខាតដល់រថយន្ត ឬទ្រព្យសម្បត្តិរបស់គេ ការបាត់បង់ និងការខូចខាត ហើយនិងសេវាផ្នែកច្បាប់ ត្រូវបានធានារ៉ាប់រង។',
      },
    },
    noCoverSection: {
      title: 'តើធានារ៉ាប់រងរថយន្តមិនធានាលើអ្វីខ្លះ?',
      subTitle: 'ទាំងនេះគឺជាការមិនធានានៅក្នុងបណ្ណសន្យាធានារ៉ាប់រងរថយន្ត។ សូមយោងទៅលើបណ្ណសន្យារ៉ាប់រងជាពាក្យពេចសម្រាប់បញ្ជីទូលំទូលាយនៃការមិនធានា។',
      item1: {
        label: 'ប្រើប្រាស់ និងសឹករិចរិលជាលក្ខណៈទូទៅ',
        desc: 'ថ្លៃការជួសជុល និងការផ្លាស់ប្តូរគ្រឿងបន្លាស់កើតឡើងពីការប្រើប្រាស់ជាប្រចាំគឺមិនត្រូវបានធានាទេ។',
      },
      item2: {
        label: 'ការបើកបរពេលស្រវឹង',
        desc: 'ប្រសិនបើអ្នកបើកបររបស់អ្នក ឬអ្នក ត្រូវបានគេរកឃើញថាបានកំពុងបើកបរក្រោមឥទ្ធិពលនៃគ្រឿងស្រវឹង ឬថ្នាំញឿន ការបាត់បង់ ឬការខូចខាតមិនត្រូវបានធានានោះទេ។',
      },
      item3: {
        label: 'បើកបរដោយគ្មានបណ្ណបើកបរ',
        desc: 'វាមិនធានាសំរាប់ការបាត់បង់ ឬការខូចខាតណាមួយ ដែលកើតឡើងក្នុងអំឡុងពេលបើកបរដោយគ្មានបណ្ណបើកបរមានសុពលភាពនោះទេ។',
      },
      item4: {
        label: 'ការខូចខាតដែលមានស្រាប់',
        desc: 'ការខូចខាតណាមួយដែលរថយន្តរបស់អ្នកបានទទួលរងគ្រោះមុនទិញប័ណ្ណសន្យាធានារ៉ាប់រង នឹងមិនត្រូវបានធានារ៉ាប់រងនោះទេ។',
      },
      item5: {
        label: 'ការប្រើប្រាស់រថយន្តរបស់អ្នកសំរាប់ធ្វើអាជីវកម្ម',
        desc: 'បណ្ណសន្យារ៉ាប់រងរថយន្តធានារ៉ាប់រងតែលើរថយន្តប្រើប្រាស់ជាលក្ខណៈឯកជនតែប៉ុណ្ណោះ ដូច្នេះហើយ វាមិនធានារ៉ាប់រងលើការបាត់បង់ និងការខូចខាតទាំងឡាយណា ដែលបណ្តាលមកពីការប្រើប្រាស់សំរាប់ធ្វើអាជីវកម្មឡើយ។',
      },
      item6: {
        label: 'រួមចំណែកប្រព្រឹត្តការធ្វេសប្រហែស',
        desc: 'ការបាត់បង់ និងការខូចខាតទាំងឡាយណាដែលបណ្តាលមកពីការធ្វេសប្រហែសរបស់អ្នកផ្ទាល់ ដែលប្រាស់ចាកពីការណែនាំអំពីការបើកបររបស់ក្រុមហ៊ុនផលិតរថយន្ត នឹងមិនត្រូវបានធានារ៉ាប់រងឡើយ។  ឧទាហរណ៍៖ អ្នកបើកបររថយន្តរបស់អ្នកក្នុងទឹកជំនន់។',
      },
      item7: {
        label: 'ការខូចខាតបន្តបន្ទាប់គ្នាក្រោយពីគ្រោះថ្នាក់',
        desc: 'រាល់ការបាត់បង់ និងការខូចខាតដែលមិនមែនជាលទ្ធផលផ្ទាល់នៃគ្រោះថ្នាក់នឹងមិនត្រូវបានធានារ៉ាប់រងឡើយ។ ឧទាហរណ៍៖ ប្រសិនបើរថយន្តខូចត្រូវបានបើកបរមិនបានត្រឹមត្រូវបន្ទាប់ពីគ្រោះថ្នាក់ ហើយម៉ាស៊ីនរបស់វាខូច នោះវានឹងមិនត្រូវបានធានារ៉ាប់រងឡើយ។\n',
      },
      item8: {
        label: 'ការខូចខាតផ្នែកគ្រឿងម៉ាសុីន និងអគ្គិសនី',
        desc: '  រាល់​ការ​ខូច​ខាត​គ្រឿង​ម៉ាស៊ីន និង​អគ្គិសនី​នៅ​ក្នុង​ផ្នែក​រថយន្ត​របស់​អ្នក​នឹង​មិន​ត្រូវ​បានធានា​រ៉ាប់រង​ឡើយ។',
      },
      item9: {
        label: 'ដែនកំណត់តំបន់ភូមិសាស្ត្រ',
        desc: 'ការបាត់បង់ និងការខូចខាតណាមួយចំពោះរថយន្តរបស់អ្នក នៅពេលប្រើប្រាស់នៅខាងក្រៅតំបន់ភូមិសាស្ត្រនៃប្រទេសកម្ពុជា នឹងមិនត្រូវបានធានារ៉ាប់រងឡើយ។',
      },
    },
    addOnCoverSection: {
      title: 'ធានារ៉ាប់រងបន្ថែម (Add-on Covers) ក្នុងធានារ៉ាប់រងរថយន្ត',
      subTitle: 'ធានារ៉ាប់រងបន្ថែមគឺជាការធានាពង្រីកបន្ថែម ឬអត្ថប្រយោជន៍បន្ថែម លើការធានារ៉ាប់រងមូលដ្ឋាននៃបណ្ណសន្យារ៉ាប់រងរថយន្តរបស់អ្នក។ ប៉ុន្តែ ពួកវាក៏បង្កើនថ្លៃបុព្វលាភទៅតាមនោះផងដែរ ដូច្នេះ អ្នកត្រូវតែពនិត្យសេចក្តីលំអិតនៅពេលបន្ថែម។ មានធានារ៉ាប់រងបន្ថែមចំនួនពីរប្រភេទ ដែលអ្នកអាចជ្រើសរើសពី អិមជីអេ ខូវើ។',
      item1: {
        label: 'គ្រោះថ្នាក់ដល់អ្នកមានសិទ្ធិបើកបរ',
        desc: 'ការធានារ៉ាប់រងបន្ថែមនេះផ្តល់ការធ្វើសំណងសំរាប់ មរណភាព ឬពិការភាពជាអចិន្ត្រៃយ៍ ឬការរងរបួស ដល់បុគ្គលដែលមានសិទ្ធបើកបរយានយន្តក្នុងអំឡុងពេលកើតហេតុ ដែលការទាមទារសំណងកើតឡើងចេញពីហេតុការណ៍។ \n\nអ្នកមានសិទ្ធិបើកបរ (Authorized Driver) សំដៅលើបុគ្គលណាដែលបើករថយន្តរបស់អ្នកតាមការបញ្ជារ ឬការអនុញ្ញាតរបស់អ្នក ប៉ុន្តែលុះត្រាតែ បុគ្គលនោះមានប័ណ្ណបើកបរដែលមានសុពលភាពនៅក្នុងប្រទេសកម្ពុជា ហើយនិងមិនស្ថិតក្រោមការត្រួតពិនិត្យ ឬការដកសិទ្ធិពីការបើកបរ។\n',
      },
      item2: {
        label: 'ទំនួលខុសត្រូវចំពោះអ្នកដំណើរ',
        desc: 'ការធានារ៉ាប់រងបន្ថែមនេះផ្តល់ការធ្វើសំណងសម្រាប់ មរណភាព ឬការរងរបួស ដល់បុគ្គលណា ដែលត្រូវបានដឹកចូល ឬចូលដោយខ្លួនឯង ឬឡើងជិះ ឬក៏ចុះពីយានយន្តនៅក្នុងអំឡុងពេលកើតហេតុ ដែលការទាមទារសំណងកើតឡើងចេញពីហេតុការណ៍។',
      },
    },
    whyNeedSection: {
      title: 'ហេតុអ្វីអ្នកត្រូវមានធានារ៉ាប់រងរថយន្ត?',
      subTitle: 'ទោះបីជាវាមិនមែនជាកាតព្វកិច្ចនៅក្នុងព្រះរាជាណាចក្រកម្ពុជានៅឡើយក៏ដោយ យ៉ាងហោចណាស់ អ្នកគួរតែមានធានារ៉ាប់រងរថយន្តគំរោង ទំនួលខុសត្រូវលើតតិយជន (Third-Party Liability) នៅពេលដែលអ្នកមានរថយន្តផ្ទាល់ខ្លួន។\n\nបណ្ណសន្យានារ៉ាប់រងរថយន្តផ្តល់អោយអ្នកនូវទំនួលខុសត្រូវហិរញ្ញវត្ថុដែលអាចកើតឡើងចំពោះតតិយជន ឬ ការបាត់បង់ ឬការខូចខាតផ្ទាល់ខ្លួនចំពោះរថយន្តរបស់អ្នក ដោយសារគ្រោះថ្នាក់ចរាចរណ៍ ឬព្រឹត្តិការណ៍អកុសលផ្សេងទៀត។ នេះគឺជាអត្ថប្រយោជន៍សំខាន់ៗខ្លះៗរបស់ធានារ៉ាប់រងរថយន្ត៖',
      item1: {
        label: 'ធានារ៉ាប់រងចំពោះការខូចខាតរថយន្ត',
        desc: 'ប្រសិនបើរថយន្តរបស់អ្នកត្រូវបានខូចខាតដោយសារ គ្រោះថ្នាក់ ឬការប៉ះទង្គិចគ្នា ឬភ្លើងឆេះ ធានារ៉ាប់រងរថយន្តគំរោងទូលំទូលាយ ឬស្តង់ដា (Comprehensive/Standard) អាចផ្តល់នូវការការពារផ្នែកហិរញ្ញវត្ថុ។',
      },
      item2: {
        label: 'ធានារ៉ាប់រងចំពោះចោរកម្ម',
        desc: 'ធានារ៉ាប់រងរថយន្តគំរោងទូលំទូលាយ ឬស្តង់ដា (Comprehensive/Standard) អាចផ្តល់នូវការការពារផ្នែកហិរញ្ញវត្ថុ ចំពោះការបាត់បង់នៃរថយន្តរបស់អ្នកទាំងស្រុង នៅពេលដែលរថយន្តរបស់អ្នកត្រូវបានចោរលួចយក។ សំណងនឹងអនុលោមទៅតាម Insured Declared Value (IDV) ដែលមានចែងក្នុងបណ្ណសន្យារបស់អ្នកដោយស្របទៅតាមលក្ខខណ្ឌ។',
      },
      item3: {
        label: 'ធានារ៉ាប់រងចំពោះគ្រោះថ្នាក់ដល់អ្នកមានសិទ្ធបើកបរ',
        desc: 'ប្រសិនបើអ្នកចង់ការពារខ្លួនអ្នកដែលជាអ្នកបើកបរដោយផ្ទាល់ ឬអ្នកមានសិទ្ធបើកបររបស់អ្នក ពីពិការភាពអចិន្ត្រៃយ៍ ឬមរណភាព ដែលបណ្តាលមកពីគ្រោះថ្នាក់ចរាចរណ៍ ការធានាបន្ថែមលើគ្រោះថ្នាក់ដល់អ្នកមានសិទ្ធិបើកបរ (Accident to Driver add-on cover) គឺជាខែលផ្នែកហិរញ្ញវត្ថុបន្ថែមចំពោះការបាត់បង់ ឬការខូចខាតបែបនេះ។',
      },
      item4: {
        label: 'ទទួលបានសេវាមិនបាច់បង់ប្រាក់',
        desc: 'ធានាររ៉ាប់រងរថយន្តជាធម្មតាបញ្ចូលការជួសជុលមិនបាច់បង់ប្រាក់ ដែលផ្តល់ជូនដោយបណ្តាញយានដ្ឋានដែលមានការបញ្ជាក់ ដែលក្រុមហ៊ុនធានារ៉ាប់រងរថយន្តបានចាប់ដៃគូជាមួយ។ ត្រូវប្រាកដថា អ្នកពិនិត្យមើលបណ្តាញយានដ្ឋានរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរថយន្ត ដែលអ្នកនឹងទិញជាមួយ ថាតើពួកវាមាននៅក្នុងតំបន់នៃលំនៅដ្ឋានរបស់អ្នក។',
      },
      item5: {
        label: 'ខែលការពារប្រឆាំងនឹងការបាត់បង់ដល់តតិយជន  (Third-Party)',
        desc: 'ការទទួលខុសត្រូវចំពោះមរណភាព ឬរបួសរាងកាយចំពោះបុគ្គលណាម្នាក់ ឬការខូចខាតរថយន្ត ឬទ្រព្យសម្បត្តិរបស់គេ ដែលបង្កឡើងដោយរថយន្តរបស់អ្នក គឺជាបន្ទុកហិរញ្ញវត្ថុធ្ងន់ធ្ងរ។ ក៏ប៉ុន្តែ បណ្ណសន្យាធានារ៉ាប់រងរថយន្តគំរោងតតិយជនរបស់អ្នកដើរតួនាទីយ៉ាងសំខាន់ប្រឆាំងនឹងទំនួលខុសត្រូវចំពោះតតិយជនទាំងនេះ។',
      },
      item6: {
        label: 'ផ្តល់អោយខ្លួនអ្នកនូវសន្តិភាពផ្លូវចិត្ត',
        desc: 'មានបណ្ណសន្យាធានារ៉ាប់រងរថយន្តអាចធ្វើឱ្យអ្នកធូរស្រាលពីភាពតានតឹងផ្លូវចិត្ត ដោយសារអ្នកត្រូវបានការពារផ្នែកហិរញ្ញវត្ថុសម្រាប់ព្រឹត្តិការណ៍អកុសល ហើយអ្នកអាចបើកបរប្រកបដោយទំនុកចិត្ត។',
      },
    },
    keyFeatureSection: {
      title: 'លក្ខណៈពិសេសនៃធានារ៉ាប់រងរថយន្តរបស់ អិមជីអេ ខូវើ',
      item1: {
        label: 'ការធានាលើការខូចខាតផ្ទាល់ខ្លួន ឬចោរកម្ម',
        desc: 'ការធានារ៉ាប់រងនេះមាននៅក្នុងគម្រោងធានារ៉ាប់រងរថយន្តទូលំទូលាយ ឬស្តង់ដារ។',
      },
      item2: {
        label: 'ការធានាលើការខូចខាតដល់តតិយជន',
        desc: 'ផ្នែកនេះធានាលើមរណភាព ឬការរងរបួសរាងកាយដល់បុគ្គលណាម្នាក់ ឬការខូចខាតដល់រថយន្ត ឬទ្រព្យសម្បត្តិរបស់គេ ដែលបង្ករដោយរថយន្តរបស់អ្នក។',
      },
      item3: {
        label: 'ធានារ៉ាប់រងបន្ថែម (Addon Covers)',
        desc: 'អត្ថប្រយោជន៍បន្ថែមទៅលើការធានារ៉ាប់រងរថយន្តមូលដ្ឋាន។ មានធានារ៉ាប់រងបន្ថែម២ប្រភេទ៖ គ្រោះថ្នាក់ដល់អ្នកមានសិទ្ធិបើកបរ & ទំនួលខុសត្រូវចំពោះអ្នកដំណើរ។',
      },
      item4: {
        label: 'បុព្វលាភធានារ៉ាប់រងរថយន្ត',
        desc: 'ធានារ៉ាប់រងរថយន្តនៃអិមជីអេ ខូវើ ផ្តល់ជូនតម្លៃសមរម្យមិនគួរឱ្យជឿ។',
      },
      item5: {
        label: 'ការបញ្ចុះតម្លៃ',
        desc: 'ការបញ្ចុះតម្លៃធម្មតា ការបញ្ចុះតម្លៃសំរាប់អតិថិជនស្មោះត្រង់ និងការបញ្ចុះតម្លៃពេលផ្សព្វផ្សាយ។',
      },
      item6: {
        label: 'រង្វាន់ពេលគ្មានការទាមទារសំណង',
        desc: 'ការបញ្ចុះតម្លៃផ្តល់ជូនរហូតដល់៥០%',
      },
      item7: {
        label: 'សេវាកម្មដោយគ្មានចំណាយប្រាក់',
        desc: 'អាចរកបានតាមរយះបណ្តាញយានដ្ឋានរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរថយន្ត។',
      },
      item8: {
        label: 'ដំណើរការទិញ',
        desc: 'តាមរយៈឌីជីថល ១០០%',
      },
      item9: {
        label: 'ដំណើរកាទាមទារសំណង',
        desc: 'ដំណើរការទាមទារដោយរលូនតាមរយៈអ៊ីនធឺណិត។ ការ​ទូទាត់​សំណង​ ដោយ​គ្មាន​ចំណាយប្រាក់ រហ័ស និង​ងាយស្រួល។',
      },
    },
    buyConsiderationSection: {
      title: 'ចំណុចដែលគួរពិចារណានៅពេលទិញធានារ៉ាប់រងរថយន្ត',
      item1: {
        label: 'វិសាលភាពនៃការធានា',
        desc: 'ទោះបីជាការធានារ៉ាប់រងរថយន្តតតិយជនមិនទាន់បានចូលជា កាតព្វកិច្ចជាផ្លូវច្បាប់នៅក្នុងប្រទេសកម្ពុជានៅឡើយ ប៉ុន្តែម្ចាស់រថយន្តគ្រប់រូបគួរតែពិចារណាលើការធានារ៉ាប់រងនេះ ព្រោះវាផ្តល់អត្ថប្រយោជន៍ផ្នែកហិរញ្ញវត្ថុដ៏ធំធេង និងបុព្វលាភទាបមិនគួរឱ្យជឿ។ ប្រសិនបើអ្នកចង់ពង្រីកបន្ថែមការធានារ៉ាប់រងកាន់អោយតែធំ ការធានារ៉ាប់រងរថយន្តគំរោងទូលំទូលាយ ឬស្តង់ដារ ត្រូវបានណែនាំ។ ទោះយ៉ាងណាក៏ដោយ វាមានសារៈសំខាន់ខ្លាំងណាស់ដែលអ្នកត្រូវពិនិត្យមើល ការធានានិងការមិនធានាទាំងអស់នៃគម្រោងមុនពេលទិញវា។',
      },
      item2: {
        label: 'ធានារ៉ាប់រងបន្ថែម',
        desc: 'វាក៏ជាការល្អផងដែរក្នុងការពិចារណាលើការធានារ៉ាប់រងបន្ថែមជាមួយនឹងផែនការធានារ៉ាប់រងរថយន្តរបស់អ្នក ដើម្បីបង្កើនការធានារ៉ាប់រងលើបណ្ណសន្យា និងបង្កើនអត្ថប្រយោជន៍ហិរញ្ញវត្ថុរបស់បណ្ណសន្យារ៉ាប់រង។ ជាក់ស្តែង វាអាស្រ័យលើតម្រូវការ និងថវិការបស់អ្នក ដូច្នេះសូមជ្រើសរើសតែអ្វីដែលអ្នកត្រូវការប៉ុណ្ណោះ។',
      },
      item3: {
        label: 'Insured Declared Value (IDV) ត្រឹមត្រូវ',
        desc: 'Insured Declared Value (IDV) គឺជាចំនួនអតិបរិមា ឬខ្ពស់បំផុត ដែលអ្នកនឹងទទួលពីក្រុមហ៊ុនធានារ៉ាប់រងចំពោះការខូចខាតទាំងស្រុង ឬចោរលួច នៃរថយន្តរបស់អ្នក។ ជាទូទៅ វាគឺជាតម្លៃទីផ្សារប្រហាក់ប្រហែលនៃរថយន្តរបស់អ្នក។ ដូច្នេះវាមានសារៈសំខាន់ណាស់ក្នុងការត្រួតពិនិត្យវាឱ្យបានច្បាស់លាស់មុនពេលធ្វើការសម្រេចចិត្តទិញ។ IDV ខ្ពស់ផ្តល់នូវការការពារធានារ៉ាប់រងកាន់តែច្រើន ប៉ុន្តែវាបង្កើនបុព្វលាភ។',
      },
      item4: {
        label: 'ប្រៀបធៀបសម្រង់តម្លៃធានារ៉ាប់រងរថយន្ត',
        desc: 'អ្នកអាចប្រើប្រាស់មុខងារប្រៀបធៀបសម្រង់តម្លៃធានារ៉ាប់រងរថយន្តដើម្បីស្វែងរកអត្រា និងគោលការណ៍ធានារ៉ាប់រងរថយន្តល្អបំផុតតាមតម្រូវការរបស់អ្នក។',
      },
      item5: {
        label: 'បណ្តាញយានដ្ឋាន',
        desc: 'ការពិនិត្យមើលបណ្តាញយានដ្ឋានរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរថយន្តអនុញ្ញាតឱ្យអ្នកចូលប្រើការជួសជុលដោយគ្មានទូទាត់ប្រាក់នៅកន្លែងដែលអ្នករស់នៅ។ ពិសេសអស្ចារ្យនោះ អ្នកសន្សំសំចៃប្រាក់។',
      },
      item6: {
        label: 'ដំណើរការទាមទារសំណង',
        desc: ' មូលហេតុចម្បងនៃធានារ៉ាប់រងរថយន្តគឺ ដើម្បីទទួលបានសំណងជាថ្នូរ។ នេះ​ជា​អ្វី​ដែល​ហៅ​ថា​ការ​ទាមទារសំណង​ធានា​រ៉ាប់​រង​។ ដូច្នេះហើយ វាជារឿងសំខាន់ក្នុងការត្រួតពិនិត្យដំណើរការទាមទារសំណងរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរថយន្តដែលអ្នកពេញចិត្ត ថាតើវារលូន និងងាយស្រួលដែរឬទេ។',
      },
      item7: {
        label: 'ការទូទាត់សំណង',
        desc: 'ចំនួនទឹកប្រាក់នៃសំណងដ៏គួរពេញចិត្តគឺជាអ្វីដែលអ្នកតែងតែរំពឹងចង់បានពីធានារ៉ាប់រងរថយន្តរបស់អ្នក។ វាមានសារៈសំខាន់ខ្លាំងណាស់ ដែលអ្នកពិនិត្យមើលកំណត់ត្រាទូទាត់សំណងរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរថយន្ត ដូច្នេះអ្នកអាចធានាបានថា ការទាមទាររបស់អ្នកទីបំផុតនឹងត្រូវបានទូរទាត់។',
      },
      item8: {
        label: 'ជំនួយផ្នែកអតិថិជន',
        desc: 'ពិតណាស់ថា អ្នកតែងតែចង់បានសេវាកម្មអតិថិជនដែលឆ្លើយតបគ្រប់កាលៈទេសៈ មិនថាអ្នកមានបញ្ហាគ្រោះថ្នាក់ចរាចរណ៍ ឬអ្នកត្រូវការជំនួយក្នុងការរៀបចំទាមទារសំណង។ ដូច្នេះ ចូររកមើលក្រុមហ៊ុនធានារ៉ាប់រងរថយន្ត ដែលផ្តល់ឱ្យអ្នកនូវជំនួយក្នុងរយះពេល 24x7 ហើយអ្នកតែងតែមាននរណាម្នាក់ដែលត្រូវពឹងផ្អែកជានិច្ច!',
      },
    },
    whichPlanSection: {
      title: 'តើគំរោងធានារ៉ាប់រងរថយន្តមួយណាដែលសាកសមនឹងអ្នក?',
      item1: {
        label: 'ទំនួលខុសត្រូវលើតតិយជន',
        desc: 'ធានារ៉ាប់រងរថយន្តលើតតិយជន គឺជាប្រភេទគម្រោងធានារ៉ាប់រងរថយន្តទូទៅបំផុត ដែលក្នុងគំរោងនេះ ការខាតបង់និងការខូចខាត ដែលបង្ករដល់បុគ្គលតតិយជន(ភាគីទីបី) រថយន្ត ឬទ្រព្យសម្បត្តិរបស់ពួកគេតែប៉ុណ្ណោះ ត្រូវបានធានារ៉ាប់រង។',
      },
      item2: {
        label: 'ធានារ៉ាប់រងរថយន្តទូលំទូលាយ ឬស្តង់ដារ',
        desc: 'ធានារ៉ាប់រងរថយន្តទូលំទូលាយ ឬស្តង់ដារ គឺជាប្រភេទធានារ៉ាប់រងរថយន្តដ៏មានតម្លៃបំផុតដែលធានារ៉ាប់រងលើទំនួលខុសត្រូវលើតតិយជន និង ការខាតបង់និងការខូចខាតដល់រថយន្តរបស់អ្នកដោយសារគ្រោះថ្នាក់ អគ្គីភ័យនិងចោរកម្មជាដើម។',
      },
    },
    thirdPartyAndComprehensiveSection: {
      title: 'ភាពខុសគ្នារវាង គំរោងទំនួលខុសត្រូវលើតិតយជន និង គំរោងទូលំទូលាយ ឬស្តង់ដារ',
      item1: {
        label: 'ការបាត់បង់ ឬការខូចខាត ដល់រថយន្តផ្ទាល់ខ្លួនរបស់អ្នក ដោយសារគ្រោះថ្នាក់',
        desc: 'ធានារ៉ាប់រងលើការខូចខាតដល់រថយន្តរបស់អ្នក ដោយសារគ្រោះថ្នាក់ ឬការប៉ះទង្គិច។',
        thirdParty: 'no',
        comprehensive: 'yes',
      },
      item2: {
        label: 'ការបាត់បង់ ឬការខូចខាត ដល់រថយន្តផ្ទាល់ខ្លួនរបស់អ្នកក្នុងករណីអគ្គីភ័យ',
        desc: 'ធានារ៉ាប់រងចំពោះការខូចខាតដល់រថយន្តរបស់អ្នក ដោយសារគ្រោះថ្នាក់អគ្គីភ័យ។',
        thirdParty: 'no',
        comprehensive: 'yes',
      },
      item3: {
        label: 'ចោរកម្ម',
        desc: 'ធានារ៉ាប់រងសំរាប់ការបាត់បង់ ប្រសិនបើរថយន្តរបស់អ្នកត្រូវបានចោរលួច។',
        thirdParty: 'no',
        comprehensive: 'yes',
      },
      item4: {
        label: 'ការខូចខាតដល់រថយន្តរបស់តតិយជន (ភាគីទី៣)',
        desc: 'ធានារ៉ាប់រងចំពោះការខូចខាតដែលបង្ករឡើងដោយរថយន្តរបស់អ្នកទៅកាន់រថយន្តរបស់តតិយជន',
        thirdParty: 'yes',
        comprehensive: 'yes',
      },
      item5: {
        label: 'ការខូចខាតដល់ទ្រព្យសម្បត្តិរបស់តតិយជន (ភាគីទី៣)',
        desc: 'ធានារ៉ាប់រងសំរាប់ការបាត់បង់ និងការខូចខាត ដែលបង្ករឡើយដោយរថយន្តរបស់អ្នកដល់ទ្រព្យសម្បត្តិរបស់តតិយជន',
        thirdParty: 'yes',
        comprehensive: 'yes',
      },
      item6: {
        label: 'របួសរាងកាយ ឬមរណភាពនៃបុគ្គលតតិយជន (ភាគីទី៣)',
        desc: 'ធានារ៉ាប់រងសំរាប់របួសរាងកាយ ឬមរណភាព ដែលបង្ករឡើងដោយរថយន្តរបស់អ្នក ដល់បុគ្គលតតិយជនណាមួយ',
        thirdParty: 'yes',
        comprehensive: 'yes',
      },
      item7: {
        label: 'កែប្រែ IDV',
        desc: 'ការប្ដូរ IDV នៃរថយន្តរបស់អ្នកតាមបំណងប៉ះពាល់ដល់បុព្វលាភធានារ៉ាប់រងរថយន្តរបស់អ្នក។',
        thirdParty: 'no',
        comprehensive: 'yes',
      },
      item8: {
        label: 'ធានារ៉ាប់រងបន្ថែម',
        desc: 'ផ្តល់ឱ្យរថយន្តរបស់អ្នកនូវអត្ថប្រយោជន៍បន្ថែមជាមួយនឹងធានារ៉ាប់រងបន្ថែមតាមតម្រូវការ មានដូចជា គ្រោះថ្នាក់ដល់អ្នកបើកបរនិងការទទួលខុសត្រូវចំពោះអ្នកធ្វើដំណើរ។',
        thirdParty: 'yes',
        comprehensive: 'yes',
      },
    },
    buyReasonSection: {
      title: 'ហេតុផល៨ចំណុចដែលត្រូវទិញធានារ៉ាប់រងរថយន្តជាមួយ អិមជីអេ ខូវើ',
      item1: {
        label: '១. សម្រង់តំលៃភ្លាមៗ',
        desc: 'មើលសម្រង់តម្លៃភ្លាមៗតាមអ៊ីនធឺណិតពីក្រុមហ៊ុនធានារ៉ាប់រងកំពូលៗក្នុងប្រទេសកម្ពុជាក្នុងរយៈពេលមិនដល់២នាទី។',
      },
      item2: {
        label: '២. បុព្វលាភសមរម្យ',
        desc: 'ការទិញធានារ៉ាប់រងមិនគួរជាបន្ទុកហិរញ្ញវត្ថុសម្រាប់អ្នកទេ។ យើងផ្តល់ជូននូវផែនការធានារ៉ាប់រងត្រឹមត្រូវទៅតាមថវិការបស់អ្នក។',
      },
      item3: {
        label: '៣. តម្លាភាព',
        desc: 'បេសកកម្មរបស់យើងគឺធ្វើឱ្យការធានារ៉ាប់រងរថយន្តកាន់តែមានតម្លាភាពសម្រាប់អ្នក ដើម្បីឱ្យអ្នកទទួលបានព័ត៌មានច្បាស់លាស់តាមដែលអាចធ្វើទៅបាន មុនពេលអ្នកសម្រេចចិត្តលើបណ្ណសន្យាធានារ៉ាប់រងរថយន្តរបស់អ្នក។',
      },
      item4: {
        label: '៤. ប្រៀបធៀបសម្រង់តម្លៃលើអនឡាញ',
        desc: 'អ្នកអាចប្រើប្រាស់មុខងារប្រៀបធៀបសម្រង់តម្លៃធានារ៉ាប់រងរថយន្តរបស់ MGA Cover ដើម្បីស្វែងរក អត្រានិងគោលការណ៍ធានារ៉ាប់រងរថយន្តល្អបំផុតតាមតម្រូវការរបស់អ្នក។ នេះគឺល្អណាស់សម្រាប់តម្លៃនៃប្រាក់របស់អ្នក។',
      },
      item5: {
        label: '៥. ដំណើរការទិញងាយស្រួល',
        desc: 'ឥឡូវនេះ អ្នកអាចទទួលបទពិសោធន៍លើអ៊ីនធឺណិតជាមួយយើងក្នុងការទិញធានារ៉ាប់រងរថយន្តរបស់អ្នក ជាជាងវិធីសាស្ត្របែបបុរាណ។ វាគឺរហ័ស និងងាយស្រួល ក្នុងរយៈពេលមិនដល់៥នាទី ដូច្នេះវាជួយអ្នកសន្សំសំចៃពេលវេលា និងការខិតខំប្រឹងប្រែងយ៉ាងច្រើន។',
      },
      item6: {
        label: '៦. ធានារ៉ាប់រងភ្លាមៗ',
        desc: 'មិនមានការរង់ចាំការបញ្ជាក់ពីការការពារទេ។ អ្នកត្រូវបានធានារ៉ាប់រងភ្លាមៗបន្ទាប់ពីទិញដោយជោគជ័យ។',
      },
      item7: {
        label: '៧. ដំណើរការទាមទារសំណងដោយរលូន',
        desc: 'គោលដៅរបស់យើងគឺធ្វើឱ្យការទាមទារធានារ៉ាប់រងកាន់តែងាយស្រួល។ អ្វីដែលអ្នកត្រូវធ្វើ គឺគ្រាន់តែដាក់ស្នើរការទាមទារសំណងរបស់អ្នកតាមអ៊ីនធឺណិត និងទទួលបានបទពិសោធន៍ទូទាត់សំណងដោយមិនទូទាត់ប្រាក់ រហ័ស និងងាយស្រួល។ យើងនឹងនៅជាមួយអ្នកគ្រប់ជំហាននៃដំណើរទាមទារសំណង។',
      },
      item8: {
        label: '៨. ជំនួយអតិថិជន',
        desc: 'ក្រុមបំរើសេវាកម្មអតិថិជនរបស់យើងតែងតែឈរក្បែរអ្នកជានិច្ច ដើម្បីជួយអ្នកតាមតម្រូវការរបស់អ្នក មុនឬក្រោយពេលទិញ តាមរយៈអ៊ីមែល ការជជែក និងការហៅទូរសព្ទ។',
      },
    },
    howToCompareSection: {
      title: 'តើប្រៀបធៀបសម្រង់តម្លៃធានារ៉ាប់រងរថយន្តដោយរបៀបណា?',
      subTitle: 'MGA Cover ផ្តល់មុខងារប្រៀបធៀបសម្រង់ការធានារ៉ាប់រងរថយន្ត ដើម្បីជួយអ្នកប្រៀបធៀបសម្រង់តម្លៃធានារ៉ាប់រងរថយន្តតាមអ៊ីនធឺណិតពីក្រុមហ៊ុនធានារ៉ាប់រងរថយន្តកំពូលៗក្នុងប្រទេសកម្ពុជា។ នេះគឺ ៤ជំហ៊ានដើម្បីប្រៀបធៀបសម្រង់ការធានារ៉ាប់រងរថយន្ត៖',
      item1: {
        label: 'ទទួលសម្រង់តម្លៃជាមួយ អិមជីអេ ខូវើ',
        desc: 'ជាដំបូង ចាប់ផ្តើមជាមួយនឹងសម្រង់តម្លៃភ្លាមៗ ដោយឆ្លើយសំណួរមួយចំនួនអំពីរថយន្តរបស់អ្នក ដូចជា ម៉ាក ម៉ូដែល ប្រភេទម៉ាសុីន និងឆ្នាំនៃការផលិត។',
      },
      item2: {
        label: 'ជ្រើសរើសសម្រង់តម្លៃ',
        desc: 'នៅពេលដែលអ្នកទទួលបានបញ្ជីសម្រង់តម្លៃរបស់អ្នក គ្រាន់តែចុចប៊ូតុង ប្រៀបធៀប នៅក្នុងកាតសម្រង់តម្លៃ ដើម្បីជ្រើសរើសសម្រង់តម្លៃដែលអ្នកចង់ប្រៀបធៀប។ អ្នកអាចជ្រើសរើសបានរហូតដល់ 3 សម្រង់តម្លៃសម្រាប់ការប្រៀបធៀប។',
      },
      item3: {
        label: 'ចាប់ផ្តើមបៀបធៀប',
        desc: 'បន្ទាប់ពីជ្រើសរើសសម្រង់តម្លៃដែលអ្នកចង់បាន សូមចុចបើកផ្ទាំងប្រៀបធៀបនៅខាងក្រោមទំព័រ ហើយចុចប៊ូតុង ប្រៀបធៀប ដើម្បីចាប់ផ្តើមការប្រៀបធៀប។',
      },
      item4: {
        label: 'ជ្រើសរើសគំរោងធានារ៉ាប់រងរថយន្តដែលសាកសម',
        desc: 'នៅទីនេះ អ្នកអាចប្រៀបធៀបសម្រង់តម្លៃធានារ៉ាប់រងរថយន្តដោយផ្អែកលើ បុព្វលាភធានារ៉ាប់រង ប្រភេទ ការគ្របដណ្តប់ធានារ៉ាប់រង ធានារ៉ាប់រងបន្ថែម កំរិតមិនធ្វើសំណង ការមិនធានារ៉ាប់រង និងផ្សេងៗជាច្រើនទៀត ដែលតាមរយៈការប្រៀបធៀបនេះ អ្នកអាចទិញគម្រោងធានារ៉ាប់រងរថយន្តល្អបំផុតដែលសាកសមនឹងអ្នកតំរូវតាមថវិការដ៏ត្រឹមត្រូវតាមអនឡាញដោយវិធីបង់ប្រាក់ដ៏មានសុវត្ថិភាព។',
      },
    },
    howToBuySection: {
      title: 'តើទិញធានារ៉ាប់រងរថយន្តដោយរបៀបណា?',
      subTitle: 'MGA Cover សម្រួលដំណើរការទិញធានារ៉ាប់រងរថយន្តសម្រាប់អ្នក។ អ្នកអាចទិញបណ្ណសន្យាធានារ៉ាប់រងរថយន្តរបស់អ្នកតាមអនឡាញ ដោយធ្វើតាមជំហានងាយៗដូចបានខាងក្រោម៖',
      item1: 'ចូរឆ្លើយសំណួរសាមញ្ញមួយចំនួនអំពីរថយន្តរបស់អ្នក ដូចជា ម៉ាករថយន្ត ម៉ូដែល លេខម៉ាស៊ីន និងឆ្នាំផលិត ដើម្បីទទួលបានសម្រង់តម្លៃធានារ៉ាប់រងរថយន្ត។',
      item2: 'មើលសម្រង់តម្លៃផ្សេងៗចេញពីក្រុមហ៊ុនធានារ៉ាប់រងរថយន្តផ្សេងៗគ្នាហើយប្រៀបធៀបគ្នាជាមួយព័ត៌មានលម្អិត។',
      item3: 'ជ្រើសរើសធានារ៉ាប់រងបន្ថែម (Add-on Covers) ដើម្បីបន្ថែមការការពារតាមតម្រូវការរបស់អ្នក។',
      item4: 'ជ្រើសរើសគម្រោងធានារ៉ាប់រងរថយន្តដែលមានតម្លៃសមរម្យ និងត្រឹមត្រូវរបស់អ្នក។',
      item5: 'អ្នកតម្រូវឱ្យបង្កើតគណនីមួយ ដើម្បីទិញបណ្ណសន្យាធានារ៉ាប់រងរថយន្ត',
      item6: 'បំពេញព័ត៌មានលម្អិតផ្ទាល់ខ្លួនរបស់អ្នក',
      item7: 'បង់ប្រាក់តាមអនឡាញដោយសុវត្ថិភាព។ នៅពេលដែលការទូទាត់ត្រូវបានធ្វើឡើងដោយជោគជ័យ អ្នកនឹងទទួលបានការជូនដំណឹងតាមអ៊ីមែលដែលបញ្ជាក់ថាអ្នកកំពុងត្រូវបានការពារ។',
      item8: 'អ្នកអាចចូលទៅកាន់ផ្ទាំងគ្រប់គ្រង ដើម្បីមើលប្រតិបត្តិការទូទាត់ប្រាក់ ព័ត៌មានលម្អិតអំពីបណ្ណសន្យាធានារ៉ាប់រងរថយន្ត ឬទាញយកឯកសារជា PDF។',
    },
    howToFileClaimSection: {
      title: 'តើដាក់ពាក្យទាមទារសំណងធានារ៉ាប់រងរថយន្តដោយរបៀបណា?',
      subTitle: 'អ្នកអាចដាក់ពាក្យទាមទារសំណងតាមអនឡាញនៅក្នុងផ្ទាំងគ្រប់គ្រងអ្នកប្រើប្រាស់ របស់ MGA Cover ដោយជំហានងាយៗខាងក្រោម៖',
      item1: 'ចូលគណនីរបស់អ្នក',
      item2: 'នៅក្នុងផ្ទាំងគ្រប់គ្រងរបស់អ្នក ចូរមើល បណ្ណសន្យាធានារ៉ាប់រងទាំងអស់របស់អ្នក ហើយចុចប៊ូតុង “ទាមទារសំណង” នៅលើបណ្ណសន្យាធានារ៉ាប់រងដែលអ្នកចង់ដាក់ពាក្យទាមទារសំណង។',
      item3: 'បំពេញព័ត៌មានលម្អិតដែលត្រូវការ អាប់ឡូតឯកសារទាំងឡាយដែលទាក់ទងនឹងការទាមទារសំណង ហើយបន្ទាប់មកបញ្ជូនពាក្យទាមទារសំណង។',
      item4: 'អ្នកអាចតាមដានស្ថានភាពទាមទារសំណងរបស់អ្នកនៅក្នុងម៉ឺនុយទាមទារសំណង។ ការទាមទារសំណងរបស់អ្នកនឹងត្រូវបានទូទាត់ ប្រសិនបើវាត្រូវបានអនុម័ត។',
    },
    documentClaimSection: {
      title: 'ឯកសារតម្រូវសំរាប់ដាក់ពាក្យទាមទារសំណងធានារ៉ាប់រងរថយន្តតាមអនឡាញ',
      subTitle: 'អ្នក​ត្រូវ​បាន​តម្រូវ​ឱ្យអាប់ឡូត​ឯកសារខ្លះ ឬទាំងអស់ដូច​ខាង​ក្រោម​នៅ​លើ​ថ្នាល MGA Cover ខណៈ​ពេល​ដែល​ដាក់​ស្នើ​រសុំ​សំណងធានា​រ៉ាប់​រង​រថយន្ត​របស់​អ្នក​៖',
      item1: 'បណ្ណបើកបរថតចំលង១ច្បាប់',
      item2: 'បណ្ណសំគាល់យានយន្តថតចំលង១ច្បាប់',
      item3: 'តារាងតម្លៃជួសជុលថតចំលង១ច្បាប់',
      item4: 'វិក័យបត្របង់ប្រាក់ថ្លៃជួសជុលថតចំលង១ច្បាប់',
      item5: 'រូបភាពផ្សេងៗនៃគ្រោះថ្នាក់',
      item6: 'របាយការណ៍របស់ប៉ូលីស',
    },
  },
  healthInsurancePage: {
    headerSection: {
      title: 'ធានារ៉ាប់រងសុខភាព',
      subTitle: 'ធានារ៉ាប់រងសុខភាព គឺជាឧបករណ៍ហិរញ្ញវត្ថុដ៏សំខាន់ដែលធានារ៉ាប់រងលើការចំណាយលើការព្យាបាលវេជ្ជសាស្រ្តសំរាប់ របួស និងជំងឺ។',
      item1: 'ទទួលសម្រង់តម្លៃធានារ៉ាប់រងសុខភាពភ្លាមៗដោយឥតគិតថ្លៃ',
      item2: 'បុព្វលាភសមរម្យពីក្រុមហ៊ុនធានារ៉ាប់សុខភាពកំពូលៗ',
      item3: 'ស្វែងរកវិធីសន្សំសំចៃប្រាក់លើការធានារ៉ាប់រងសុខភាព',
      item4: 'ប្រៀបធៀបអត្រាធានារ៉ាប់រងសុខភាពដោយឥតគិតថ្លៃ',
    },
    definitionSection: {
      title: 'តើធានារ៉ាប់រងសុខភាពគឺជាអ្វី?',
      description: 'ធានារ៉ាប់រងសុខភាព គឺជាប្រភេទធានារ៉ាប់រងដែលធានារ៉ាប់រងលើថ្លៃព្យាបាលវេជ្ជសាស្ត្ររបស់បុគ្គលម្នាក់ ឬក្រុមមនុស្ស ក្នុងករណីមានជំងឺ របួស ឬពិការភាព។ ធានារ៉ាប់រងសុខភាពអាចជួយអ្នកក្នុងការបង់ថ្លៃសេវាថែទាំសុខភាពផ្សេងៗដូចជា ការសម្រាកព្យាបាលនៅមន្ទីរពេទ្យ ការវះកាត់ ការទៅជួបគ្រូពេទ្យ វេជ្ជបញ្ជាឱសថ ការថែទាំបង្ការ និងច្រើនទៀត។',
    },
    benefitSection: {
      title: 'អត្ថប្រយោជន៍នៃធានារ៉ាប់រងសុខភាព',
      subTitle: 'មានបណ្ណសន្យាធានារ៉ាប់រងសុខភាព គឺជាការសម្រេចចិត្តដ៏សំខាន់បំផុតមួយ ដែលអ្នកអាចធ្វើសម្រាប់ខ្លួនអ្នក និងមនុស្សជាទីស្រលាញ់របស់អ្នក។ ការធានារ៉ាប់រងសុខភាពអាចផ្តល់ឱ្យអ្នកនូវអត្ថប្រយោជន៍ជាច្រើនដូចជា៖',
      item1: {
        label: 'ការការពារផ្នែកហិរញ្ញវត្ថុទៅនឹងថ្លៃព្យាបាលដែលមិននឹកស្មានដល់ និងតំលៃខ្ពស់',
        desc: 'ថ្លៃព្យាបាលជំងឺបានឡើងថ្លៃខ្លាំងក្នុងសម័យបច្ចុប្បន្ន ហើយជំងឺក៏ក្លាយជារឿងធម្មតាដែរ ដោយសាររបៀបរស់នៅបច្ចុប្បន្ន។ ក្នុងករណីបែបនេះ ប្រសិនបើការសង្គ្រោះបន្ទាន់ផ្នែកវេជ្ជសាស្ត្រកើតឡើង ការចំណាយដ៏ថ្លៃអាចធ្វើអោយហិនហោចប្រាក់សន្សំរបស់អ្នក។ ប័ណ្ណសន្យាធានារ៉ាប់រងសុខភាពដើរតួជាឆ្នុក ដើម្បីបញ្ឈប់ការធ្វើអោយហិនហោចនេះ។ វាទូរទាត់ថ្លៃព្យាបាល និងការពារប្រាក់សន្សំរបស់អ្នក។',
      },
      item2: {
        label: 'ទទួលបានការថែទាំសុខភាពប្រកបដោយគុណភាព',
        desc: 'ធានារ៉ាប់រងសុខភាពអាចឱ្យអ្នកចូលទៅកាន់បណ្តាញអ្នកផ្តល់សេវាថែទាំសុខភាព និងមន្ទីរពេទ្យប្រកបដោយគុណភាព ដោយមិនគិតពីប្រាក់ចំណូលរបស់អ្នក។ នេះដោយសារតែ គំរោងធានារ៉ាប់រងសុខភាពភាគច្រើន ធានារ៉ាប់រងលើសេវាវេជ្ជសាស្រ្តជាច្រើនផ្នែក រួមមានដូចជា ការថែទាំបង្ការ ការទៅជួបគ្រូពេទ្យ ការស្នាក់នៅមន្ទីរពេទ្យ និងវេជ្ជបញ្ជាថ្នាំ។',
      },
      item3: {
        label: 'លទ្ធផលសុខភាពកាន់តែប្រសើរ',
        desc: 'ការថែរក្សាសុខភាពរបស់អ្នកឱ្យបានល្អគឺជារឿងសំខាន់ ហើយធានារ៉ាប់រងសុខភាពក៏ដើរតួក្នុងរឿងនេះផងដែរ។ នៅពេលអ្នកមានការធានារ៉ាប់រង អ្នកទំនងជាស្វែងរកការថែទាំបង្ការ ដូចជាការពិនិត្យសុខភាព និងការពិនិត្យរកជំងឺប្រចាំឆ្នាំជាដើម។ ជា​លទ្ធផល បញ្ហា​សុខភាព​ណាមួយ​អាច​ត្រូវ​បាន​រក​ឃើញ​ទាន់​ពេល​វេលា និង​ធ្វើ​អន្តរាគមន៍​ទាន់​ពេល​វេលា។ នៅទីបំផុត វាធ្វើអោយប្រសើរឡើងនូវលទ្ធផលសុខភាពរយៈពេលវែងរបស់អ្នក។ នេះ​គឺ​ជា​វិធី​សាស្ត្រ​សកម្ម​ដើម្បី​រក្សា​សុខុមាលភាព​របស់​អ្នក។\n',
      },
      item4: {
        label: 'សន្តិភាពផ្លូវចិត្ត',
        desc: ' មានធានារ៉ាប់រងសុខភាពអាចផ្តល់ឱ្យអ្នកនូវសន្តិភាពផ្លូវចិត្ត ដោយដឹងថា អ្នកត្រូវបានការពារផ្នែកហិរញ្ញវត្ថុក្នុងករណីមានអាសន្នផ្នែកវេជ្ជសាស្ត្រ។ នេះអាចអនុញ្ញាតឱ្យអ្នកផ្តោតលើសុខភាព និងការជាសះស្បើយរបស់អ្នក ដោយមិនចាំបាច់ព្រួយបារម្ភអំពីថ្លៃថែទាំ។',
      },
    },
    coverSection: {
      title: 'តើអ្វីខ្លះត្រូវបានធានារ៉ាប់រងនៅក្នុងគំរោងធានារ៉ាប់រងសុខភាព?',
      subTitle: 'គំរោងធានារ៉ាប់រងសុខភាពអាចធានារ៉ាប់រងលើការចំណាយផ្នែកវេជ្ជសាស្រ្តជាច្រើន អាស្រ័យលើប្រភេទ និងវិសាលភាពនៃគំរោង។ ការចំណាយទូទៅមួយចំនួនដែលត្រូវបានរ៉ាប់រងក្នុងគម្រោងធានារ៉ាប់រងសុខភាពគឺ៖',
      item1: {
        label: 'ការសម្រាកព្យាបាលក្នុងមន្ទីរពេទ្យ',
        desc: 'តម្លៃនៃការស្នាក់នៅក្នុងមន្ទីរពេទ្យលើសពី 24 ម៉ោងដោយសារជំងឺ ឬរបួស',
      },
      item2: {
        label: 'ការចំណាយមុនពេលចូលសំរាកព្យាបាលក្នុងមន្ទីរពេទ្យ',
        desc: 'ការចំណាយដែលកើតឡើងមុនពេលចូលសំរាកព្យាបាលក្នុងមន្ទីរពេទ្យត្រូវបានធានារ៉ាប់រងរហូតដល់រយៈពេលជាក់លាក់មួយតាមលក្ខខណ្ឌនៃប័ណ្ណសន្យាធានារ៉ាប់រង។\n',
      },
      item3: {
        label: 'ការចំណាយក្រោយពីចេញពីមន្ទីរពេទ្យ',
        desc: 'ការចំណាយដែលកើតឡើងបន្ទាប់ពីចេញពីមន្ទីរពេទ្យត្រូវបានរ៉ាប់រងរហូតដល់រយៈពេលជាក់លាក់មួយដែលត្រូវបានបញ្ជាក់នៅក្នុងលក្ខខណ្ឌនៃប័ណ្ណសន្យាធានារ៉ាប់រង។ ការចំណាយទាំងនេះត្រូវបានកើតឡើងសម្រាប់ការត្រួតពិនិត្យការជាសះស្បើយរបស់អ្នកបន្ទាប់ពីការព្យាបាល។',
      },
      item4: {
        label: 'ការព្យាបាលថែទាំពេលថ្ងៃ',
        desc: 'ការព្យាបាលកំរិតស្រាល ដូចជា ការវះកាត់ភ្នែកឡើងបាយ ការដក សាច់ដុះក្នុងបំពុងកចេញ ការលាងឈាម ឬវិធីស្រដៀងគ្នា ដែលតម្រូវឱ្យមានការសម្រាកនៅមន្ទីរពេទ្យតិចជាង 24 ម៉ោងត្រូវបានធានារ៉ាប់រង ក្រោមគម្រោងធានារ៉ាប់រងសុខភាព។',
      },
      item5: {
        label: 'ការសម្រាកព្យាបាលនៅផ្ទះ',
        desc: 'តម្លៃនៃការព្យាបាលដែលធ្វើឡើងនៅផ្ទះក្រោមការត្រួតពិនិត្យផ្នែកវេជ្ជសាស្រ្ដ ដោយសារកង្វះគ្រែមន្ទីរពេទ្យ ឬស្ថានភាពអ្នកជំងឺ',
      },
      item6: {
        label: 'ថ្លៃរថយន្តសង្គ្រោះបន្ទាន់',
        desc: 'ថ្លៃដឹកជញ្ជូនទៅ និងមកពីមន្ទីរពេទ្យក្នុងស្ថានភាពសង្គ្រោះបន្ទាន់',
      },
      item7: {
        label: 'ការចំណាយលើមាតុភាព និងទារកទើបនឹងកើត',
        desc: 'ការចំណាយលើការសម្រាល ការថែទាំមុនពេលសម្រាល និងក្រោយពេលសម្រាល ការចាក់ថ្នាំបង្ការ ជាដើម សម្រាប់ម្តាយ និងទារកត្រូវបានរ៉ាប់រងក្រោមអត្ថប្រយោជន៍ និងការធានារ៉ាប់រងផ្នែកសម្ភព។ នេះមានប្រយោជន៍នៅពេលអ្នកកំពុងរៀបចំផែនការគ្រួសារ។',
      },
      item8: {
        label: 'ការពិនិត្យសុខភាពបង្ការជំងឺ',
        desc: 'គំរោងធានារ៉ាប់រងសុខភាពធានារ៉ាប់រងលើការចំណាយលើការពិនិត្យសុខភាព និងការធ្វើតេស្តជាប្រចាំ ដើម្បីរកមើលបញ្ហាសុខភាពដែលអាចកើតមាន អាស្រ័យលើលក្ខខណ្ឌនៃប័ណ្ណសន្យាធានារ៉ាប់រង។',
      },
      notice: 'ចំណាំ៖ ការធានារ៉ាប់រងនៃគំរោងធានារ៉ាប់រងសុខភាពគឺមិនដូចគ្នាសម្រាប់រាល់ប័ណ្ណសន្យាធានារ៉ាប់រងនោះទេ។ សូមយោងទៅអ្នកផ្តល់សេវាធានារ៉ាប់រងសុខភាពរបស់អ្នក ដើម្បីពិនិត្យមើលពាក្យប័ណ្ណសន្យារបស់អ្នក ដើម្បីទទួលបានបញ្ជីលម្អិតនៃការធានារ៉ាប់រង។',
    },
    noCoverSection: {
      title: 'តើអ្វីខ្លះមិនត្រូវបានធានារ៉ាប់រងនៅក្នុងគំរោងធានារ៉ាប់រងសុខភាព?',
      subTitle: 'គំរោងធានារ៉ាប់រងសុខភាពអាចនឹងមិនធានារ៉ាប់រងលើការចំណាយផ្នែកវេជ្ជសាស្រ្តមួយចំនួន ដែលត្រូវបានដកចេញពីប័ណ្ណសន្យា។ ការមិនធានារ៉ាប់រងទូទៅមួយចំនួននៅក្នុងគម្រោងធានារ៉ាប់រងសុខភាពគឺ៖',
      item1: {
        label: 'ជំងឺប្រចាំកាយដែលមានស្រាប់',
        desc: 'ជំងឺ ឬលក្ខខណ្ឌណាមួយ ដែលអ្នកត្រូវបានធានារ៉ាប់រងមានមុនពេលទិញប័ណ្ណសន្យារ៉ាប់រង ឬអំឡុងពេលរង់ចាំ។',
      },
      item2: {
        label: 'ការវះកាត់កែសម្ផស្ស',
        desc: 'ការវះកាត់ ឬវិធីណាមួយ ដែលធ្វើឡើងដើម្បីបង្កើនរូបរាង ឬភាពស្រស់ស្អាត។',
      },
      item3: {
        label: 'ការព្យាបាលធ្មេញ',
        desc: 'ការព្យាបាល ឬវិធីណាមួយ ដែលទាក់ទងនឹងធ្មេញ ឬអញ្ចាញធ្មេញ។',
      },
      item4: {
        label: 'របួសដែលបង្កដោយខ្លួនឯង',
        desc: 'របួស ឬគ្រោះថ្នាក់ណាមួយ ដែលបង្កឡើងដោយចេតនារបស់អ្នកត្រូវបានធានារ៉ាប់រង ដូចជាការធ្វើអត្តឃាត ឬការប្រើប្រាស់គ្រឿងញៀន។',
      },
      item5: {
        label: 'សង្គ្រាម និងភេរវកម្ម',
        desc: 'ការរងរបួស ឬការខូចខាតណាមួយ ដែលបណ្តាលមកពីសង្គ្រាម ភាពចលាចលស៊ីវិល កុប្បកម្ម កូដកម្ម សកម្មភាពភេរវករ។ល។',
      },
      item6: {
        label: 'ការព្យាបាលដោយពិសោធន៍',
        desc: 'ការព្យាបាល ឬវិធីណាមួយ ដែលមិនត្រូវបានបញ្ជាក់ដោយវិទ្យាសាស្រ្ត ឬអនុម័តដោយអាជ្ញាធរវេជ្ជសាស្ត្រ',
      },
      notice: 'ចំណាំ៖ ការមិនធានារ៉ាប់រងនៃគម្រោងធានារ៉ាប់រងសុខភាពគឺ មិនដូចគ្នាសម្រាប់រាល់ប័ណ្ណសន្យាធានារ៉ាប់រងនោះទេ។ សូមយោងទៅកាន់អ្នកផ្តល់សេវាធានារ៉ាប់រងសុខភាពរបស់អ្នក ដើម្បីពិនិត្យមើលពាក្យប័ណ្ណសន្យារបស់អ្នក ដើម្បីទទួលបានបញ្ជីលម្អិតនៃការមិនធានារ៉ាប់រង។',
    },
    eligibilitySection: {
      title: 'តើអ្នកណាមានសិទ្ធិទិញប័ណ្ណសន្យាធានារ៉ាប់រងសុខភាព?',
      subTitle: 'ដើម្បីទិញប័ណ្ណសន្យាធានារ៉ាប់រងសុខភាព អ្នកត្រូវបំពេញតាមតម្រូវការសិទ្ធិទទួលបានជាក់លាក់ដែលកំណត់ដោយក្រុមហ៊ុនធានារ៉ាប់រង។ តម្រូវការសិទ្ធិទទួលបានអាចប្រែប្រួលអាស្រ័យលើប្រភេទគម្រោងធានារ៉ាប់រងសុខភាព និងក្រុមហ៊ុនធានារ៉ាប់រង។ ទោះយ៉ាងណាក៏ដោយ នេះគឺជាលក្ខខណ្ឌទូទៅមួយចំនួននៃសិទ្ធិទទួលបាន៖',
      item1: {
        label: 'អាយុ',
        desc: 'អ្នកត្រូវស្ថិតនៅក្នុងចន្លោះអាយុជាក់លាក់មួយដើម្បីទិញប័ណ្ណសន្យាធានារ៉ាប់រងសុខភាព។ ឧទាហរណ៍ គម្រោងធានារ៉ាប់រងសុខភាពបុគ្គលភាគច្រើនមានអាយុអប្បបរមា 18 ឆ្នាំ និងអាយុអតិបរមា 65 ឆ្នាំ។ សំរាប់គម្រោងគ្រួសារ អាយុអប្បបរមាអាចទាបជាងសំរាប់កុមារ និងខ្ពស់ជាងនេះសំរាប់មនុស្សចាស់។',
      },
      item2: {
        label: 'ស្ថានភាពសុខភាព',
        desc: 'អ្នកត្រូវបង្ហាញប្រវត្តិសុខភាពបច្ចុប្បន្ន និងអតីតកាលរបស់អ្នក ទៅកាន់ក្រុមហ៊ុនធានារ៉ាប់រង។ អ្នកក៏ប្រហែលជាត្រូវឆ្លងកាត់ការពិនិត្យសុខភាព ឬបញ្ជូនរបាយការណ៍វេជ្ជសាស្ត្រ ដើម្បីបញ្ជាក់ពីស្ថានភាពសុខភាពរបស់អ្នក។ ក្រុមហ៊ុនធានារ៉ាប់រងអាចបដិសេធពាក្យសុំរបស់អ្នក ឬគិតថ្លៃបុព្វលាភខ្ពសពីអ្នក ប្រសិនបើអ្នកមានជំងឺដែលមានពីមុនមក ឬកត្តាហានិភ័យខ្ពស់ ដូចជាការជក់បារី ភាពធាត់ជាដើម។ល។',
      },
      item3: {
        label: 'មុខរបរ',
        desc: 'អ្នកត្រូវផ្តល់មុខរបររបស់អ្នក។ ក្រុមហ៊ុនធានារ៉ាប់រងអាចផ្តល់ជូនអ្នកនូវគម្រោង និងបុព្វលាភផ្សេងៗគ្នា ដោយផ្អែកលើមុខរបររបស់អ្នក។ ជាឧទាហរណ៍ គំរោងមួយចំនួនអាចត្រូវបានរចនាឡើងសម្រាប់អ្នកជំនាញ ដូចជាវេជ្ជបណ្ឌិត មេធាវី វិស្វករជាដើម។ល។',
      },
    },
    buyEarlySection: {
      title: 'សារៈសំខាន់នៃការទិញគំរោងធានារ៉ាប់រងសុខភាពនៅអាយុតិច',
      subTitle: 'ការទិញគម្រោងធានារ៉ាប់រងសុខភាពតាំងពីតូចគឺជាការសម្រេចចិត្តដ៏ឈ្លាសវៃ និងមានប្រយោជន៍។ ការទិញគម្រោងធានារ៉ាប់រងសុខភាពនៅវ័យក្មេងអាចផ្តល់ឱ្យអ្នកនូវអត្ថប្រយោជន៍ជាច្រើនដូចជា៖',
      item1: {
        label: 'បុព្វលាភទាប',
        desc: 'បុព្វលាភនៃគម្រោងធានារ៉ាប់រងសុខភាពអាស្រ័យលើអាយុ និងស្ថានភាពសុខភាពរបស់អ្នក។ អ្នកកាន់តែក្មេង និងមានសុខភាពល្អ បុព្វលាភដែលអ្នកត្រូវបង់កាន់តែទាប។ នៅពេលអ្នកកាន់តែចាស់ បុព្វលាភនឹងកើនឡើងដោយសារតែហានិភ័យខ្ពស់នៃជំងឺ និងរបួស។',
      },
      item2: {
        label: 'ការធានារ៉ាប់រងរយៈពេលវែង',
        desc: 'អ្នកត្រូវបានធានារ៉ាប់រងកាន់តែយូរ អ្នកអាចទទួលបានអត្ថប្រយោជន៍កាន់តែច្រើន។ អ្នក​អាច​ទទួល​បាន​ធានា​រ៉ាប់រង​ក្នុង​រយៈ​ពេល​យូរ​ ហើយ​ជៀសវាង​ចន្លោះ​ប្រហោង ​ឬ​ផុតសុពលភាព ក្នុងប័ណ្ណសន្យាធានារ៉ាប់រង​របស់​អ្នក។ អ្នកក៏អាចបន្ត ប័ណ្ណសន្យាធានារ៉ាប់រងរបស់អ្នកជាមួយនឹងប្រាក់រង្វាន់ភាពស្មោះត្រង់ដ៏សន្ធឹកសន្ធាប់ និងដោយគ្មានការរំខាន ឬការរឹតបន្តឹងណាមួយឡើយ។',
      },
      item3: {
        label: 'ជម្រើសកាន់តែទូលំទូលាយ',
        desc: 'នៅពេលដែលអ្នកទិញគំរោងធានារ៉ាប់រងសុខភាពនៅអាយុកាន់តែក្មេង អ្នកមានជំរើសកាន់តែច្រើនត្រូវជ្រើសរើស។ អ្នកអាចជ្រើសរើសគម្រោង ដែលសាកសមបំផុតនឹងតម្រូវការ និងចំណូលចិត្តរបស់អ្នក។ អ្នកក៏អាចផ្លាស់ប្តូរ ឬដំឡើងកំរិត (upgrade) គំរោងរបស់អ្នកតាមតម្រូវការ និងការរំពឹងទុករបស់អ្នក។',
      },
    },
    frequentlyAskedQuestionSection: {
      title: 'សំណួរដែលសួរញឹកញាប់អំពីធានារ៉ាប់រងសុខភាព',
      q1: 'តើហេតុអ្វីខ្ញុំគួរតែទិញធានារ៉ាប់រងសុខភាព?',
      a1: 'ធានារ៉ាប់រងសុខភាព គឺជាខែលដ៏សំខាន់មួយ ព្រោះវាផ្តល់ការការពារផ្នែកហិរញ្ញវត្ថុប្រឆាំងនឹងការចំណាយថ្លៃពេទ្យ និងសេវាថែទាំសុខភាព។ អ្នកអាចទទួលបានការថែទាំវេជ្ជសាស្រ្តទាន់ពេលវេលា និងប្រកបដោយគុណភាព ដោយមិនបារម្ភពីបន្ទុកធ្ងន់នៃការចំណាយ។ វាផ្តល់នូវសន្តិភាពផ្លូវចិត្ត ការការពារប្រឆាំងនឹងការសង្គ្រោះបន្ទាន់ផ្នែកវេជ្ជសាស្រ្តដែលមិនបានរំពឹងទុក និងលើកកម្ពស់សុខុមាលភាពទូទៅដោយលើកទឹកចិត្តឱ្យមានការពិនិត្យមើលសុខភាព ការពិនិត្យរកជំងឺ និងការថែទាំបង្ការជាប្រចាំ។',
      q2: 'តើអាយុប៉ុន្មានដែលសមស្របដើម្បីទិញធានារ៉ាប់រងសុខភាព?',
      a2: 'មិន​មាន​កំណត់អាយុ​សមស្របដើម្បី​ទិញ​ធានា​រ៉ាប់រង​សុខភាព​ទេ ប៉ុន្តែ​អាយុ​ដែល​មាន​សិទ្ធិ​សមរម្យ​សម្រាប់​មនុស្ស​ពេញវ័យ​គឺ​នៅ​ចន្លោះ​ពី 18 ទៅ 65 ឆ្នាំ រីឯអាយុ​ដែល​មាន​សិទ្ធិ​ទទួល​បាន​សម្រាប់​កុមារ​មាន​ចន្លោះ​ពី 90 ថ្ងៃ​ដល់​ទៅ 18 ឆ្នាំ។ វាត្រូវបានណែនាំឱ្យអ្នកទិញធានារ៉ាប់រងសុខភាពពីក្មេង  អ្នកទទួលបានបុព្វលាភកាន់តែទាប ពីព្រោះថា អ្នកនៅក្មេង និងមានសុខភាពល្អ ហើយមិនសូវងាយនឹងកើតជំងឺធ្ងន់ធ្ងរ និងសំរាកព្យាបាលនៅក្នុងមន្ទីរពេទ្យនោះទេ បើប្រៀបធៀបទៅនឹងនរណាម្នាក់ក្នុងវ័យ ៥០ និង ៦០ ឆ្នាំ។',
      q3: 'តើការចូលសម្រាកព្យាបាលក្នុងមន្ទីរពេទ្យដោយមិនបាច់បង់ប្រាក់មានន័យដូចម្តេចនៅក្នុងប័ណ្ណសន្យាធានារ៉ាប់រងសុខភាព?',
      a3: 'ការសម្រាកព្យាបាលក្នុងមន្ទីរពេទ្យដោយមិនបាច់បង់ប្រាក់នៅក្នុងប័ណ្ណសន្យាធានារ៉ាប់រងសុខភាពមានន័យថា អ្នកអាចចូលសម្រាកព្យាបាលក្នុងមន្ទីរពេទ្យ និងទទួលការព្យាបាល ដោយមិនចាំបាច់បង់ប្រាក់ជាមុន។ ក្រុមហ៊ុនធានារ៉ាប់រងនឹងបង់ថ្លៃមន្ទីរពេទ្យដោយផ្ទាល់ជំនួសអ្នក តាមលក្ខខណ្ឌនៃប័ណ្ណសន្យា។ ក្រុមហ៊ុនធានារ៉ាប់រងទាំងអស់មានភាពជាដៃគូជាមួយបណ្តាញមន្ទីរពេទ្យដ៏ច្រើន ដែលបុគ្គលដែលត្រូវបានធានារ៉ាប់រងអាចទទួលបានការព្យាបាលដោយមិនបាច់បង់ប្រាក់។ អ្នកគ្រាន់តែផ្តល់ព័ត៌មានធានារ៉ាប់រងរបស់អ្នកទៅកាន់មន្ទីរពេទ្យ។',
      q4: 'តើការស្នាក់នៅមន្ទីរពេទ្យក្នុងធានារ៉ាប់រងសុខភាពជាអ្វី?',
      a4: 'ការស្នាក់នៅក្នុងមន្ទីរពេទ្យក្នុងការធានារ៉ាប់រងសុខភាព គឺជាការធានារ៉ាប់រងលើការចំណាយដែលទាក់ទងនឹងការស្នាក់នៅក្នុងមន្ទីរពេទ្យ ដូចជាបន្ទប់ អាហារ និងគ្រឿងបរិក្ខារផ្សេងៗទៀត។ គម្រោងធានារ៉ាប់រងសុខភាពភាគច្រើននឹងរ៉ាប់រងថ្លៃខ្លះ ឬទាំងអស់នៃថ្លៃស្នាក់នៅក្នុងមន្ទីរពេទ្យ ប៉ុន្តែការធានារ៉ាប់រងជាក់លាក់នឹងប្រែប្រួលអាស្រ័យលើគម្រោង។',
      q5: 'តើការបង់ថ្លៃរួមគ្នានៃគំរោងធានារ៉ាប់រងសុខភាពគឺជាអ្វី?',
      a5: 'ការបង់ប្រាក់រួមគ្នានៃគម្រោងធានារ៉ាប់រងសុខភាព គឺជាចំនួនប្រាក់ថេរដែលអ្នកត្រូវចំណាយសម្រាប់សេវាវេជ្ជសាស្រ្តមួយចំនួន ដូចជា ការទៅជួបគ្រូពេទ្យ ឬវេជ្ជបញ្ជាថ្នាំ។ ឧទាហរណ៍ អ្នកអាចមានការបង់ប្រាក់រួមចំនួន $20 សម្រាប់ការទៅជួបគ្រូពេទ្យម្តងៗ។',
      q6: 'តើលក្ខខណ្ឌដែលមានស្រាប់នៅក្នុងធានារ៉ាប់រងសុខភាពគឺជាអ្វី?',
      a6: 'លក្ខខណ្ឌដែលមានស្រាប់នៅក្នុងធានារ៉ាប់រងសុខភាពគឺជា ជំងឺ របួស ឬលក្ខខណ្ឌវេជ្ជសាស្ត្រ ដែលអ្នកមានមុនពេលដាក់ពាក្យសុំគម្រោងធានារ៉ាប់រងសុខភាពថ្មី។ នេះអាចរួមបញ្ចូល លក្ខខណ្ឌរ៉ាំរ៉ៃ ដូចជាជំងឺហឺត ជំងឺទឹកនោមផ្អែម ឬជំងឺបេះដូង ព្រមទាំងលក្ខខណ្ឌធ្ងន់ធ្ងរ ដូចជាការបាក់ឆ្អឹង ឬការវះកាត់ថ្មីៗ។',
      q7: 'តើ​នឹង​មាន​អ្វី​កើត​ឡើង​ប្រសិន​បើ​ប័ណ្ណសន្យធានារ៉ាប់រងរបស់​ខ្ញុំ​ហួសថ្ងៃកំណត់​ពេល​ខ្ញុំ​សម្រាកព្យាបាល​នៅ​មន្ទីរពេទ្យ?',
      a7: 'ប្រសិនបើ ប័ណ្ណសន្យាធានារ៉ាប់រងសុខភាពរបស់អ្នកហួសថ្ងៃកំណត់ ខណៈពេលដែលអ្នកកំពុងសម្រាកព្យាបាលនៅក្នុងមន្ទីរពេទ្យ អ្នកនឹងទទួលខុសត្រូវចំពោះការបង់ថ្លៃព្យាបាលទាំងអស់ចេញពីហោប៉ៅរបស់អ្នក។ នេះអាចជាបន្ទុកផ្នែកហិរញ្ញវត្ថុដ៏ធ្ងន់ធ្ងរ ជាពិសេស ប្រសិនបើអ្នកមានការសម្រាកព្យាបាលនៅមន្ទីរពេទ្យរយៈពេលយូរ ឬស្មុគស្មាញ។\n\nក្រុមហ៊ុនធានារ៉ាប់រងមួយចំនួនអាចផ្តល់រយៈពេលអនុគ្រោះ បន្ទាប់ពី ប័ណ្ណសន្យាធានារ៉ាប់រងរបស់អ្នកផុតកំណត់។ នេះមានន័យថា អ្នកអាចមានពេលវេលាជាក់លាក់មួយដើម្បីបន្តប័ណ្ណសន្យាធានារ៉ាប់រងរបស់អ្នក មុនពេលធានារ៉ាប់រងរបស់អ្នកត្រូវបានបញ្ចប់។ ប្រសិនបើ អ្នកបន្តប័ណ្ណសន្យាធានារ៉ាប់រងរបស់អ្នកក្នុងអំឡុងពេលអនុគ្រោះ អ្នកនឹងនៅតែត្រូវបានធានារ៉ាប់រងសម្រាប់ការសម្រាកព្យាបាលនៅមន្ទីរពេទ្យរបស់អ្នក។\n\nប៉ុន្តែ ប្រសិនបើអ្នកមិនបន្តប័ណ្ណសន្យាធានារ៉ាប់រងរបស់អ្នកក្នុងអំឡុងពេលអនុគ្រោះទេ ការធានារ៉ាប់រងរបស់អ្នកនឹងត្រូវបានបញ្ចប់ ហើយអ្នកនឹងទទួលខុសត្រូវចំពោះការបង់ថ្លៃព្យាបាលរបស់អ្នកទាំងអស់ចេញពីហោប៉ៅ។',
    },
    disclaimer: 'ការបដិសេធ៖ ទំព័រនេះ គឺសម្រាប់តែការអប់រំផ្នែកធានារ៉ាប់រងសុខភាពប៉ុណ្ណោះ។ វាមិនឆ្លុះបញ្ចាំងពីគោលការណ៍ធានារ៉ាប់រងណាមួយឡើយ។',
  },
  healthQuoteForm: {
    members: {
      title: 'ជ្រើសរើសបុគ្គលដែលអ្នកចង់ធានា',
      gender: 'ភេទរបស់អ្នក',
    },
    birthdates: {
      title: 'បំពេញថ្ងៃខែឆ្នាំកំណើត',
    },
    policyEffectiveDate: {
      title: 'កំណត់កាលបរិច្ឆេទមានប្រសិទ្ធភាព',
    },
  },
  healthQuote: {
    contact: {
      title: 'ប្រាប់យើងអំពីខ្លួនអ្នក',
    },
    authorizedNote: 'ខ្ញុំអនុញ្ញាតឱ្យ MGA Cover ទាក់ទងជាមួយខ្ញុំតាមលេខដែលបានផ្តល់ឱ្យសម្រាប់តម្រូវការធានារ៉ាប់រងរបស់ខ្ញុំ។',
    totalPlans: 'ធានារ៉ាប់រងសុខភាពមាន {{count}} គម្រោង',
    annualLimit: 'ដែនកំណត់ប្រចាំឆ្នាំ',
    coveredMembers: 'សមាជិកត្រូវបានធានា',
    geographicCoverage: 'ភូមិសាស្ត្រគ្របដណ្តប់',
    hospitalAccommodation: 'ការស្នាក់នៅមន្ទីរពេទ្យ',
    copay: 'ការបង់ប្រាក់រួម',
    waitingPeriod: 'រយៈពេលរង់ចាំ',
    cashlessHospitals: 'បណ្តាញមន្ទីរពេទ្យដៃគូ',
    premium: 'បុព្វលាភធានារ៉ាប់រង',
    planDetails: 'គម្រោងលំអិត',
    viewMore: '{{count}} គម្រោងបន្ថែម',
    myAge: 'ខ្លួនខ្ញុំ ({{age}} ឆ្នាំ)',
    medicalQuestions: {
      error: {
        title: 'មានសមាជិកដែលមិនបានបំពេញគ្រប់លក្ខខណ្ឌ',
        description: 'សមាជិកដែលបានរាយបញ្ជីខាងក្រោមមិនត្រូវបានបំពេញតាមតម្រូវការទាំងអស់ដែលទាមទារដោយក្រុមហ៊ុនធានារ៉ាប់រងនោះទេ។\nដើម្បីបន្តទៅមុខទៀត អ្នកត្រូវតែប្រាកដថាអ្នក និងសមាជិកណាម្នាក់មិនមានបញ្ហាសុខភាពដូចបានរៀបរាប់ខាងលើ ឬអ្នកដកសមាជិកដែលមិនមានលក្ខណៈសម្បត្តិគ្រប់គ្រាន់ចេញពីសម្រង់ ដើម្បីអ្នកនឹងទទួលបានសម្រង់ដែលបានកែសម្រួល។',
      },
    },
    medicalCondition: 'សូម​ជួយ​យើង​ឱ្យ​ដឹង​ពី​ស្ថានភាព​សុខភាព ប្រសិន​បើ​មាន យើង​នឹង​សុំ​តែ​ព័ត៌មាន​លម្អិត​ដែល​ក្រុមហ៊ុន​ធានា​រ៉ាប់រង​ត្រូវ​ការ',
    filters: 'តម្រងច្រោះទិន្នន័យ',
    ipd: 'សម្រាកក្នុងមន្ទីរពេទ្យ',
    opd: 'មិនសម្រាកក្នុងមន្ទីរពេទ្យ',
    maternity: 'មានផ្ទៃពោះនិងសម្រាលកូន',
    healthCheckup: 'ការពិនិត្យសុខភាព',
    vision: 'ការព្យាបាលភ្នែក',
    dental: 'ការព្យាបាលធ្មេញ',
  },
  healthPlanBenefitTypes: {
    hospitalAndSurgery: '',
    inpatient: 'អត្ថប្រយោជន៍សំរាប់ការព្យាបាលជំងឺសម្រាកក្នុងមន្ទីរពេទ្យ',
    outpatient: 'អត្ថប្រយោជន៍សំរាប់ការព្យាបាលជំងឺមិនសម្រាកក្នុងមន្ទីរពេទ្យ',
    healthCheckup: 'អត្ថប្រយោជន៍សំរាប់ការពិនិត្យសុខភាព',
    dental: 'អត្ថប្រយោជន៍សំរាប់ការព្យាបាលធ្មេញ',
    maternity: 'អត្ថប្រយោជន៍សំរាប់ពេលមានផ្ទៃពោះ និងសម្រាលកូន',
    vision: 'អត្ថប្រយោជន៍សំរាប់ការព្យាបាលភ្នែក',
    copay: 'អត្ថប្រយោជន៍សំរាប់ការបង់ប្រាក់រួម',
    others: 'អត្ថប្រយោជន៍ផ្សេងៗ',
    generalPersonalAccident: 'អត្ថប្រយោជន៍សំរាប់គ្រោះថ្នាក់បុគ្គលទូទៅ',
    ipdHospitalAndSurgicalBenefits: 'អត្ថប្រយោជន៍សំរាប់ការព្យាបាលជំងឺសម្រាកក្នុងមន្ទីរពេទ្យ និងវះកាត់',
    ipdHospitalRoomAndBoard: 'បន្ទប់មន្ទីរពេទ្យ និងអាហារ',
    ipdIcuAndSimilar: 'ICU និងស្រដៀងគ្នា',
    ipdHospitalGeneralExpenses: 'ការចំណាយទូទៅរបស់មន្ទីរពេទ្យ',
    ipdSurgicalBenefits: 'អត្ថប្រយោជន៍នៃការវះកាត់',
    ipdPsychiatricCare: 'ការថែទាំផ្លូវចិត្ត',
    ipdCashAllowance: 'ប្រាក់ឧបត្ថម្ភសាច់ប្រាក់',
    ipdEmergencyTransportationFee: 'ថ្លៃដឹកជញ្ជូនបន្ទាន់',
    opdBenefits: 'អត្ថប្រយោជន៍ OPD',
    opdPrescribed: 'បានចេញវេជ្ជបញ្ជា',
    healthCheckupBenefits: 'អត្ថប្រយោជន៍សំរាប់ការពិនិត្យសុខភាព',
    maternityBenefits: 'អត្ថប្រយោជន៍សំរាប់ពេលមានផ្ទៃពោះ និងសម្រាលកូន',
    visionBenefits: 'អត្ថប្រយោជន៍សំរាប់ការព្យាបាលភ្នែក',
    copayBenefits: 'អត្ថប្រយោជន៍សំរាប់ការបង់ប្រាក់រួម',
    dentalBenefits: 'អត្ថប្រយោជន៍សំរាប់ការព្យាបាលធ្មេញ',
    otherBenefits: 'អត្ថប្រយោជន៍ផ្សេងៗ',
    otherPreExistingCondition: 'លក្ខខណ្ឌដែលមានស្រាប់',
    otherChronicCondition: 'ស្ថានភាពរ៉ាំរ៉ៃ',
    otherAidHiv: 'អេដស៍/មេរោគអេដស៍',
    otherCongenitalCondition: 'ស្ថានភាពពីកំណើត',
    otherCovid19: 'កូវីត 19',
    generalPersonalAccidentBenefits: 'អត្ថប្រយោជន៍សំរាប់គ្រោះថ្នាក់បុគ្គលទូទៅ',
  },
  healthQuoteDetailsPage: {
    coverAmount: 'ចំនួនទឹកប្រាក់ធានា',
    policyWording: 'សេចក្តីលំអិតនៃប័ណ្ណសន្យារ៉ាប់រង',
    planBrochure: 'ខិត្តប័ណ្ណគំរោង',
    membersCovered: {
      title: 'សមាជិកត្រូវបានធានា',
      edit: 'កែប្រែសមាជិក',
    },
  },
  healthQuoteBuyPage: {
    title: 'ទិញបណ្ណសន្យាធានារ៉ាប់រង',
    subTitle: 'សូមបំពេញព័ត៌មានលម្អិតអំពីអ្នកត្រូវបានធានារ៉ាប់រងដែលអ្នកចង់បញ្ចូលក្នុងបណ្ណសន្យាតែមួយ ហើយបន្ទាប់មកឆ្លើយកម្រងសំណួរ',
  },
  healthQuoteReviewPage: {
    memberDetailsTitle: 'ពត័មានលម្អិតរបស់សមាជិក',
  },
  ordinalItem_one: '{{item}}ទី {{count}}',
  ordinalItem_two: '{{item}}ទី {{count}}',
  ordinalItem_few: '{{item}}ទី {{count}}',
  ordinalItem_other: '{{item}}ទី {{count}}',
  personalAccidentInsurancePage: {
    headerSection: {
      title: 'ធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល',
      subTitle: 'គ្រោះថ្នាក់អាចធ្វើអោយអន្តរាយដល់បុគ្គលខ្លួនឯង និងបុគ្គលជាទីស្រលាញ់។',
      item1: 'ទទួលសម្រង់តម្លៃធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលភ្លាមៗដោយឥតគិតថ្លៃ',
      item2: 'បុព្វលាភសមរម្យពីក្រុមហ៊ុនធានារ៉ាប់គ្រោះថ្នាក់បុគ្គលកំពូលៗ',
      item3: 'ស្វែងរកវិធីសន្សំសំចៃប្រាក់លើការធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល',
      item4: 'ប្រៀបធៀបអត្រាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលដោយឥតគិតថ្លៃ',
    },
    definitionSection: {
      title: 'តើធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលគឺជាអ្វី?',
      description: 'ធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល គឺជាប្រភេទប័ណ្ណសន្យាធានារ៉ាប់រង ដែលផ្តល់ការការពារផ្នែកហិរញ្ញវត្ថុ ក្នុងករណីមរណភាពដោយចៃដន្យ ពិការភាពមួយផ្នែក ឬទាំងស្រុងជាអចិន្ត្រៃយ៍ ហើយនឹងពិការភាពជាបណ្តោះអាសន្ន ឬការចំណាយលើការព្យាបាលផងដែរ។ វាធានាថា អ្នកនិងមនុស្សជាទីស្រលាញ់របស់អ្នកនឹងមានសុវត្ថិភាពផ្នែកហិរញ្ញវត្ថុក្នុងករណីមានគ្រោះថ្នាក់ដែលមិននឹកស្មានដល់។\n\nឧបទ្ទវហេតុអាចកើតឡើងគ្រប់ទីកន្លែងគ្រប់ពេលវេលា ហើយធ្វើឱ្យជីវិតរបស់អ្នកក្រឡាប់ផ្ងារ «អ្នកមិនត្រឹមតែនឹងត្រូវបានទទួលរងផលប៉ះពាល់ផ្លូវកាយ និងផ្លូវចិត្តប៉ុណ្ណោះទេ វាក៏អាចក្លាយជាបន្ទុកហិរញ្ញវត្ថុផងដែរ»។ ប្រសិនបើ សំណាងល្អ អ្នកមានប័ណ្ណសន្យាធានារ៉ាប់រងសុខភាព វាអាចគ្រាន់តែធានារ៉ាប់រងការចំណាយលើថ្លៃព្យាបាលស្តង់ដារ ដូចជាការចំណាយលើការសម្រាកព្យាបាលក្នុងមន្ទីរពេទ្យជាដើម។\n\nឧទាហរណ៍៖ ប្រសិនបើអ្នកធ្លាក់ពីលើជណ្តើរ ហើយបាក់ឆ្អឹង ឬរបួសក្បាល អ្នកប្រហែលជាត្រូវប្រឈមមុខនឹងថ្លៃព្យាបាលយ៉ាងច្រើន។ ជាមួយនឹងអត្ថប្រយោជន៍ធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល អ្នកនឹងអាចទទួលបានចំនួនទឹកប្រាក់ជាក់លាក់មួយ ដើម្បីរ៉ាប់រងលើការចំណាយផ្នែកវេជ្ជសាស្រ្ត និងការចំណាយផ្សេងៗ ហើយក៏ដូចជាការបាត់បង់ប្រាក់ចំណូលខណៈពេលដែលអ្នកកំពុងតែជាសះស្បើយពីរបួសនេះ ដូចច្នេះហើយ អ្នកអាចមានទំនុកចិត្តអំពីស្ថិរភាពហិរញ្ញវត្ថុរបស់អ្នក។\n',
    },
    whyNeedSection: {
      title: 'តើហេតុអ្វីអ្នកត្រូវការធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល?',
      item1: {
        label: 'ការការពារផ្នែកហិរញ្ញវត្ថុក្នុងករណីមរណភាពដោយចៃដន្យ',
        desc: 'ប្រសិនបើអ្នកស្លាប់ដោយសារគ្រោះថ្នាក់ អ្នកទទួលផលរបស់អ្នកនឹងទទួលបានប្រាក់សំណង ដើម្បីដោះស្រាយបញ្ហានឹងការចាកចេញរបស់អ្នក។ នេះអាចជួយឱ្យពួកគេចំណាយសម្រាប់ពិធីបុណ្យសព បំណុលដែលនៅសេសសល់ និងការចំណាយលើការរស់នៅ។',
      },
      item2: {
        label: 'ការការពារផ្នែកហិរញ្ញវត្ថុក្នុងករណីពិការភាពដោយចៃដន្យ',
        desc: 'ប្រសិនបើអ្នកទទួលរងនូវពិការភាពទាំងស្រុង ឬមួយផ្នែក ជាអចិន្ត្រៃយ៍ ដែលជាលទ្ធផលនៃគ្រោះថ្នាក់ចៃដន្យ អ្នកនឹងទទួលបានប្រាក់សំណង ដើម្បីជួយធានារ៉ាប់រងលើប្រាក់ចំណូលដែលបាត់បង់និងថ្លៃព្យាបាលរបស់អ្នក។ ជាធម្មតាចំនួនទឹកប្រាក់នៃអត្ថប្រយោជន៍នឹងអាស្រ័យលើភាពធ្ងន់ធ្ងរនៃពិការភាពរបស់អ្នក។',
      },
      item3: {
        label: 'សំណងថ្លៃព្យាបាល',
        desc: 'ប្រសិនបើអ្នករងរបួសក្នុងឧបទ្ទវហេតុ ថ្លៃព្យាបាលរបស់អ្នកនឹងត្រូវបានសងវិញដោយក្រុមហ៊ុនធានារ៉ាប់រង។ នេះអាចរាប់បញ្ចូលទាំងថ្លៃចូលមន្ទីរពេទ្យ ការវះកាត់ និងថ្លៃព្យាបាលផ្សេងៗទៀត។',
      },
      item4: {
        label: 'សន្តិភាពផ្លូវចិត្ត',
        desc: 'ការដឹងថាអ្នកមានការធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល អាចផ្តល់ឱ្យអ្នកនូវសន្តិភាពផ្លូវចិត្ត។ អ្នកអាចធានាបានថា អ្នកនិងមនុស្សជាទីស្រលាញ់របស់អ្នកនឹងត្រូវបានការពារផ្នែកហិរញ្ញវត្ថុក្នុងករណីមានគ្រោះថ្នាក់ដែលមិននឹកស្មានដល់។',
      },
    },
    coverSection: {
      title: 'តើអ្វីខ្លះត្រូវបានធានារ៉ាប់រងនៅក្នុងធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល?',
      item1: {
        label: 'មរណភាពដោយចៃដន្យ',
        desc: 'ប្រសិនបើ អ្នកស្លាប់ដោយសារឧបទ្ទវហេតុ គ្រួសាររបស់អ្នកនឹងទទួលបានប្រាក់សំណងជាក់លាក់មួយចំនួន។ វាដើរតួជាជំនួយហិរញ្ញវត្ថុនៅពេលដែលពួកគេត្រូវការវាជាចាំបាច់បំផុត។ ចំនួនទឹកប្រាក់នៃអត្ថប្រយោជន៍មរណភាពប្រែប្រួលអាស្រ័យលើគោលការណ៍ដែលអ្នកជ្រើសរើស។',
      },
      item2: {
        label: 'ពិការភាពទាំងស្រុងជាអចិន្ត្រៃយ៍',
        desc: 'នៅពេលដែលឧបទ្ទវហេតុបណ្តាលឱ្យមានពិការភាពទាំងស្រុងជាអចិន្ត្រៃយ៍ ទឹកប្រាក់ជាក់លាក់មួយចំនួននឹងត្រូវទូរទាត់ឱ្យអ្នក។ ពិការភាពទាំងស្រុងជាអចិន្ត្រៃយ៍  មានន័យថាអ្នកមិនអាចធ្វើការ ឬបំពេញភារកិច្ចសំខាន់ៗណាមួយនៃមុខរបររបស់អ្នក។',
      },
      item3: {
        label: 'ពិការភាពដោយផ្នែកជាអចិន្ត្រៃយ៍',
        desc: 'ចំនួនទឹកប្រាក់សំណងជាក់លាក់ត្រូវបានទូរទាត់ឱ្យអ្នកក្នុងករណីពិការភាពដោយផ្នែកអចិន្ត្រៃយ៍ ដែលបណ្តាលមកពីគ្រោះថ្នាក់។ ពិការភាពដោយផ្នែកអចិន្ត្រៃយ៍មានន័យថា អ្នកអាចធ្វើការបាន ប៉ុន្តែសមត្ថភាពរកប្រាក់ចំណូលរបស់អ្នកត្រូវបានថយចុះ។',
      },
      item4: {
        label: 'ពិការភាពបណ្តោះអាសន្ន',
        desc: 'ប្រសិនបើ អ្នកមិនអាចធ្វើការបានមួយរយៈ ដោយសារតែពិការភាពបណ្តោះអាសន្នដែលបណ្តាលមកពីគ្រោះថ្នាក់ អ្នកអាចទទួលបានសំណងជាក់លាក់មួយចំនួន ដើម្បីរ៉ាប់រងការចំណាយប្រចាំថ្ងៃរបស់អ្នក។',
      },
      item5: {
        label: 'ថ្លៃព្យាបាលវេជ្ជសាស្ត្រ',
        desc: 'វាធានារ៉ាប់រងលើវិក្កយបត្រវេជ្ជសាស្រ្តរបស់អ្នកដោយសារគ្រោះថ្នាក់។ វាជួយសម្រាលបន្ទុកហិរញ្ញវត្ថុរបស់អ្នក ចាប់ពីការស្នាក់នៅព្យាបាលក្នុងមន្ទីរពេទ្យរហូតដល់ការវះកាត់។',
      },
    },
    noCoverSection: {
      title: 'តើអ្វីខ្លះមិនត្រូវបានធានារ៉ាប់រងនៅក្នុងធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល?',
      item1: {
        label: 'របួសបង្កដោយខ្លួនឯង',
        desc: 'របួសដែលបង្កឡើងដោយបុគ្គលដែលត្រូវបានធានារ៉ាប់រង ដោយចេតនាធ្វើឱ្យខ្លួនឯងមានគ្រោះថ្នាក់ នោះមិនត្រូវបានធានារ៉ាប់រងដោយធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលឡើយ។ ការណ៍នេះរាប់បញ្ចូលទាំង ការធ្វើអត្តឃាត ការធ្វើទុក្ខបុកម្នេញលើខ្លួនឯង និងរបួសដែលកើតឡើងក្នុងពេលប៉ុនប៉ងធ្វើបាបអ្នកដទៃ។',
      },
      item2: {
        label: 'លក្ខខណ្ឌដែលមានស្រាប់',
        desc: 'ធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល ជាទូទៅមិនធានាលើរបួស ឬជំងឺដែលមាន មុនពេលទិញប័ណ្ណសន្យាធានារ៉ាប់រងនោះទេ។ ប្រសិនបើ ឧបទ្ទវហេតុធ្វើឱ្យស្ថានភាពដែលមានស្រាប់កាន់តែធ្ងន់ធ្ងរឡើង ធានារ៉ាប់រងអាចធានាត្រឹមតែផ្នែកនៃរបួស ឬជំងឺដែលបណ្តាលមកពីគ្រោះថ្នាក់ដោយផ្ទាល់ប៉ុណ្ណោះ។',
      },
      item3: {
        label: 'មរណភាពដោយមូលហេតុធម្មជាតិ',
        desc: 'មរណភាពដោយមូលហេតុធម្មជាតិ ដូចជា ជំងឺ ឬចាស់ជរា មិនត្រូវបានធានារ៉ាប់រងទេ។',
      },
      item4: {
        label: 'របួសដែលកើតឡើងនៅពេលចូលរួមក្នុងសកម្មភាពគ្រោះថ្នាក់',
        desc: 'ប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល ជារឿយៗមិនរាប់បញ្ចូលការរងរបួសដែលកើតឡើងនៅពេលចូលរួមក្នុងសកម្មភាពដែលមានហានិភ័យខ្ពស់ ឬគ្រោះថ្នាក់ ដូចជា ការជិះខ្លែងលើមេឃ ការឡើងភ្នំ ការមុជទឹក ឬការប្រណាំងម៉ូតូជាដើម។ សកម្មភាពទាំងនេះត្រូវបានចាត់ទុកថាមានហានិភ័យខ្ពស់នៃការរងរបួស ហើយក្រុមហ៊ុនធានារ៉ាប់រងអាចនឹងមិនធានារ៉ាប់រងលើគ្រោះថ្នាក់ដែលកើតឡើងនៅពេលចូលរួមក្នុងសកម្មភាពទាំងនេះ។',
      },
      item5: {
        label: 'ឥទ្ធិពលនៃគ្រឿងស្រវឹង ឬគ្រឿងញៀន',
        desc: 'ប្រសិនបើឧបទ្ទវហេតុកើតឡើងខណៈពេលដែល អ្នកដែលត្រូវបានធានារ៉ាប់រងស្ថិតនៅក្រោមឥទ្ធិពលនៃគ្រឿងស្រវឹង ឬគ្រឿងញៀន ក្រុមហ៊ុនធានារ៉ាប់រងអាចបដិសេធ ឬកាត់បន្ថយការទាមទារសំណងនេះ។ នេះគឺដោយសារតែ ការញៀនថ្នាំស្រវឹងអាចធ្វើឱ្យខូចការវិនិច្ឆ័យនិងការសម្របសម្រួល ដែលបង្កើនលទ្ធភាពកើតឡើងនៃគ្រោះថ្នាក់។',
      },
      item6: {
        label: 'ការចូលរួមក្នុងសកម្មភាពឧក្រិដ្ឋកម្ម',
        desc: 'ធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលមិនធានារ៉ាប់រងលើ របួសដែលកើតឡើងនៅពេលប្រព្រឹត្តបទឧក្រិដ្ឋ ឬចូលរួមក្នុងសកម្មភាពខុសច្បាប់នោះទេ។ នេះ​គឺ​ដោយសារ​ក្រុមហ៊ុន​ធានា​រ៉ាប់រង​មិន​ចង់​ជំរុញ​ឲ្យ​មាន​អាកប្បកិរិយា​ឧក្រិដ្ឋកម្ម។',
      },
      item7: {
        label: 'សង្គ្រាម ឬកុបកម្ម',
        desc: 'ប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល ជាធម្មតាមិនរាប់បញ្ចូលការរងរបួសដែលកើតឡើងក្នុងអំឡុងពេលសង្រ្គាម ភាពចលាចលស៊ីវិល ឬកុបកម្ម។ ព្រឹត្តិការណ៍ទាំងនេះត្រូវបានចាត់ទុកថាជាអំពើហឹង្សា ដែលហួសពីវិសាលភាពនៃការធានាររបស់ប័ណ្ណសន្យា។',
      },
      item8: {
        label: 'ការបើកបរដោយគ្មានប័ណ្ណបើកបរ',
        desc: 'ប្រសិនបើគ្រោះថ្នាក់កើតឡើងខណៈពេលដែលម្ចាស់ប័ណ្ណសន្យាធានារ៉ាប់រងបើកបរដោយគ្មានអាជ្ញាប័ណ្ណត្រឹមត្រូវ ក្រុមហ៊ុនធានារ៉ាប់រងអាចនឹងមិនផ្តល់ការធានារ៉ាប់រងឡើយ។',
      },
      item9: {
        label: 'ការមានផ្ទៃពោះ ឬការសម្រាលកូន',
        desc: 'គោលការណ៍មួយចំនួនអាចមិនរាប់បញ្ចូលការរងរបួស ឬពិការភាព ដែលកើតឡើងក្នុងអំឡុងពេលមានផ្ទៃពោះ ឬសម្រាលកូននោះទេ។',
      },
    },
    extraBenefitSection: {
      title: 'អត្ថប្រយោជន៍បន្ថែមរបស់ប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល',
      item1: {
        label: 'ការចំណាយលើពិធីបុណ្យសព',
        desc: 'ប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលមួយចំនួនសងប្រាក់ថ្លៃបុណ្យសពរបស់អ្នកកាន់ប័ណ្ណសន្យាធានារ៉ាប់រងវិញតាមចំនួនបញ្ជាក់នៅក្នុងប័ណ្ណសន្យា។ នេះអាចជួយសម្រាលបន្ទុកហិរញ្ញវត្ថុលើក្រុមគ្រួសារក្នុងគ្រាលំបាក។',
      },
      item2: {
        label: 'ការចំណាយលើរថយន្តសង្គ្រោះ',
        desc: 'ប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល មួយចំនួនផ្តល់ប្រាក់ឧបត្ថម្ភមួយចំនួនសម្រាប់ថ្លៃរថយន្តសង្គ្រោះ ដើម្បីដឹកអ្នកទៅមន្ទីរពេទ្យក្នុងស្ថានភាពសង្គ្រោះបន្ទាន់។',
      },
      item3: {
        label: 'អត្ថប្រយោជន៍សំរាប់ការសិក្សាអប់រំ',
        desc: 'ប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលមួយចំនួនផ្តល់ការទូទាត់ជាសាច់ប្រាក់មួយចំនួនដល់កូនៗរបស់ម្ចាស់ប័ណ្ណសន្យាធានារ៉ាប់រង ដើម្បីជួយរ៉ាប់រងលើថ្លៃការសិក្សាអប់រំរបស់ពួកគេ ក្នុងករណីមរណភាពរដោយចៃដន្យរបស់ម្ចាស់ប័ណ្ណសន្យាធានារ៉ាប់រង។',
      },
      item4: {
        label: 'ការបាត់ខ្លួន',
        desc: 'ប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលមួយចំនួនផ្តល់ប្រាក់ឧបត្ថម្ភ ក្នុងករណីបាត់ខ្លួន ឬការចាប់ជំរិត។',
      },
      item5: {
        label: 'ការពុលចំនីអាហារ',
        desc: 'ក្នុងករណីពុលអាហារ ឬភេសជ្ជៈ ប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលរបស់អ្នកអាចរ៉ាប់រងរហូតដល់ចំនួនកំណត់តាមតារាងអត្ថប្រយោជន៍នៃប័ណ្ណសន្យា។',
      },
      item6: {
        label: 'ពស់ចឹក សត្វល្អិត ឬសត្វ ខាំ',
        desc: 'ក្នុងករណីណាក៏ដោយដែល ពស់ចឹក សត្វល្អិត ឆ្កែ ឬសត្វខាំ ដែលត្រូវការការព្យាបាល ឬការថែទាំវេជ្ជសាស្រ្ត ការទូទាត់ប្រាក់ត្រូវបានផ្តល់ជូនដើម្បីរ៉ាប់រងលើថ្លៃព្យាបាលនេះ។',
      },
      item7: {
        label: 'ជំងឺគ្រុនឈាម គ្រុនចាញ់ និង/ឬ គ្រុនឈីក',
        desc: 'ប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលមួយចំនួនធានារ៉ាប់រងសម្រាប់ជំងឺដូចជា គ្រុនឈាម គ្រុនចាញ់ ឬគ្រុនឈីក។ ការធានារ៉ាប់រងគឺរហូតដល់ចំនួនកំណត់ដែលបានបញ្ជាក់តាមតារាង អត្ថប្រយោជន៍របស់ប័ណ្ណសន្យា។',
      },
    },
    eligibilitySection: {
      title: 'លក្ខណៈវិនិច្ឆ័យការមានសិទ្ធិទិញប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល',
      subTitle: 'លក្ខណៈវិនិច្ឆ័យការមានសិទ្ធិទិញប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលគឺសាមញ្ញ។ ដំណើរការទិញគឺងាយស្រួលណាស់សម្រាប់បុគ្គល និងសមាជិកគ្រួសារ។ ខាងក្រោម​នេះ​គឺ​ជា​លក្ខខណ្ឌ​តម្រូវ​ការ​មានសិទ្ធិ​៖',
      item1: {
        label: 'អាយុ',
        desc: 'អ្នកត្រូវតែមានអាយុយ៉ាងតិច ១៨ឆ្នាំ និងមិនលើសពី ៦៥ឆ្នាំ។ ក្រុមហ៊ុនធានារ៉ាប់រងមួយចំនួនអាចមានដែនកំណត់អាយុខុសៗគ្នាសម្រាប់ប្រភេទមុខរបរ ឬសកម្មភាពជាក់លាក់មួយចំនួន។',
      },
      item2: {
        label: 'ទីលំនៅ',
        desc: 'អ្នកត្រូវតែជាអ្នករស់នៅក្នុងប្រទេសដែលអ្នកកំពុងទិញប័ណ្ណសន្យាធានារ៉ាប់រង។',
      },
      item3: {
        label: 'សុខភាព',
        desc: 'អ្នកត្រូវតែមានសុខភាពល្អ និងមិនមានលក្ខខណ្ឌវេជ្ជសាស្ត្រដែលមានស្រាប់ ដែលអាចបង្កើនហានិភ័យនៃគ្រោះថ្នាក់។ ក្រុមហ៊ុនធានារ៉ាប់រងមួយចំនួនអាចតម្រូវឱ្យអ្នកឆ្លងកាត់ការពិនិត្យសុខភាព មុនពេលពួកគេនឹងចេញប័ណ្ណសន្យាធានារ៉ាប់រងជូនអ្នក។',
      },
      item4: {
        label: 'មុខរបរ',
        desc: 'អ្នកមិនត្រូវមានមុខរបរដែលចាត់ទុកថាមានហានិភ័យខ្ពស់ ឬមានគ្រោះថ្នាក់នោះទេ។ ក្រុមហ៊ុនធានារ៉ាប់រងមួយចំនួនអាចតម្រូវឱ្យអ្នកផ្តល់ព័ត៌មានលម្អិតអំពីមុខរបររបស់អ្នក នៅពេលដាក់ពាក្យសុំប័ណ្ណសន្យាធានារ៉ាប់រង។',
      },
      item5: {
        label: 'ប្រាក់ចំណូល',
        desc: 'អ្នកមិនត្រូវបានតម្រូវឱ្យដាក់ឯកសារប្រាក់ចំណូលរបស់អ្នកដើម្បីទទួលបានការធានារ៉ាប់រងនេះទេ។ វាគឺសម្រាប់មនុស្សមានប្រាក់ចំណូលគ្រប់កម្រិត។',
      },
      item6: {
        label: 'កំណត់ត្រាព្រហ្មទណ្ឌ',
        desc: 'អ្នកមិនត្រូវមានកំណត់ត្រាព្រហ្មទណ្ឌឡើយ។ ក្រុមហ៊ុនធានារ៉ាប់រងខ្លះអាចស្នើរសុំឱ្យអ្នកផ្តល់ច្បាប់ចម្លងនៃកំណត់ត្រាប៉ូលីសរបស់អ្នកនៅពេលអ្នកដាក់ពាក្យសុំប័ណ្ណសន្យាធានារ៉ាប់រង។',
      },
      item7: {
        label: 'បុព្វលាភ',
        desc: 'អ្នកត្រូវបង់បុព្វលាភរ៉ាប់រងដើម្បីរក្សាប័ណ្ណសន្យាធានារ៉ាប់រងរបស់អ្នកឱ្យនៅសកម្ម។ ចំនួនបុព្វលាភ គឺអាស្រ័យលើការធានារ៉ាប់រង និងអត្ថប្រយោជន៍ដែលអ្នកបានជ្រើសរើស។',
      },
    },
    whoShouldGetSection: {
      title: 'តើអ្នកណាគួរតែមានធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល?',
      subTitle: 'ធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល គឺសមរម្យសម្រាប់អ្នកដែលមានសិទ្ធិអាចទទួលបាន និងមានហានិភ័យនៃគ្រោះថ្នាក់ដែលមិននឹកស្មានដល់ ដោយមិនគិតពីមុខរបរ និងកម្រិតប្រាក់ចំណូលរបស់ពួកគេ។ នេះអាចរួមបញ្ចូលៈ',
      tab1: {
        title: 'បុគ្គលមានមុខរបរដែលមានហានិភ័យទាប',
        item1: 'បុគ្គលិកការិយាល័យ (ដូចជាទីប្រឹក្សា គណនេយ្យករ និងវិស្វករ)',
        item2: 'បុគ្គលិកថែទាំសុខភាព',
        item3: 'អ្នកជំនាញផ្នែកច្បាប់',
        item4: 'សិល្បករ អ្នកនិពន្ធ និងអ្នករចនា',
        item5: 'គ្រូបង្រៀន និងសិស្សានុសិស្ស',
        item6: 'មន្ត្រីរាជការ និងមន្ត្រីការិយាល័យ',
        item7: 'បុគ្គលិកធានាគារ',
        item8: 'ម្ចាស់ហាង',
        item9: 'មេផ្ទះ',
      },
      tab2: {
        title: 'បុគ្គលមានមុខរបរដែលមានហានិភ័យខ្ពស់',
        item1: 'កម្មករឧស្សាហកម្ម (មិនមានគ្រោះថ្នាក់)',
        item2: 'ពេទ្យសត្វ',
        item3: 'មន្ត្រីសន្តិសុខ',
        item4: 'អ្នកថតរូប និងចុងភៅ',
        item5: 'និស្សិតមហាវិទ្យាល័យ / សាកលវិទ្យាល័យ',
        item6: 'អ្នកសាងសង់ អ្នកម៉ៅការ និងកម្មករសំណង់',
        item7: 'បុគ្គលិកផ្នែកបដិសណ្ឋារកិច្ច និងទេសចរណ៍',
        item8: 'ក្រុមអាកាសយានិក និងបុគ្គលិកអាកាសយានដ្ឋាន',
        item9: 'បុគ្គលិកដឹកជញ្ជូន',
      },
      tab3: {
        title: 'បុគ្គលមានមុខរបរដែលមានហានិភ័យខ្ពស់ខ្លាំង',
        item1: 'កម្មករឧស្សាហកម្ម (កម្មករប្រឈមនឹងគ្រោះថ្នាក់)',
        item2: 'អត្តពលិក',
        item3: 'ប៉ូលីស និងទាហានប្រដាប់អាវុធ',
        item4: 'អ្នកឡើងភ្នំ',
        item5: 'អ្នកកាសែត',
        item6: 'អ្នក​នយោបាយ',
      },
    },
    frequentlyAskedQuestionSection: {
      title: 'សំណួរដែលគេសួរញឹកញាប់អំពីធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល',
      q1: 'តើប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលមានអត្ថប្រយោជន៍អ្វីខ្លះ?',
      a1: 'ប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលនឹងធានារ៉ាប់រងអ្នក ក្នុងករណីមរណភាពដោយចៃដន្យ ពិការភាពទាំងស្រុង ឬដោយផ្នែកជាអចិន្ត្រៃយ៍ ពិការភាពបណ្តោះអាសន្ន ថ្លៃព្យាបាលវេជ្ជសាស្ត្រ និងជាច្រើនទៀតដូចជា ថ្លៃរថយន្តសង្គ្រោះ និងថ្លៃបុណ្យសពជាដើម។',
      q2: 'តើខ្ញុំអាចបញ្ចូលឪពុកម្តាយរបស់ខ្ញុំនៅក្នុងប័ណ្ណសន្យាធានារ៉ាប់រងនេះបានទេ?',
      a2: 'បាទ/ចាស អ្នកអាចបន្ថែមឪពុកម្តាយរបស់អ្នក រហូតដល់អាយុ 65 ឆ្នាំ ក្នុងនាមជាអ្នកនៅក្នុងបន្ទុក ក្នុងប័ណ្ណសន្យាធានារ៉ាប់រងនេះ។',
      q3: 'តើប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលធានារ៉ាប់រងលើមរណភាពទេ?',
      a3: 'បាទ/ចាស វាធានា។ នៅក្នុងករណីមរណភាពដោយចៃដន្យ អ្នកនៅក្នុងបន្ទុករបស់អ្នកនឹងទទួលបានចំនួនទឹកប្រាក់ធានារ៉ាប់រងដែលបានបញ្ជាក់នៅក្នុងតារាងអត្ថប្រយោជន៍នៃប័ណ្ណសន្យាធានារ៉ាប់រង។',
      q4: 'ប៉ុន្តែ ខ្ញុំក៏មានប័ណ្ណសន្យាធានារ៉ាប់រងសុខភាពផងដែរ។ តើខ្ញុំនៅតែត្រូវការប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលដែរឬទេ?',
      a4: 'ប័ណ្ណសន្យាធានារ៉ាប់រងសុខភាពស្តង់ដារពិតជាខុសពីប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់ផ្ទាល់ខ្លួន។ ប័ណ្ណសន្យាធានារ៉ាប់រងសុខភាពនឹងរ៉ាប់រងអ្នកក្នុងករណីមានជម្ងឺណាមួយ និងផ្សេងៗដូចជា ថ្លៃសម្រាកព្យាបាលនៅមន្ទីរពេទ្យដោយមិនបាច់បង់ប្រាក់ ឬទូទាត់សងជូនអ្នកវិញ។ ប៉ុន្តែ ជាមួយនឹងការធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល អ្នកនឹងទទួលទឹកប្រាក់មួយចំនួនដើម្បីជួយអ្នកនៅពេលដែលត្រូវការជំនួយផ្នែកហិរញ្ញវត្ថុ។\n',
      q5: 'តើឯកសារអ្វីខ្លះដែលតម្រូវសំរាប់ប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល?',
      a5: 'តាមរយះធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលរបស់អឹមជីអេ ខូវើ វាគឺជាដំណើរការតាមអនឡាញ។ អ្នកគ្រាន់តែបំពេញពត៌មានលម្អិតដែលត្រូវការ ហើយនិងទូរទាត់បង់ប្រាក់តាមអនឡាញ នោះអ្នកនឹងត្រូវបានធានារ៉ាប់រងក្នុងគម្រោងធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលរបស់អ្នក។',
      q6: 'តើខ្ញុំត្រូវការប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលដាច់ដោយឡែកមួយទៀតសំរាប់សមាជិកក្រុមគ្រួសាររបស់ខ្ញុំដែរឬទេ?',
      a6: 'ទេ តាមពិតអ្នកមិនត្រូវការទេ! ប័ណ្ណសន្យាធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គល គឺជាប័ណ្ណសន្យាអណ្តែត ដែលមានន័យថា អ្នកអាចបន្ថែមគ្រួសារទាំងមូលរបស់អ្នក រួមទាំងខ្លួនអ្នក ប្តីឬប្រពន្ធរបស់អ្នក កូននៅក្នុងបន្ទុក និងឪពុកម្តាយនៅក្រោមគម្រោងតែមួយ។',
    },
    disclaimer: 'ការបដិសេធ៖ ទំព័រនេះ គឺសម្រាប់តែការអប់រំផ្នែកធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលប៉ុណ្ណោះ។  វាមិនឆ្លុះបញ្ចាំងពីគោលការណ៍ធានារ៉ាប់រងណាមួយឡើយ។',
  },
  personalAccidentQuote: {
    featuredPlanBenefits: {
      death: 'មរណភាពបណ្តាលមកពីគ្រោះថ្នាក់',
      permanentAndTotalDisablement: 'ពិការភាពទាំងស្រុងជាអចិន្ត្រៃយ៍បណ្តាលមកពីគ្រោះថ្នាក់',
      permanentAndPartialDisablement: 'ពិការភាពដោយផ្នែកជាអចិន្ត្រៃយ៍បណ្តាលមកពីគ្រោះថ្នាក់',
      medicalExpense: 'ថ្លៃចំណាយផ្នែកវេជ្ជសាស្ត្របណ្តាលមកពីគ្រោះថ្នាក់',
    },
    annualLimit: 'ទឹកប្រាក់ធានាកំណត់ប្រចាំឆ្នាំ',
    geographicCoverage: 'ភូមិសាស្ត្រធានា',
    cashlessHospitals: 'បណ្តាញមន្ទីរពេទ្យដៃគូ',
    myAge: 'ខ្លួនខ្ញុំ ({{age}} ឆ្នាំ)',
    totalPlans: 'ធានារ៉ាប់រងគ្រោះថ្នាក់បុគ្គលមាន {{count}} គម្រោង',
  },
  personalAccidentQuoteBuyPage: {
    title: 'ទិញបណ្ណសន្យាធានារ៉ាប់រង',
    subTitle: 'សូមបំពេញព័ត៌មានលម្អិតអំពីអ្នកត្រូវបានធានារ៉ាប់រងដែលអ្នកចង់បញ្ចូលក្នុងបណ្ណសន្យាតែមួយ ហើយបន្ទាប់មកឆ្លើយកម្រងសំណួរ',
  },
  personalAccidentQuoteReviewPage: {
    memberDetailsTitle: 'ពត័មានលម្អិតរបស់សមាជិក',
  },
  personalAccidentPlanBenefitGroupTypes: {
    basicBenefits: 'អត្ថប្រយោជន៍មូលដ្ឋាន',
    medicalExpense: 'ថ្លៃចំណាយផ្នែកវេជ្ជសាស្ត្រ',
    extensions: 'អត្ថប្រយោជន៍ផ្សេងៗ',
    iema: 'សេវាសង្គ្រោះអន្តរជាតិ',
  },
  personalAccidentPlanBenefit: {
    basicBenefitsDeathDueToAccident: 'មរណភាពបណ្តាលមកពីគ្រោះថ្នាក់',
    basicBenefitsPermanentAndTotalDisablementDueToAccident: 'ពិការភាពទាំងស្រុងជាអចិន្ត្រៃយ៍បណ្តាលមកពីគ្រោះថ្នាក់',
    basicBenefitsPermanentAndPartialDisablementDueToAccident: 'ពិការភាពអាវៈយវៈជាអចិន្ត្រៃយ៍បណ្តាលមកពីគ្រោះថ្នាក់',
    basicBenefitsMedicalExpenseDueToAccident: 'ថ្លៃចំណាយផ្នែកវេជ្ជសាស្ត្របណ្តាលមកពីគ្រោះថ្នាក់',
    medicalExpenseInpatientAndOutpatientTreatmentDueToAccident: 'ការព្យាបាលរបួស បណ្តាលមកពីគ្រោះថ្នាក់ ដោយសម្រាកព្យាបាល និងដោយមិនសម្រាកព្យាបាល',
    medicalExpenseLocalGroundAmbulance: 'រថយន្តគិលានសង្គ្រោះក្នុងប្រទេស',
    extensionsCashAllowance: 'ថវិកាឧបត្ថម្ភ',
    extensionsDisappearance: 'ការបាត់ខ្លួន',
    extensionsFuneralExpensesSubsidyNonAccidentalDeath: 'ថវិកាចូលរួមរំលែកមរណទុក្ខ (មរណភាពមិនមែនបណ្តាលមកពីគ្រោះថ្នាក់)',
    extensionsNoClaimBonus: 'ប្រាក់រង្វាន់ពេលគ្មានការទាមទារសំណង',
    extensionsSnakeBitesAndInsectBites: 'ពស់ចឹក និងសត្វល្អិតទិចឬខាំ',
    extensionsAccidentalMiscarriage: 'ការរលូតកូនដោយចៃដន្យ',
    extensionsFoodPoisoning: 'ការពុលចំនីអាហារ',
    extensionsFuneralBenefit: 'អត្ថប្រយោជន៍ចូលរួមរំលែកមរណទុក្ខ',
    extensionsIncrementBonus: 'ប្រាក់រង្វាន់បន្ថែម',
    extensionsInsectOrAnimalBite: 'សត្វល្អិតទិចឬខាំ ឬ សត្វខាំ',
    extensionsMedicalExpenseTripleIndemnityForRobbery: 'ថ្លៃចំណាយផ្នែកវេជ្ជសាស្ត្រ - ការផ្តល់សំណងបីដងចំពោះអំពើប្លន់',
    extensionsMedicalTreatmentDengueFever: 'ការព្យាបាលជម្ងឺគ្រុនឈាម',
    extensionsStikeAndRiot: 'កូដកម្ម និងកុប្បកម្ម',
    extensionsMotorcycling: 'គ្រោះថ្នាក់​ចរាចរណ៍​ម៉ូតូ',
    iemaEmergencyMedicalEvacuationDueToAccident: 'ការបញ្ជូនបន្ទាន់តាមគោលការណ៍វេជ្ជសាស្ត្រ បណ្តាលមកពីគ្រោះថ្នាក់',
    iemaEmergencyMedicalRepatriationDueToAccident: 'ការធ្វើមាតុភូមិនិវត្តន៍បន្ទាន់តាមគោលការណ៍វេជ្ជសាស្ត្រ បណ្តាលមកពីគ្រោះថ្នាក់',
    iemaRepatriationOfMortalRemainsDueToAccident: 'ការធ្វើមាតុភូមិនិវត្តន៍សាកសព ឬធាតុ បណ្តាលមកពីគ្រោះថ្នាក់',
  },
  personalAccidentPolicyClaim: {
    termsAndConditions: 'ខ្ញុំ/យើងជាអ្នកត្រូវបានធានារ៉ាប់រង សូមអះអាងយ៉ាងមុឺងម៉ាត់ថា ខ្ញុំ/យើងគោរពតាមលក្ខខណ្ឌនៃបណ្ណសន្យារ៉ាប់រងនេះ ហើយគ្មានគោលបំណងបង្កហេតុណាមួយដើម្បីទាញយកផលប្រយោជន៍អ្វីតាមរយៈការក្លែងបន្លំ ឬការពិពណ៌មិនពិតដោយចេតនាឡើយ ហើយក៏សូមបញ្ជាក់ថាព័ត៌មានដែលបានបំពេញលើបែបបទនេះគឺជាការពិត ហើយខ្ញុំ/យើងពុំមានលាក់បាំងព័ត៌មានណាមួយដែលពាក់ព័ន្ធនឹងការទាមទារសំណងនេះឡើយ។',
  },
  personalAccidentClaimTypes: {
    death: 'មរណភាព',
    permanentAndTotalDisablement: 'ពិការភាពទាំងស្រុងជាអចិន្ត្រៃយ៍',
    permanentAndPartialDisablement: 'ពិការភាពអាវៈយវៈជាអចិន្ត្រៃយ៍',
    medicalExpense: 'ថ្លៃចំណាយផ្នែកវេជ្ជសាស្ត្រ',
    cashAllowance: 'ថវិកាឧបត្ថម្ភ',
    internationalEmergencyMedicalAssistance: 'សេវាសង្គ្រោះអន្តរជាតិ',
    others: 'ផ្សេងៗ',
  },
  cancerInsurancePage: {
    headerSection: {
      title: 'ធានារ៉ាប់រងជំងឺមហារីក',
      subTitle: 'ធានារ៉ាប់រងជំងឺមហារីកជួយអ្នក និងគ្រួសាររបស់អ្នកឱ្យមានភាពរឹងមាំខាងផ្លូវចិត្ត រាងកាយ និងសំខាន់បំផុតផ្នែកហិរញ្ញវត្ថុក្នុងករណីត្រូវបានគេធ្វើរោគវិនិច្ឆ័យថាមានជំងឺមហារីក។',
      item1: 'ទទួលសម្រង់តម្លៃធានារ៉ាប់រងជំងឺមហារីកភ្លាមៗដោយឥតគិតថ្លៃ',
      item2: 'បុព្វលាភសមរម្យពីក្រុមហ៊ុនធានារ៉ាប់ជំងឺមហារីកកំពូលៗ',
      item3: 'ស្វែងរកវិធីសន្សំសំចៃប្រាក់លើការធានារ៉ាប់រងជំងឺមហារីក',
      item4: 'ប្រៀបធៀបអត្រាធានារ៉ាប់រងជំងឺមហារីកដោយឥតគិតថ្លៃ',
    },
    definitionSection: {
      title: 'តើធានារ៉ាប់រងជំងឺមហារីកជាគឺជាអ្វី?',
      description: 'ធានារ៉ាប់រងជំងឺមហារីកគឺជាបណ្ណសន្យាធានារ៉ាប់រងឯកទេសមួយ ដែលមានគោលបំណងកាត់បន្ថយផលប៉ះពាល់ផ្នែកហិរញ្ញវត្ថុ និងអារម្មណ៍ មកលើអ្នក និងគ្រួសាររបស់អ្នក ក្នុងករណីមានរោគវិនិច្ឆ័យជំងឺមហារីក។ ក្នុង​ករណី​អកុសល​ដែល​ត្រូវ​បាន​គេ​រក​ឃើញ​ថា​មាន​ជំងឺ​មហារីក ម្ចាស់​ប័ណ្ណ​ធានា​រ៉ាប់រង​ជំងឺ​មហារីក​នឹង​ទទួល​បាន​ប្រាក់សំណងសំរាប់​ការ​ព្យាបាល និងប្រើប្រាស់ទៅតាមតម្រូវការ។',
    },
    howItWorksSection: {
      title: 'តើធានារ៉ាប់រងជំងឺមហារីកដំណើរយ៉ាងដូចម្តេច?',
      description: 'នៅពេលដែលបុគ្គលម្នាក់ត្រូវបានគេធ្វើរោគវិនិច្ឆ័យថាមានជំងឺមហារីក បណ្ណសន្យារ៉ាប់រងធានារ៉ាប់រងជំងឺមហារីកនឹងមានប្រសិទ្ធភាព។ នៅពេលធ្វើរោគវិនិច្ឆ័យ ក្រុមហ៊ុនធានារ៉ាប់រងនឹងបញ្ចេញសាច់ប្រាក់មួយចំនួនដែលស្មើនឹងចំនួនទឹកប្រាក់ធានារ៉ាប់រង ដែលអាចត្រូវបានប្រើប្រាស់ដើម្បីទូទាត់ការចំណាយលើការព្យាបាលជំងឺមហារីក។ ជាធម្មតា ចំនួនទឹកប្រាក់សំណងត្រូវបានបញ្ចេញនៅដំណាក់កាលផ្សេងៗគ្នានៃការធ្វើរោគវិនិច្ឆ័យ ដូចជាដំណាក់ស្រាល ដំណាក់កាលធ្ងន់ និង ដំណាក់កាលធ្ងន់ធ្ងរខ្លាំង ដរាបណាការធ្វើរោគវិនិច្ឆ័យធ្វើឡើងក្នុងរយៈពេលធានារា៉ប់រងនៃបណ្ណសន្យា។ ទោះជាយ៉ាងណាក៏ដោយ វាគឺសំខាន់ណាស់ក្នុងការកត់ចំណាំថា បណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីកមិនផ្តល់អត្ថប្រយោជន៍ចំពោះ មរណៈភាព ថ្ងៃកំណត់នៃបណ្ណសន្យា ឬការបញ្ចប់បណ្ណសន្យាមុនថ្ងៃកំណត់នោះទេ។',
    },
    benefitSection: {
      title: 'អត្ថប្រយោជន៍នៃបណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីក',
      subTitle: 'មានបណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីក គឺជាការសម្រេចចិត្តដ៏សំខាន់បំផុតមួយ ដែលអ្នកអាចធ្វើសម្រាប់ខ្លួនអ្នក និងមនុស្សជាទីស្រលាញ់របស់អ្នក។ ធានារ៉ាប់រងជំងឺមហារីកអាចផ្តល់ឱ្យអ្នកនូវអត្ថប្រយោជន៍ជាច្រើនដូចជា៖',
      item1: {
        label: 'ការទូទាត់សាច់ប្រាក់',
        desc: 'គម្រោងធានារ៉ាប់រងជាច្រើនផ្តល់ការទូទាត់សាច់ប្រាក់ នៅពេលធ្វើរោគវិនិច្ឆ័យ ដែលការណ៍នេះអនុញ្ញាតឱ្យមានភាពបត់បែនក្នុងការប្រើប្រាស់ មូនិថិសម្រាប់ការព្យាបាលជំងឺមហារីក ការចំណាយលើការរស់នៅ ឬតម្រូវការផ្សេងទៀត។',
      },
      item2: {
        label: 'ការជំនួសប្រាក់ចំណូល',
        desc: 'បណ្ណសន្យាធានារ៉ាប់រងមួយចំនួនផ្តល់អត្ថប្រយោជន៍ជាប្រាក់ចំណូល ដើម្បីជួយជំនួសប្រាក់កម្រៃការងារដែលបាត់បង់អំឡុងពេលព្យាបាល។',
      },
      item3: {
        label: 'ការធានារ៉ាប់រងសម្រាប់ការចំណាយជាក់លាក់',
        desc: 'គម្រោងធានារ៉ាប់រងមួយចំនួនធានាលើការចំណាយជាក់លាក់ដូចជាការវះកាត់ ការព្យាបាលដោយប្រើគីមី  កាំរស្មី ឬការសម្រាកនៅមន្ទីរពេទ្យ។',
      },
      item4: {
        label: 'ការរ៉ាប់រងប្រឆាំងនឹងជំងឺមហារីកច្រើនប្រភេទ',
        desc: 'ក្រុមហ៊ុនធានារ៉ាប់រងមហារីកភាគច្រើនធានារ៉ាប់រងលើប្រភេទមហារីកជាច្រើនប្រភេទ ដែលនេះមានសារៈប្រយោជន៍យ៉ាងខ្លាំង។',
      },
      item5: {
        label: 'ជំងឺមហារីកជាច្រើនដំណាក់កាល',
        desc: 'វាធានាលើជំងឺមហារីកគ្រប់ប្រភេទនៅគ្រប់ដំណាក់កាល។',
      },
      item6: {
        label: 'ការលើកលែងបុព្វលាភ',
        desc: 'ក្នុងករណីត្រូវបានគេធ្វើរោគវិនិច្ឆ័យថាមានជំងឺមហារីក ក្រុមហ៊ុនធានារ៉ាប់រងមួយចំនួនអាចលះបង់បុព្វលាភដែលត្រូវបង់សម្រាប់បណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីក។ នេះគឺជាអត្ថប្រយោជន៍ដ៏អស្ចារ្យ ព្រោះវាកាត់បន្ថយបន្ទុកហិរញ្ញវត្ថុនៃការបង់បុព្វលាភ។',
      },
      item7: {
        label: 'ប្រាក់រង្វាន់ពេលគ្មានការទាមទារសំណង',
        desc: 'ប្រសិនបើមិនមានការទាមទារសំណង ក្នុងរយៈពេលធានាដែលបានបញ្ជាក់ ក្រុមហ៊ុនធានារ៉ាប់រងភាគច្រើនអាចកាត់បន្ថយបុព្វលាភដែលបង់សម្រាប់គោលនយោបាយធានារ៉ាប់រងជំងឺមហារីក។',
      },
      item8: {
        label: 'សន្តិភាព​ផ្លូវចិត្ត',
        desc: 'ការធ្វើរោគវិនិច្ឆ័យមានជំងឺមហារីកអាចជាស្ថានភាពធ្ងន់ធ្ងរខ្លាំងពិបាកដោះស្រាយ ហើយបន្ទុកហិរញ្ញវត្ថុអាចបន្ថែមភាពតានតឹង។ ការធានារ៉ាប់រងជំងឺមហារីកអាចជួយបន្ធូរបន្ថយកង្វល់មួយចំនួន ដោយផ្តល់នូវសុវត្ថិភាពហិរញ្ញវត្ថុក្នុងអំឡុងពេលដ៏លំបាក ដើម្បីឱ្យអ្នកផ្តោតអារម្មណ៍លើសុខភាព និងការជាសះស្បើយឡើងវិញរបស់អ្នក ហើយនិងត្រឡប់រស់នៅធម្មតាវិញ។',
      },
    },
    whyNeedSection: {
      title: 'ហេតុអ្វីបានជាអ្នកត្រូវការការធានារ៉ាប់រងជំងឺមហារីក?',
      subTitle: 'ការព្យាបាលជំងឺមហារីកអាចមានតម្លៃថ្លៃមិនគួរឱ្យជឿទោះបីជាមានការធានារ៉ាប់រងសុខភាពធម្មតាក៏ដោយ។ ការធានារ៉ាប់រងជំងឺមហារីកផ្តល់នូវសុវត្ថិភាពហិរញ្ញវត្ថុដ៏សំខាន់មួយដោយ៖',
      item1: {
        label: 'រ៉ាប់រងការចំណាយដែលមិននឹកស្មានដល់',
        desc: 'វាជួយបង់ថ្លៃព្យាបាល ថ្លៃថ្នាំ ការព្យាបាល និងការចំណាយពាក់ព័ន្ធផ្សេងទៀត ដែលធានារ៉ាប់រងសុខភាពធម្មតារបស់អ្នមិនអាចរ៉ាប់រងទាំងស្រុង។',
      },
      item2: {
        label: 'ផ្តល់ស្ថិរភាពហិរញ្ញវត្ថុ',
        desc: 'ការព្យាបាលជំងឺមហារីកអាចរំខានដល់ប្រាក់ចំណូលរបស់អ្នក ដូច្នេះ ធានារ៉ាប់រងអាចជួយរក្សាសុខុមាលភាពហិរញ្ញវត្ថុរបស់អ្នក។',
      },
      item3: {
        label: 'កាត់បន្ថយភាពតានតឹងផ្នែកហិរញ្ញវត្ថុ',
        desc: 'ការដឹងថាអ្នកមានការការពារផ្នែកហិរញ្ញវត្ថុអាចជួយសម្រាលបន្ទុកផ្លូវចិត្តនៃការធ្វើរោគវិនិច្ឆ័យមហារីក។',
      },
      item4: {
        label: 'ផ្តល់ភាពបត់បែន',
        desc: 'គម្រោងធានារ៉ាប់រងមហារីកជាច្រើនផ្តល់ការទូទាត់សាច់ប្រាក់ ដែលអនុញ្ញាតឱ្យអ្នកប្រើប្រាស់ប្រាក់តាមតម្រូវការ។',
      },
    },
    noCoverSection: {
      title: 'ករណីមិនធានារ៉ាប់រងក្រោម បណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីក',
      subTitle: 'ខណៈពេលដែល ធានារ៉ាប់រងជំងឺមហារីកផ្តល់ការគាំទ្រផ្នែកហិរញ្ញវត្ថុដ៏សំខាន់ វាចាំបាច់ណាស់ក្នុងការយល់ដឹងអំពីដែនកំណត់នៃការធានារ៉ាប់រងផងដែរ។ នេះគឺជាករណីមិនធានារ៉ាប់រងមួយចំនួនដែលមាននៅក្នុងបណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីក៖',
      item1: 'ប្រភេទមួយចំនួននៃជំងឺមហារីកស្បែកអាចត្រូវបានដកចេញ',
      item2: 'ប្រភេទនៃជំងឺមហារីកណាមួយដែលរងឥទ្ធិពលដោយផ្ទាល់ ឬដោយប្រយោល ឬកាន់តែធ្ងន់ធ្ងរឡើងដោយជំងឺកាមរោគ មេរោគអេដស៍ ឬជំងឺអេដស៍',
      item3: 'មហារីក​កើត​ចេញ​ពី​ជំងឺ​ពី​កំណើត ឬ​លក្ខណ្ឌដែលមានប្រចាំកាយស្រាប់',
      item4: 'រាល់ជំងឺដែលបណ្តាលមកពីការទទួលទានគ្រឿងញៀន (លើកលែងតែស្ថិតក្រោមការណែនាំត្រឹមត្រូវពីគ្រូពេទ្យ) សារធាតុញៀន ថ្នាំពុល ឬគ្រឿងស្រវឹង មិនត្រូវបានរាប់បញ្ចូលនោះទេ។',
      item5: 'ការវះកាត់កែសម្ផស្ស ឬផ្លាស្ទិច ក៏ដូចជាការព្យាបាលស្រដៀងគ្នា មិនត្រូវបានរ៉ាប់រងទេ។',
      item6: 'មហារីក​ដែល​កើត​ចេញ​ពី​ការ​ប៉ះពាល់​នឹង​ការ​បំពុល​ដោយ​ជីវសាស្ត្រ នុយក្លេអ៊ែរ ឬ​គីមី',
      item7: 'មហារីកដែលបណ្តាលមកពីការប៉ះពាល់វិទ្យុសកម្ម ឬវិទ្យុសកម្មពីប្រភពផ្សេងក្រៅពីប្រភពរោគវិនិច្ឆ័យ ឬការព្យាបាល',
      note: 'វាគឺសំខាន់ណាស់ក្នុងការអានឯកសារនៃបណ្ណសន្យាដោយប្រុងប្រយ័ត្ន ដើម្បីយល់អំពីករណីមិនធានារ៉ាប់របងជាក់លាក់។ ខនិងលក្ខខណ្ឌអាចប្រែប្រួលខ្លាំងរវាងក្រុមហ៊ុនធានារ៉ាប់រង។\nចំណាំ៖ ព័ត៌មាននេះមានលក្ខណៈទូទៅ ហើយប្រហែលជាមិនអនុវត្តចំពោះ បណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីកទាំងអស់នោះទេ។ ជានិច្ចជាកាល សូមយោងទៅលើ បណ្ណសន្យាជាក់លាក់របស់អ្នកសម្រាប់ព័ត៌មានការធានាលម្អិត។',
    },
    whenBuySection: {
      title: 'តើអ្នកគួរទិញធានារ៉ាប់រងជំងឺមហារីកនៅពេលណា?',
      item1: 'ប្រសិនបើមានប្រវត្តិនៃជំងឺមហារីកនៅក្នុងគ្រួសាររបស់អ្នក វាគឺសំខាន់ដែលគួរពិចារណាទិញគម្រោងធានារ៉ាប់រងជំងឺមហារីក។',
      item2: 'ប្រសិនបើអ្នកជឿថាអ្នកមានការកើនឡើងហានិភ័យនៃការវិវត្តទៅជាជំងឺមហារីកដោយសារតែកត្តាបរិស្ថាន ឬកត្តាផ្សេងទៀត វាអាចជាការប្រុងប្រយ័ត្នជាមុន ក្នុងការស្វែងរកមើលធានារ៉ាប់រងជំងឺមហារីក។',
      item3: 'ប្រសិនបើអ្នកខ្វះការសន្សំចាំបាច់ដើម្បីរ៉ាប់រងការចំណាយផ្នែកវេជ្ជសាស្ត្រយ៉ាងច្រើនសន្ធឹកសន្ធាប់ បណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីកអាចជាប្រយោជន៍។',
      item4: 'ប្រសិនបើ បណ្ណសន្យាធានារ៉ាប់រងសុខភាពបច្ចុប្បន្នរបស់អ្នកមិនផ្តល់ការធានារ៉ាប់រងគ្រប់គ្រាន់ទេ វាអាចជាការល្អក្នុងការរកមើលទិញ បណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីក។',
      item5: 'ប្រសិនបើ អ្នកគឺជាអ្នករកសុីចិញ្ចឹមតែម្នាក់គត់នៅក្នុងគ្រួសាររបស់អ្នក វាជាការគួរពិចារណាមានបណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីក។',
    },
    chooseRightPlanSection: {
      title: 'របៀបជ្រើសរើសគោលនយោបាយធានារ៉ាប់រងមហារីកត្រឹមត្រូវ',
      subTitle: 'ការជ្រើសរើសគោលការណ៍ធានារ៉ាប់រងមហារីកត្រឹមត្រូវអាចមានច្រើនលើសលប់ ដោយសារជម្រើសជាច្រើនដែលមាន។ នេះគឺជាកត្តាសំខាន់ៗមួយចំនួនដែលត្រូវពិចារណា៖',
      understandNeeds: {
        title: 'របៀបជ្រើសរើសគោលនយោបាយធានារ៉ាប់រងមហារីកត្រឹមត្រូវ',
        item1: {
          label: 'ស្ទង់មើលហានិភ័យរបស់អ្នក',
          desc: 'ពិចារណាអំពីប្រវត្តិគ្រួសារ កត្តារបៀបរស់នៅ និងសុខភាពទូទៅរបស់អ្នក ដើម្បីកំណត់ហានិភ័យរបស់អ្នកនៃការវិវត្តទៅជាជំងឺមហារីក។',
        },
        item2: {
          label: 'វាយតំលៃស្ថានភាពហិរញ្ញវត្ថុរបស់អ្នក',
          desc: 'កំណត់ថាតើអ្នកអាចចំណាយលើការធានារ៉ាប់រងចំនួនប៉ុន្មាន និងចំនួនប៉ុន្មានដែលអ្នកប្រហែលជាត្រូវការក្នុងករណីមានរោគវិនិច្ឆ័យជំងឺមហារីក។',
        },
        item3: {
          label: 'ពិចារណាពីចំណូលចិត្តការថែទាំសុខភាពរបស់អ្នក',
          desc: 'ស្រាវជ្រាវជម្រើសនៃការព្យាបាលផ្សេងៗគ្នា ហើយជ្រើសរើស គោលការណ៍ដែល គ្របដណ្តប់ការព្យាបាលដែលអ្នកប្រហែលជាត្រូវការ។',
        },
      },
      keyFeatures: {
        title: 'លក្ខណៈសំខាន់ៗដែលត្រូវមើល',
        item1: {
          label: 'ការរ៉ាប់រងទូលំទូលាយ',
          desc: 'ត្រូវប្រាកដថាបណ្ណសន្យាធានារ៉ាប់រងធានាលើដែនកំណត់ធំទូលាយចំពោះប្រភេទមហារីក ដំណាក់កាល និងការព្យាបាល។',
        },
        item2: {
          label: 'រចនាសម្ព័ន្ធអត្ថប្រយោជន៍',
          desc: 'ស្វែងយល់ពីរបៀបដែលគោលការណ៍បង់ចេញអត្ថប្រយោជន៍ (ផលបូក ប្រចាំខែ ឬបន្សំ)។',
        },
        item3: {
          label: 'រយៈពេលរង់ចាំ',
          desc: 'ត្រូវដឹងពីរយៈពេលរង់ចាំ មុនពេលការធានារ៉ាប់រងចាប់ផ្តើម។',
        },
        item4: {
          label: 'សមាមាត្រនៃការទូទាត់សំណង',
          desc: 'ពិនិត្យមើលកេរ្តិ៍ឈ្មោះរបស់អ្នកធានារ៉ាប់រងសម្រាប់ការទូទាត់សំណងទាន់ពេលវេលា។',
        },
        item5: {
          label: 'អត្ថប្រយោជន៍បន្ថែម',
          desc: 'រកមើលបណ្ណសន្យាណាដែលផ្តល់អត្ថប្រយោជន៍បន្ថែម ដូចជាការធានារ៉ាប់រងសម្រាប់ការរកឃើញដំណាក់កាលដំបូង ការព្យាបាលដោយប្រើគីមី ព្យាបាលដោយប្រើកាំរស្មី ការវះកាត់ និងការថែទាំក្រោយការព្យាបាល។',
        },
      },
      comparePolicies: {
        title: 'ប្រៀបធៀបបណ្ណសន្យា',
        item1: {
          label: 'ទទួលបានសម្រង់តម្លៃច្រើន',
          desc: 'ប្រៀបធៀបបណ្ណសន្យាពីក្រុមហ៊ុនធានារ៉ាប់រងផ្សេងៗគ្នា ដើម្បីស្វែងរកតម្លៃដ៏ល្អបំផុតត្រូវនឹងទឹកប្រាក់របស់អ្នក។',
        },
        item2: {
          label: 'អានលក្ខខណ្ឌ',
          desc: 'ពិនិត្យដោយប្រុងប្រយ័ត្ននូវឯកសារបណ្ណសន្យាដើម្បីយល់ពីករណីធានា ករណីមិនធានា ខនិងលក្ខខណ្ឌ។',
        },
        item3: {
          label: 'ស្វែងរកដំបូន្មានប្រកបដោយវិជ្ជាជីវៈ',
          desc: 'ពិចារណាពិគ្រោះជាមួយទីប្រឹក្សាហិរញ្ញវត្ថុ ឬភ្នាក់ងារធានារ៉ាប់រង ដើម្បីជួយអ្នកធ្វើការសម្រេចចិត្តបន្ទាប់ពីជ្រាបពត័មានសព្វគ្រប់។',
        },
      },
    },
    frequentlyAskedQuestionSection: {
      title: 'សំណួរដែលគេសួរញឹកញាប់អំពីការធានារ៉ាប់រងជំងឺមហារីក',
      q1: 'តើ​បណ្ណសន្យាធានា​រ៉ាប់រង​ជំងឺមហារីក​ធានាលើប្រភេទ​ជំងឺមហារីកណា​ខ្លះ​?',
      a1: 'មហារីកសុដន់ ក្រពះ អូវែ ក្រពេញប្រូស្តាត សួត និង hypopharynx (បំពង់កផ្នែកខាងក្រោម) ត្រូវបានធានាដោយអ្នកផ្តល់សេវាធានារ៉ាប់រងមហារីកភាគច្រើន។',
      q2: 'តើអាយុប៉ុន្មានដែលសមស្របដើម្បីទិញបណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីក?',
      a2: 'អ្នកត្រូវបានធានារ៉ាប់រងត្រូវតែមានអាយុចន្លោះពី 1 ដល់ 60 ឆ្នាំ ហើយអាចបន្តធានារ៉ាប់រងរបស់ពួកគេរហូតដល់អាយុ 70 ឬ 74 ឆ្នាំ អាស្រ័យលើក្រុមហ៊ុនធានារ៉ាប់រងជាក់លាក់។',
      q3: 'តើខ្ញុំអាចជ្រើសរើសបណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីកបន្ទាប់ពីខ្ញុំត្រូវបានគេធ្វើរោគវិនិច្ឆ័យថាមានជំងឺមហារីកបានដែរឬទេ?',
      a3: 'វាស្ទើរតែមិនអាចទៅរួចទេក្នុងការទិញបណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីកថ្មី បន្ទាប់ពីអ្នកត្រូវបានគេធ្វើរោគវិនិច្ឆ័យថាមានជំងឺមហារីក។',
      q4: 'តើការព្យាបាលដូចជាការបាញ់កាំរស្មី និងការព្យាបាលដោយប្រើគីមីត្រូវបានធានាក្រោម បណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីកដែរឬទេ?',
      a4: 'បាទ/ចាស!  វិធីសាស្ត្រនៃការព្យាបាលទាំងពីរនេះត្រូវបានធានាក្រោមបណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីក។',
      q5: 'តើខ្ញុំត្រូវការការពិនិត្យសុខភាពជាមុនដែរឬទេ?',
      a5: 'ទេ។ ការពិនិត្យសុខភាពជាមុនមិនត្រូវបានទាមទារនោះទេ។ អ្នកគ្រាន់តែឆ្លើយសំណួរវេជ្ជសាស្ត្រអំពីសុខភាពរបស់អ្នកដោយស្មោះត្រង់ និងការពិត នោះអ្នកនឹងទទួលបានការធានារ៉ាប់រង។',
    },
    disclaimer: 'ការបដិសេធ៖ ទំព័រនេះ គឺសម្រាប់តែការអប់រំផ្នែកធានារ៉ាប់រងជំងឺមហារីកប៉ុណ្ណោះ។ វាមិនឆ្លុះបញ្ចាំងពីគោលការណ៍ធានារ៉ាប់រងណាមួយឡើយ។',
  },
  cancerQuote: {
    geographicCoverage: 'ភូមិសាស្ត្រគ្របដណ្តប់',
    annualLimit: 'ដែនកំណត់ប្រចាំឆ្នាំ',
    cashlessHospitals: 'បណ្តាញមន្ទីរពេទ្យដៃគូ',
    coverAmount: 'ចំនួនទឹកប្រាក់ធានា',
    planBenefits: 'អត្ថប្រយោជន៍ពីគម្រោង',
  },
  cancerQuoteResultPage: {
    myAge: 'ខ្លួនខ្ញុំ ({{age}} ឆ្នាំ)',
    totalPlans: 'ធានារ៉ាប់រងជំងឺមហារីកមាន {{count}} គម្រោង',
  },
  cancerQuoteBuyPage: {
    title: 'ទិញបណ្ណសន្យាធានារ៉ាប់រងជំងឺមហារីក',
    subTitle: 'សូមបំពេញព័ត៌មានលម្អិតអំពីអ្នកត្រូវបានធានារ៉ាប់រងដែលអ្នកចង់បញ្ចូលក្នុងបណ្ណសន្យាតែមួយ ហើយបន្ទាប់មកឆ្លើយកម្រងសំណួរ',
    medicalQuestions: {
      error: {
        title: 'មានសមាជិកដែលមិនបានបំពេញគ្រប់លក្ខខណ្ឌ',
        description: 'សមាជិកដែលបានរាយបញ្ជីខាងក្រោមមិនត្រូវបានបំពេញតាមតម្រូវការទាំងអស់ដែលទាមទារដោយក្រុមហ៊ុនធានារ៉ាប់រងនោះទេ។\nដើម្បីបន្តទៅមុខទៀត អ្នកត្រូវតែប្រាកដថាអ្នក និងសមាជិកណាម្នាក់មិនមានបញ្ហាសុខភាពដូចបានរៀបរាប់ខាងលើ ឬអ្នកដកសមាជិកដែលមិនមានលក្ខណៈសម្បត្តិគ្រប់គ្រាន់ចេញពីសម្រង់ ដើម្បីអ្នកនឹងទទួលបានសម្រង់ដែលបានកែសម្រួល។',
      },
    },
  },
  cancerQuoteReviewPage: {
    memberDetailsTitle: 'ពត័មានលម្អិតរបស់សមាជិក',
  },
  cancerPolicyClaim: {
    termsAndConditions: 'ខ្ញុំ/យើងជាអ្នកត្រូវបានធានារ៉ាប់រង សូមអះអាងយ៉ាងមុឺងម៉ាត់ថា ខ្ញុំ/យើងគោរពតាមលក្ខខណ្ឌនៃបណ្ណសន្យារ៉ាប់រងនេះ ហើយគ្មានគោលបំណងបង្កហេតុណាមួយដើម្បីទាញយកផលប្រយោជន៍អ្វីតាមរយៈការក្លែងបន្លំ ឬការពិពណ៌មិនពិតដោយចេតនាឡើយ ហើយក៏សូមបញ្ជាក់ថាព័ត៌មានដែលបានបំពេញលើបែបបទនេះគឺជាការពិត ហើយខ្ញុំ/យើងពុំមានលាក់បាំងព័ត៌មានណាមួយដែលពាក់ព័ន្ធនឹងការទាមទារសំណងនេះឡើយ។',
  },
  user: {
    name: 'ឈ្មោះ',
    nameKm: 'ឈ្មោះជាភាសាខ្មែរ',
    occupation: 'មុខរបរ',
    personalCode: 'លេខអត្តសញ្ញាណប័ណ្ណ',
    email: 'អ៊ីមែល',
    mobileNumber: 'លេខ​ទូរ​សព្ទ​ចល័ត',
    dob: 'ថ្ងៃខែឆ្នាំកំណើត',
    age: 'អាយុ',
    yearsOld: '{{age}} ឆ្នាំ',
    gender: 'ភេទ',
    address: 'អាស័យដ្ឋាន',
    chargeFinalAmount: 'បុព្វលាភសរុប',
    noMobileNumber: 'គ្មានលេខទូរស័ព្ទ',
    weight: 'ទម្ងន់',
    height: 'កម្ពស់',
    bmi: 'សន្ទស្សន៍ម៉ាស់រាងកាយ (BMI)',
    relationshipType: 'ទំនាក់ទំនង',
  },
  loadingError: {
    title: 'មិនអាចទាញយកទិន្នន័យបានទេ',
    desc: 'យើងមិនអាចទាញយកទិន្នន័យចាំបាច់បានទេនៅពេលនេះ',
  },
  carPlanTypes: {
    thirdParty: 'គម្រោងធានារ៉ាប់រងលើតតិយជន',
    comprehensive: 'គម្រោងធានារ៉ាប់រងទូលំទូលាយ ឬស្តង់ដា',
  },
  carPlanCategories: {
    individual: 'បុគ្គល',
    corporate: 'សាជីវកម្ម',
    electricVehicle: 'យានយន្តអគ្គិសនី',
  },
  iAgreeToTermAndPolicy: 'ខ្ញុំយល់ព្រមចំពោះ <term>លក្ខខណ្ឌ</term> និង <policy>គោលការណ៍ឯកជនភាព</policy>',
  carUnknown: {
    title: 'គម្រោង Comprehensive មិនត្រូវបានរកឃើញទេ',
    description: 'បច្ចុប្បន្ននេះ យើងមិនអាចបង្ហាញ គម្រោង Comprehensive សម្រាប់រថយន្តដែលអ្នកបានជ្រើសរើសនោះទេ។ សូមទាក់ទងមកក្រុមការងារយើងខ្ញុំសម្រាប់ពត៍មានបន្ថែម។',
  },
  claimForm: {
    claimType: {
      label: 'ប្រភេទនៃការទាមទារសំណង',
    },
    completedClaimForms: {
      label: 'សូមភ្ជាប់ពាក្យស្នើរសុំទាមទារសំណងដែលបានបំពេញរួច (ទម្រង់ជា JPEG JPG PNG ឬ PDF)',
    },
    supportingDocuments: {
      label: 'សូមភ្ជាប់ឯកសារជំនួយផ្សេងៗ (ទម្រង់ជា JPEG JPG PNG ឬ PDF)',
    },
    invoice: {
      label: 'សូមភ្ជាប់វិក្កយបត្រ (ទម្រង់ជា JPEG JPG PNG ឬ PDF)',
    },
    totalClaimedAmount: {
      label: 'ទឹកប្រាក់ទាមទារសំណងសរុប (USD)',
    },
    approvedAmount: {
      label: 'ចំនួនទឹកប្រាក់ដែលបានអនុម័ត (USD)',
    },
    acceptTermsAndConditions: 'យល់ស្របនឹងលក្ខ័ណ្ឌ។ ខ្ញុំ/យើងសូមប្រកាសថាចំលើយទាំងអស់មានភាពត្រឹមត្រូវ និងពេញលេញ។ ខ្ញុំ/យើងសូមស្នើរអោយក្រុមហ៊ុនធានារ៉ាប់រង ដោះស្រាយលើការទាមទាររសប់តតិយជនក្នុងនាមខ្ញុំ/យើង ដោយគោរពទៅតាម ខនិង លក្ខណ្ឌ នៃប័ណ្ណសន្យារ៉ាប់រងខាងលើ ក៏ដូចជាច្បាប់ជាធរមាននៃព្រះរាជាណាចក្រកម្ពុជា ហើយ ខ្ញុំ/យើងសូមផ្តល់សិទ្ធិដល់ក្រុមហ៊ុន ឬមេធាវីរបស់ក្រុមហ៊ុន ក្នុងការដោះស្រាយ ករណីនេះ តាមគ្រប់រូបភាព ដែលក្រុមហ៊ុនយល់ថាចាំបាច់។',
  },
  insuranceClaimStatuses: {
    pending: 'បានស្នើរសុំ',
    inReview: 'កំពុងពិនិត្យ',
    inProgress: 'កំពុងដំណើរការ',
    approved: 'បានអនុម័ត',
    paymentProcessing: 'កំពុងទូទាត់ប្រាក់',
    closed: 'បានបញ្ចប់',
    voided: 'បានទុកជាមោឃៈ',
    settlementOffered: 'ការទូទាត់ដែលបានផ្តល់ជូន',
  },
  insuranceClaimDetails: {
    billingType: 'ប្រភេទវិក្កយបត្រ',
    status: 'ស្ថានភាព',
    claimNumber: 'លេខទាមទារសំណង',
    registerDate: 'កាលបរិច្ឆេទទាមទារសំណង',
    totalClaimedAmount: 'ទឹកប្រាក់ទាមទារសំណងសរុប (USD)',
    document: {
      title: 'ឯកសារ',
      name: 'ឈ្មោះឯកសារ',
      action: 'សកម្មភាព',
    },
  },
  healthClaimDetails: {
    dateOfAdmission: 'កាលបរិច្ឆទចូលមន្ទីរពេទ្យ',
    companyName: 'ឈ្មោះក្រុមហ៊ុន',
    memberName: 'ឈ្មោះសមាជិក',
  },
  userStepForm: {
    title: 'យើងចង់គាំទ្រអ្នក។',
    support: 'អនុញ្ញាតឱ្យពួកយើងដឹងពីអ្នក ដូច្នេះជួរមុខរបស់យើងអាចគាំទ្រអ្នកនៅតាមផ្លូវ។',
    authorized: 'ខ្ញុំអនុញ្ញាតឱ្យ MGA Cover ប្រើលេខទូរស័ព្ទដែលបានផ្តល់ ដើម្បីពិភាក្សាអំពីតម្រូវការធានារ៉ាប់រងរបស់ខ្ញុំ។',
  },
  quoteSupportCard: {
    text: 'មិនអាចរកឃើញអ្វីដែលអ្នកកំពុងស្វែងរកមែនទេ? បង្កើតមួយភ្លាមៗ។ ជួរមុខរបស់យើងនឹងគាំទ្រអ្នកជាមួយនឹងការប្ដូរតាមបំណងទៅនឹងតម្រូវការរបស់អ្នក។',
  },
  company: {
    name: 'ឈ្មោះក្រុមហ៊ុន',
  },
  insurance: {
    type: 'ប្រភេទធានារ៉ាប់រង',
    quoteRequest: 'សូមអរគុណចំពោះការសាកសួររបស់អ្នក។ យើងបានទទួលសំណើរបស់អ្នកសម្រាប់ការស្នើសុំ Quote ហើយអ្នកប្រឹក្សារបស់យើងនឹងទាក់ទងក្នុងពេលឆាប់ៗនេះ ដើម្បីផ្តល់ឱ្យអ្នកនូវដំណោះស្រាយធានារ៉ាប់រងដែលសមស្រប។',
  },
  corporateInsurance: {
    benefits: 'តើលោកអ្នកកំពុងស្វែងរកការការពារផ្នែកហិរញ្ញវត្ថុដែលល្អបំផុតសម្រាប់អាជីវកម្មរបស់លោកអ្នកមែនឬទេ? ជួបជាមួយក្រុមការងារជំនាញ ពោរពេញដោយបទពិសោធន៏ និងមានវិជ្ជាជីវៈរបស់យើង ដោយគ្រាន់តែផ្តល់នូវព័ត៌មានរបស់លោកអ្នក និងតម្រូវការការពារផ្នែកហិរញ្ញវត្ថុដែលកំពុងស្វែងរក នោះក្រុមការងាររបស់យើង នឹងស្វែងរកជូនលោកអ្នកនូវគម្រោងការការពារផ្នែកហិរញ្ញវត្ថុដែលសាកសមបំផុតសម្រាប់អាជីវកម្មរបស់លោកអ្នក។ \n',
    howto: 'លោកអ្នកអាចធ្វើការស្នើសុំការប្រឹក្សាយោបល់ដោយឥតគិតថ្លៃ ពីក្រុមការងាររបស់យើងអំពីគម្រោងសម្រាប់ការការពារហិរញ្ញវត្ថុរបស់អាជីវកម្មលោកអ្នក ដោយគ្រាន់តែធ្វើការបំពេញនៅព័ត៌មានរួចធ្វើការផ្ញើមកកាន់ក្រុមការងាររបស់យើង ជាការស្រេច។',
  },
  alert: {
    premiumChange: {
      title: 'ការជូនដំណឹងអំពីការផ្លាស់ប្តូរបុព្វលាភ!',
      effectiveDate: 'កាលបរិច្ឆេទមានប្រសិទ្ធភាពនៃបណ្ណសន្យាធានារ៉ាប់រងរបស់អ្នកបានកន្លងផុតទៅហើយ។ អាយុរបស់អ្នកអាចប្រែប្រួល ដែលបណ្តាលឱ្យបុព្វលាភផ្លាស់ប្តូរ។ គួរអោយសោកស្តាយ អ្នកនឹងមិនអាចទូទាត់ប្រាក់លើការបញ្ជាទិញនេះភ្លាមៗបានទេ។ សូមទាក់ទងសេវាបំរើអតិថិជនរបស់យើងសម្រាប់ជំនួយ។',
    },
  },
  form: {
    inputs: {
      date: {
        help: 'សូមជ្រើសរើស ឬវាយបញ្ចូលកាលបរិច្ឆេទ',
      },
    },
  },
  orderTypes: {
    individual: 'បុគ្គល',
    orderGroup: 'ក្រុម',
    member: 'សមាជិក',
    corporate: 'សាជីវកម្ម',
  },
  order: {
    search: 'លេខបញ្ជាទិញ ឬ លេខប័ណ្ណធានា',
  },
  otp: {
    updatePasswordFor: 'ធ្វើបច្ចុប្បន្នភាពពាក្យសម្ងាត់ OTP សម្រាប់ <strong>{{mobileNumber}}</strong>',
    generateLink: 'បង្កើតតំណ OTP',
  },
  proof: 'ភស្តុតាង (វិញ្ញាបនបត្រធានារ៉ាប់រង)',
  importStatuses: {
    done: 'រួចរាល់',
    progressing: 'កំពុងដំណើរការ',
  },
  importTypes: {
    addUsers: 'បន្ថែមអ្នកប្រើប្រាស់',
    deactivateUsers: 'ធ្វើឱ្យអសកម្មអ្នកប្រើប្រាស់',
  },
  paymentInfo: {
    title: 'ព័ត៌មានការទូទាត់',
    paymentMethod: 'មធ្យោបាយទូទាត់',
    bankName: 'ឈ្មោះធនាគារ',
    beneficiaryName: 'ឈ្មោះអ្នកទទួលផល',
    bankAccount: 'គណនីធនាគារ',
    cheque: 'មូលប្បទានប័ត្រ',
    bankTransfer: 'ការផ្ទេរប្រាក់តាមធនាគារ',
  },
  claim: {
    startDate: 'កាលបរិច្ឆេទចាប់ផ្តើម',
    endDate: 'កាលបរិច្ឆេទបញ្ចប់',
  },
  insuranceClaim: {
    search: 'លេខករណីទាមទារ, លេខប័ណ្ណធានារ៉ាប់រង ឬឈ្មោះសមាជិក',
  },
  hospitalNetworkPage: {
    heading: 'បណ្តាញមន្ទីរពេទ្យ',
    subHeading: 'ការចេញវិក្កយបត្រដោយផ្ទាល់នៅក្នុងបណ្តាញរបស់យើង។',
    description: 'MGA Cover បានជ្រើសរើសមន្ទីរពេទ្យ និងគ្លីនិកដែលមានគុណភាពក្នុងប្រទេសកម្ពុជា ដែលអ្នកអាចទទួលការព្យាបាលតាមមូលដ្ឋានវិក្កយបត្រដោយផ្ទាល់។',
    searchPlaceholder: 'ស្វែងរកមន្ទីរពេទ្យតាមឈ្មោះ...',
    allLocations: 'ស្វែងរកតាមទីតាំង',
    noHospitalsFound: 'រកមិនឃើញមន្ទីរពេទ្យទេ។',
    address: 'អាស័យដ្ឋាន',
    province: 'ខេត្ត',
    viewOnMap: 'មើលនៅលើផែនទី',
    mapNotAvailable: 'ផែនទីមិនមានទេ។',
    showingResults: 'បង្ហាញ {{from}} ទៅ {{to}} នៃ {{total}} មន្ទីរពេទ្យ',
    allHealthPlans: 'ច្រោះតាមគម្រោងសុខភាព',
  },
  garageNetworkPage: {
    heading: 'បណ្តាញហាងជួសជុលរថយន្ត',
    subHeading: 'ហាងជួសជុលដែលមានគុណភាពនៅក្នុងបណ្តាញរបស់យើង។',
    description: 'MGA Cover បានចុះកិច្ចសហការជាមួយហាងជួសជុលដែលមានគុណភាពនៅទូទាំងប្រទេសកម្ពុជា សម្រាប់តម្រូវការជួសជុលធានារ៉ាប់រងរថយន្តរបស់អ្នក។',
    searchPlaceholder: 'ស្វែងរកហាងជួសជុលតាមឈ្មោះ',
    allLocations: 'ស្វែងរកតាមទីតាំង',
    noGaragesFound: 'រកមិនឃើញហាងជួសជុលទេ។',
    address: 'អាស័យដ្ឋាន',
    province: 'ខេត្ត',
    viewOnMap: 'មើលនៅលើផែនទី',
    mapNotAvailable: 'ផែនទីមិនមានទេ។',
    showingResults: 'បង្ហាញ {{from}} ទៅ {{to}} នៃ {{total}} ហាងជួសជុល',
    allInsurers: 'ច្រោះតាមក្រុមហ៊ុនធានារ៉ាប់រង',
  },
  ingestionStatuses: {
    done: 'រួចរាល់',
    progressing: 'កំពុងដំណើរការ',
  },
  ingestionTypes: {
    insurancePolicyUserAdd: 'បន្ថែមអ្នកប្រើប្រាស់',
  },
  digitalCard: {
    title: 'កាតឌីជីថល',
    insurancePlatform: 'វេទិកាធានារ៉ាប់រង',
    policyInformation: 'ព័ត៌មានគោលនយោបាយ',
    validityText: 'កាតនេះមានសុពលភាពសម្រាប់រយៈពេលដែលបានបញ្ជាក់ខាងលើ',
    annualLimit: 'ដែនកំណត់ប្រចាំឆ្នាំ',
    geographicCoverage: 'ការគ្របដណ្តប់ភូមិសាស្ត្រ',
    forReimbursement: 'សម្រាប់ការទាមទារសំណង',
    forDirectBilling: 'សម្រាប់ការទាមទារសំណងទូទាត់ដោយផ្ទាល់',
  },
  claimEditModal: {
    title: 'ការកែសម្រួលការទាមទារសម្រាប់ {{claimNumber}}',
    note: {
      placeholder: 'បញ្ចូលកំណត់ចំណាំអំពីការធ្វើបច្ចុប្បន្នភាពការទាមទារនេះ...',
    },
  },
  requestDocumentsModal: {
    title: 'ស្នើសុំឯកសារ - {{claimNumber}}',
    helperText: 'ជ្រើសរើសឯកសារដែលអ្នកត្រូវការឱ្យអតិថិជនផ្តល់ជូន។',
    documentTypes: 'ជ្រើសរើសប្រភេទឯកសារ',
    note: 'កំណត់ចំណាំ (ជម្រើស)',
    notePlaceholder: 'បញ្ចូលការណែនាំបន្ថែម ឬកំណត់ចំណាំសម្រាប់អតិថិជន...',
    submit: 'ស្នើសុំឯកសារ',
    validation: {
      atLeastOneDocument: 'សូមជ្រើសរើសប្រភេទឯកសារយ៉ាងហោចណាស់មួយ',
    },
  },
  documentTypes: {
    claimFormCompletedSigned: 'ទម្រង់បែបបទទាមទារសំណង (បំពេញ និងចុះហត្ថលេខា)',
    medicalCertificate: 'វិញ្ញាបនបត្រវេជ្ជសាស្ត្រ',
    prescriptionWithDiagnosis: 'វេជ្ជបញ្ជាជាមួយរោគវិនិច្ឆ័យ',
    laboratoryTestResults: 'លទ្ធផលតេស្តមន្ទីរពិសោធន៍',
    imagingResults: 'លទ្ធផលរូបភាព (X-ray, MRI, CT Scan)',
    medicalCertificateDischargeSummary: 'វិញ្ញាបនបត្រវេជ្ជសាស្ត្រ / សង្ខេបការចេញពីមន្ទីរពេទ្យ',
    hospitalDischargeSummary: 'សង្ខេបការចេញពីមន្ទីរពេទ្យ',
    detailedInvoiceReceiptStampedPaid: 'វិក្កយបត្រលម្អិត / បង្កាន់ដៃ (បោះត្រា និងបានបង់)',
    doctorAppointmentProof: 'ភស្តុតាងណាត់ជួបជាមួយវេជ្ជបណ្ឌិត',
    medicationPrescription: 'វេជ្ជបញ្ជាថ្នាំ',
    eyeExaminationAutoRefractorResult: 'ការពិនិត្យភ្នែក / លទ្ធផល Auto Refractor',
    dentalXrayPanorexFilm: 'ថតកាំរស្មីធ្មេញ / Panorex Film',
    healthCheckupReport: 'របាយការណ៍ពិនិត្យសុខភាព',
    vaccinationRecordCertificate: 'កំណត់ត្រាចាក់វ៉ាក់សាំង / វិញ្ញាបនបត្រ',
    biologyTestResults: 'លទ្ធផលតេស្តជីវវិទ្យា',
    doctorsDiagnosisReport: 'របាយការណ៍រោគវិនិច្ឆ័យរបស់វេជ្ជបណ្ឌិត',
    authorizationLetterClaimPayment: 'លិខិតផ្ទេរសិទ្ធិសម្រាប់ការទូទាត់សំណង',
    payeeIdentificationDocument: 'ឯកសារបញ្ជាក់អត្តសញ្ញាណអ្នកទទួលប្រាក់',
    nationalIdCardOrPassport: 'អត្តសញ្ញាណប័ណ្ណ ឬលិខិតឆ្លងដែន',
    policyInsurer: 'ក្រុមហ៊ុនធានារ៉ាប់រង',
    policyCustomer: 'អតិថិជន',
  },
  actionRequestStatuses: {
    open: 'កំពុងបើកដំណើរការ',
    resolved: 'បានដោះស្រាយរួច',
  },
  healthClaimCostItem: {
    statuses: {
      pending: 'ដែលមិនទាន់បានសម្រេច',
      approved: 'បានអនុម័ត',
    },
  },
  insurancePolicy: {
    search: 'លេខប័ណ្ណធានា',
  },
};
